import React from "react";

export const VoucherIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="35"
    viewBox="0 0 50 35"
    fill="none"
  >
    <path
      d="M12.5 0H45C47.7344 0 50 2.26562 50 5V8.75C50 9.45312 49.375 10 48.75 10.2344C47.2656 10.7812 46.25 12.1094 46.25 13.75C46.25 15.3906 47.2656 16.7969 48.75 17.3438C49.375 17.5781 50 18.125 50 18.75V22.5C50 25.3125 47.7344 27.5 45 27.5H12.5C9.6875 27.5 7.5 25.3125 7.5 22.5V5C7.5 2.26562 9.6875 0 12.5 0ZM41.25 5C40.5469 5 40 5.625 40 6.25C40 6.95312 40.5469 7.5 41.25 7.5C41.875 7.5 42.5 6.95312 42.5 6.25C42.5 5.625 41.875 5 41.25 5ZM41.25 10C40.5469 10 40 10.625 40 11.25C40 11.9531 40.5469 12.5 41.25 12.5C41.875 12.5 42.5 11.9531 42.5 11.25C42.5 10.625 41.875 10 41.25 10ZM40 16.25C40 16.9531 40.5469 17.5 41.25 17.5C41.875 17.5 42.5 16.9531 42.5 16.25C42.5 15.625 41.875 15 41.25 15C40.5469 15 40 15.625 40 16.25ZM41.25 20C40.5469 20 40 20.625 40 21.25C40 21.9531 40.5469 22.5 41.25 22.5C41.875 22.5 42.5 21.9531 42.5 21.25C42.5 20.625 41.875 20 41.25 20ZM3.75 6.875V25.625C3.75 28.75 6.25 31.25 9.375 31.25H40.625C41.6406 31.25 42.5 32.1094 42.5 33.125C42.5 34.2188 41.6406 35 40.625 35H9.375C4.14062 35 0 30.8594 0 25.625V6.875C0 5.85938 0.78125 5 1.875 5C2.89062 5 3.75 5.85938 3.75 6.875Z"
      fill="#BFC8D9"
    />
  </svg>
);

export const ProductsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.8618 3.7193V10.697H42.9221V3.7193H40.1845C39.6753 3.7193 39.2624 3.30645 39.2624 2.79715C39.2624 2.28797 39.6752 1.875 40.1845 1.875H50.5994C50.943 1.875 51.2426 2.06285 51.4012 2.34152L54.1315 6.46758C54.4119 6.89133 54.2959 7.46227 53.8721 7.7427C53.4484 8.02324 52.8774 7.90711 52.597 7.48336L50.1063 3.7193H47.8618ZM5.76983 47.5868C5.24178 47.5062 4.82869 47.0696 4.79143 46.5209L2.53147 13.1803C2.46315 12.171 3.2524 11.3263 4.26397 11.3263H18.7577C19.7679 11.3263 20.5568 12.1686 20.4904 13.1767L18.301 46.5184C18.2649 47.0682 17.8514 47.5061 17.3225 47.5868C13.4717 47.5868 9.62084 47.5868 5.76983 47.5868ZM6.14096 15.7216H16.8806C17.3899 15.7216 17.8028 15.3088 17.8028 14.7995C17.8028 14.2902 17.3899 13.8773 16.8806 13.8773H6.14096C5.63166 13.8773 5.21881 14.2902 5.21881 14.7995C5.21893 15.3088 5.63178 15.7216 6.14096 15.7216ZM11.5108 20.1649C9.63069 20.1649 8.10654 24.328 8.10654 29.4633C8.10654 34.5987 9.63069 38.7616 11.5108 38.7616C13.391 38.7616 14.9151 34.5986 14.9151 29.4633C14.9151 24.328 13.391 20.1649 11.5108 20.1649ZM23.7472 31.8912H32.7933C33.705 31.8912 34.4511 32.6372 34.4511 33.549V35.7098C34.4511 36.6217 33.7051 37.3677 32.7933 37.3677H23.7472C22.8354 37.3677 22.0894 36.6217 22.0894 35.7098V33.549C22.0894 32.6372 22.8354 31.8912 23.7472 31.8912ZM28.2119 22.5475C29.6147 22.5475 30.7597 23.5398 30.7597 24.9786V30.0469H25.7806V24.9786C25.7806 23.6396 26.8728 22.5475 28.2119 22.5475ZM33.3385 39.169C34.6542 40.1228 35.6078 41.1671 35.6078 43.1598V55.1943C35.6078 56.8062 34.2889 58.125 32.6771 58.125H23.8633C22.2514 58.125 20.9327 56.8062 20.9327 55.1943V43.1598C20.9327 41.1671 21.8863 40.1228 23.2019 39.169C23.3797 39.1971 23.5618 39.2119 23.7472 39.2119H32.7931C32.9785 39.2119 33.1608 39.1971 33.3385 39.169ZM35.6279 22.7644C34.4898 22.7644 33.539 23.5513 33.3477 24.5815H53.3819C53.9079 24.5815 54.3343 24.9943 54.3343 25.5036C54.3343 26.0129 53.9079 26.4258 53.3819 26.4258H33.3125V30.0859C34.9946 30.3388 36.2952 31.7993 36.2952 33.5491V35.71C36.2952 36.7173 35.864 37.6288 35.1772 38.2692C36.684 39.5666 37.4519 41.104 37.4519 43.1599V50.0513H57.4714V24.9635C57.4714 23.7523 56.4313 22.7644 55.156 22.7644H35.6279ZM57.4714 51.8953V52.7619C57.4714 53.4886 56.8474 54.0814 56.0822 54.0814H37.4521V51.8953H57.4714ZM45.814 32.0832C46.2697 32.7831 46.841 33.8511 47.3985 34.9153C48.2113 36.467 49.5287 38.5875 49.4338 40.402C49.2997 42.962 47.382 44.9104 45.1507 44.7537C42.9192 44.5971 41.2189 42.3948 41.3529 39.8347C41.4458 38.0598 42.809 36.3625 43.7413 34.9881C44.4684 33.9159 45.2347 32.779 45.814 32.0832ZM37.681 17.8614H53.1029C53.4204 17.8614 53.6792 18.1202 53.6792 18.4377V20.9201H37.1047V18.4377C37.1047 18.1202 37.3636 17.8614 37.681 17.8614ZM39.6108 12.5413H51.1733C51.5542 12.5413 51.8648 12.852 51.8648 13.2329V16.0173H38.9191V13.2329C38.9191 12.852 39.2298 12.5413 39.6108 12.5413ZM15.9875 49.4311V51.1C15.9875 51.4665 15.6876 51.7664 15.3212 51.7664H7.70049C7.33393 51.7664 7.03404 51.4665 7.03404 51.1V49.4311H15.9875Z"
      fill="#BFC8D9"
    />
  </svg>
);

export const ServicesIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
  >
    <path
      d="M47.1519 32.0708C51.0624 34.0264 54.8853 35.9373 54.8853 35.9373C59.0429 29.7173 58.7631 22.11 55.2179 16.3164C54.0579 19.1141 51.9169 21.4199 49.1174 22.82L38.8672 27.9286C38.8672 27.9286 43.0578 30.0236 47.1519 32.0708Z"
      fill="#BFC8D9"
    />
    <path
      d="M47.6363 19.8854C54.7884 16.3254 54.7884 6.10815 47.6363 2.54892C46.0872 1.7579 44.2744 1.62572 42.5935 2.18603L29.7062 6.89917C22.7192 9.47031 18.105 15.5015 16.9844 22.2251C18.105 23.115 18.8297 24.4993 18.8297 26.0484V34.2881L47.6363 19.8854Z"
      fill="#BFC8D9"
    />
    <path
      d="M15.5361 26.7857C15.5361 25.8625 14.811 25.1377 13.8882 25.1377H12.2402V16.898C12.2402 15.9871 11.5031 15.25 10.5923 15.25C9.68111 15.25 8.94434 15.9871 8.94434 16.898V25.1377H7.29639C6.37319 25.1377 5.64844 25.8625 5.64844 26.7857V38.3213H15.5361V26.7857Z"
      fill="#BFC8D9"
    />
    <path
      d="M17.5125 44.9131H15.5357V41.6172H5.64795V44.9131H3.71436C2.80352 44.9131 2.06641 45.6502 2.06641 46.561C2.06641 47.4722 2.80352 48.209 3.71436 48.209H8.94385V54.8008H7.2959C6.38472 54.8008 5.64795 55.5379 5.64795 56.4487C5.64795 57.3599 6.38472 58.0967 7.2959 58.0967H13.8877C14.7985 58.0967 15.5357 57.3599 15.5357 56.4487C15.5357 55.5379 14.7985 54.8008 13.8877 54.8008H12.2398V48.209H17.5118C18.423 48.209 19.1598 47.4722 19.1598 46.561C19.1598 45.6502 18.423 44.9131 17.5125 44.9131Z"
      fill="#BFC8D9"
    />
    <path
      d="M35.2111 29.7852L19.1172 37.8326C20.6158 47.411 27.8887 58.0966 36.9576 58.0966C45.5702 58.0966 52.4947 48.5117 54.4939 39.427L35.2111 29.7852ZM25.9043 40.4C25.261 39.7563 25.261 38.7133 25.9043 38.0695C26.5481 37.4258 27.5911 37.4258 28.2345 38.0695C29.4097 39.2444 31.3213 39.2444 32.4961 38.0695C33.1399 37.4258 34.1829 37.4258 34.8263 38.0695C35.47 38.7133 35.47 39.7563 34.8263 40.4C33.5972 41.6295 31.9815 42.2443 30.3658 42.2443C28.7498 42.2443 27.1338 41.6295 25.9043 40.4ZM41.4181 50.2877C40.189 51.5172 38.5733 52.1321 36.9576 52.1321C35.3416 52.1321 33.7259 51.5172 32.4965 50.2877C31.8528 49.644 31.8528 48.601 32.4965 47.9572C33.1402 47.3135 34.1829 47.3135 34.8266 47.9572C36.0015 49.1321 37.9131 49.1321 39.0883 47.9572C39.732 47.3135 40.7747 47.3135 41.4184 47.9572C42.0622 48.601 42.0618 49.644 41.4181 50.2877ZM43.5494 42.2443C41.9334 42.2443 40.3177 41.6295 39.0883 40.4C38.4446 39.7563 38.4446 38.7133 39.0883 38.0695C39.732 37.4258 40.7747 37.4258 41.4184 38.0695C42.5933 39.2447 44.5049 39.2447 45.6801 38.0695C46.3238 37.4258 47.3665 37.4258 48.0102 38.0695C48.654 38.7133 48.654 39.7563 48.0102 40.4C46.7808 41.6295 45.1651 42.2443 43.5494 42.2443Z"
      fill="#BFC8D9"
    />
  </svg>
);

export const PresentIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
  >
    <path
      d="M31.5853 1.26789C30.6619 0.458368 29.3378 0.458258 28.4144 1.26775C26.3404 3.08589 22.9688 6.65872 22.9688 10.6641C22.9688 16.393 29.7143 20.6806 29.9981 20.8589C29.9983 20.859 29.9983 20.8591 29.9985 20.8592C29.9994 20.8601 30.0001 20.8607 30.0012 20.86C30.3519 20.6397 37.0312 16.3652 37.0312 10.6641C37.0312 6.65914 33.6594 3.08629 31.5853 1.26789Z"
      fill="#BFC8D9"
    />
    <path
      d="M6.51563 35.3906C4.85877 35.3906 3.51562 36.7338 3.51562 38.3906V57C3.51562 58.6569 4.85877 60 6.51562 60H7.66406C9.32092 60 10.6641 58.6569 10.6641 57V45.4219C10.6641 43.765 12.0072 42.4219 13.6641 42.4219H21.7266C23.3834 42.4219 24.7266 43.765 24.7266 45.4219V58.2422C24.7266 59.213 25.5136 60 26.4844 60C27.4552 60 28.2422 59.213 28.2422 58.2422V45.4219C28.2422 43.765 29.5853 42.4219 31.2422 42.4219H53.3672C55.024 42.4219 56.3672 41.0787 56.3672 39.4219V38.3906C56.3672 36.7338 55.024 35.3906 53.3672 35.3906H6.51563Z"
      fill="#BFC8D9"
    />
    <path
      d="M46.6087 45.9375C45.6057 45.9375 44.669 46.4388 44.1126 47.2734L39.4688 54.2391C38.9303 55.0468 37.839 55.265 37.0312 54.7266C36.2235 54.1881 36.0053 53.0968 36.5437 52.2891L37.6687 50.6016C38.9978 48.6079 37.5686 45.9375 35.1725 45.9375H34.7578C33.101 45.9375 31.7578 47.2806 31.7578 48.9375V57C31.7578 58.6569 33.101 60 34.7578 60H38.0007C39.0037 60 39.9404 59.4987 40.4968 58.6641L45.1406 51.6984C45.6791 50.8907 46.7704 50.6725 47.5781 51.2109C48.3858 51.7494 48.6041 52.8407 48.0657 53.6484L46.9407 55.3359C45.6116 57.3296 47.0408 60 49.4369 60H53.3672C55.024 60 56.3672 58.6569 56.3672 57V48.9375C56.3672 47.2806 55.024 45.9375 53.3672 45.9375H46.6087Z"
      fill="#BFC8D9"
    />
    <path
      d="M21.2109 48.9375C21.2109 47.2806 19.8678 45.9375 18.2109 45.9375H17.1797C15.5228 45.9375 14.1797 47.2806 14.1797 48.9375V57C14.1797 58.6569 15.5228 60 17.1797 60H18.2109C19.8678 60 21.2109 58.6569 21.2109 57V48.9375Z"
      fill="#BFC8D9"
    />
    <path
      d="M44.0629 7.14844C43.6111 7.14844 43.1668 7.17894 42.7312 7.23688C41.2354 7.43581 40.5237 9.00573 40.5462 10.5145C40.5469 10.5642 40.5473 10.6141 40.5473 10.6641C40.5473 14.456 38.5648 17.6218 36.4856 19.9074C36.0436 20.3933 36.3749 21.2109 37.0317 21.2109C42.8566 21.2109 47.5786 16.489 47.5786 10.6641V10.1484C47.5786 8.49158 46.2354 7.14844 44.5786 7.14844H44.0629Z"
      fill="#BFC8D9"
    />
    <path
      d="M19.4531 10.6641C19.4531 10.6118 19.4535 10.5597 19.4543 10.5077C19.4769 9.00143 18.7607 7.43548 17.2674 7.2368C16.8324 7.17893 16.3888 7.14844 15.9375 7.14844H15.4219C13.765 7.14844 12.4219 8.49158 12.4219 10.1484V10.6641C12.4219 16.489 17.1438 21.2109 22.9688 21.2109C23.6282 21.2109 23.961 20.3902 23.5174 19.9022C21.4376 17.6139 19.4531 14.4468 19.4531 10.6641Z"
      fill="#BFC8D9"
    />
    <path
      d="M50.8607 17.6953C49.7936 17.6953 48.8261 18.2775 48.1824 19.1286C45.6211 22.5154 41.5963 24.7266 37.0312 24.7266H22.9688C18.4037 24.7266 14.3789 22.5154 11.8176 19.1286C11.1739 18.2775 10.2064 17.6953 9.1393 17.6953H3C1.34315 17.6953 0 19.0385 0 20.6953V28.875C0 30.5319 1.34315 31.875 3 31.875H57C58.6569 31.875 60 30.5319 60 28.875V20.6953C60 19.0385 58.6569 17.6953 57 17.6953H50.8607Z"
      fill="#BFC8D9"
    />
  </svg>
);

export const HexagonSVG = ({ number, textFill = "#4C9DAD" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="77"
    height="80"
    viewBox="0 0 77 80"
    fill="none"
  >
    <g filter="url(#filter0_dii_4426_20734)">
      <path
        d="M30.9376 9.81762C32.8255 8.69712 35.1745 8.69713 37.0624 9.81762L46.47 15.4013L56.0094 20.7567C57.9237 21.8314 59.0983 23.8657 59.0718 26.0609L58.94 37L59.0718 47.9391C59.0983 50.1343 57.9237 52.1686 56.0094 53.2433L46.47 58.5987L37.0624 64.1824C35.1745 65.3029 32.8255 65.3029 30.9376 64.1824L21.53 58.5987L11.9906 53.2433C10.0763 52.1686 8.90172 50.1343 8.92818 47.9391L9.06 37L8.92818 26.0609C8.90172 23.8657 10.0763 21.8314 11.9906 20.7567L21.53 15.4013L30.9376 9.81762Z"
        fill="url(#paint0_linear_4426_20734)"
      />
    </g>
    <text
      x="45%"
      y="50%"
      textAnchor="middle"
      dominantBaseline="middle"
      fontSize="28"
      fontWeight="bold"
      fill={textFill}
    >
      {number}
    </text>
    <defs>
      <filter
        id="filter0_dii_4426_20734"
        x="0.662719"
        y="0.71057"
        width="92.394"
        height="98.2983"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="12.8597" dy="12.8597" />
        <feGaussianBlur stdDeviation="10.5633" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.839216 0 0 0 0 0.905882 0 0 0 0 0.909804 0 0 0 0.38 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4426_20734"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4426_20734"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-3.67421" dy="-3.67421" />
        <feGaussianBlur stdDeviation="8.72624" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.400213 0 0 0 0 0.631606 0 0 0 0 0.677885 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_4426_20734"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="9.18552" dy="9.18552" />
        <feGaussianBlur stdDeviation="5.97059" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.77 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_4426_20734"
          result="effect3_innerShadow_4426_20734"
        />
      </filter>
      <linearGradient
        id="paint0_linear_4426_20734"
        x1="63"
        y1="37"
        x2="5"
        y2="37"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#EDF0F6" />
      </linearGradient>
    </defs>
  </svg>
);

export const ReplySVG = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
    <path
      d="M537.016,909.264c-7.034,0-14.006-2.372-19.671-6.97L18.508,496.986C11.232,491.055,7,482.161,7,472.781
			c0-9.374,4.232-18.267,11.508-24.204L517.345,43.272c9.318-7.551,22.258-9.104,33.064-3.959
			c10.871,5.175,17.785,16.135,17.785,28.162v219.277c243.388,16.107,436.483,219.246,436.483,466.625v62.353
			c0,12.18-7.097,23.235-18.147,28.314c-11.054,5.119-24.054,3.292-33.311-4.626l-52.55-45.027
			c-93.318-79.986-210.359-126.841-332.476-133.66v217.36c0,12.022-6.914,22.986-17.785,28.158
			C546.146,908.262,541.58,909.268,537.016,909.264L537.016,909.264z M125.715,472.781L506.65,782.309V614.776
			c0-15.697,12.702-28.401,28.399-28.401c134.946,0,265.707,48.367,368.18,136.193l0.972,0.834
			c-2.664-201.286-167.231-364.213-369.148-364.213c-15.699,0-28.4-12.704-28.4-28.399V163.258
			C506.65,163.258,125.715,472.781,125.715,472.781L125.715,472.781z"
    />
  </svg>
);

export const GoogleSVG = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
    <g>
      <path
        fill="#59C36A"
        d="M827.301,875.968c-84.521,71.388-194.169,116.693-313.528,116.693c-177.609,0-333.52-97.848-418.041-240.62
				l31.646-145.858l140.255-26.039c32.553,105.078,130.779,182.178,246.141,182.178c55.964,0,107.937-17.703,150.767-49.112
				l134.777,20.558L827.301,875.968z"
      />
      <path
        fill="#00A66C"
        d="M827.301,875.968l-27.984-142.201l-134.777-20.558c-42.83,31.409-94.803,49.112-150.767,49.112v230.34
				C633.132,992.661,742.779,947.355,827.301,875.968z"
      />
      <g id="Connected_Home_1_">
        <g>
          <g>
            <g>
              <path
                fill="#FFDA2D"
                d="M256.781,505.331c0,26.267,3.998,51.396,10.851,74.813l-171.9,171.897
								c-42.83-71.957-69.29-156.48-69.29-246.71c0-90.233,26.46-174.754,69.29-246.711l137.965,23.743l33.936,148.154
								C260.779,453.932,256.781,479.06,256.781,505.331L256.781,505.331z"
              />
            </g>
          </g>
        </g>
      </g>
      <path
        fill="#4086F4"
        d="M1001.103,505.331c0,148.48-68.719,281.547-173.802,370.637L664.539,713.209
				c33.121-23.988,61.107-55.971,79.384-93.66h-230.15c-15.993,0-28.556-12.567-28.556-28.554V419.666
				c0-15.99,12.563-28.554,28.556-28.554h450.78c13.707,0,25.698,9.708,27.983,23.412
				C998.247,444.225,1001.103,475.063,1001.103,505.331L1001.103,505.331z"
      />
      <path
        fill="#4175DF"
        d="M743.924,619.549c-18.275,37.689-46.264,69.672-79.382,93.66l162.759,162.759
				c105.083-89.09,173.802-222.153,173.802-370.637c0-30.269-2.855-61.106-8.567-90.807c-2.284-13.704-14.278-23.412-27.984-23.412
				H513.772v228.437H743.924z"
      />
      <path
        fill="#FF641A"
        d="M835.297,154.107c0.571,7.996-2.855,15.422-7.996,21.131L705.086,296.881
				c-9.704,10.278-25.694,11.421-37.118,2.855c-45.119-33.693-98.231-51.396-154.195-51.396
				c-115.361,0-213.588,77.095-246.141,182.178L95.731,258.62C180.253,115.848,336.163,18,513.772,18
				c113.647,0,224.439,41.88,311.244,114.978C831.298,138.119,834.723,146.112,835.297,154.107L835.297,154.107z"
      />
      <path
        fill="#F03800"
        d="M667.966,299.736c11.422,8.567,27.411,7.423,37.119-2.855l122.214-121.643
				c5.143-5.709,8.569-13.133,7.996-21.131c-0.575-7.997-3.999-15.988-10.279-21.13C738.212,59.88,627.42,18,513.772,18v230.34
				C569.736,248.34,622.849,266.043,667.966,299.736z"
      />
    </g>
  </svg>
);

export const FacebookSVG = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
    <g>
      <path
        fill="#4A7AFF"
        d="M1015.363,506.525c0,279.749-226.775,506.524-506.525,506.524c-279.749,0-506.524-226.775-506.524-506.524
	C2.313,226.775,229.089,0,508.838,0C788.588,0,1015.363,226.775,1015.363,506.525z"
      />
      <path
        fill="#FFFFFF"
        d="M663.688,149.015v114.697c0,0-131.686-19.113-131.686,65.843v84.957h118.941L636.08,544.072H532.002v337.709
	H400.316V544.072l-112.572-2.126V414.512H398.19V316.81c0,0-7.288-145.343,135.938-172.038
	C593.602,133.68,663.688,149.015,663.688,149.015z"
      />
      <path
        fill="#DCE1EB"
        d="M663.688,263.712V149.015c0,0-70.086-15.335-129.56-4.243c-9.291,1.73-17.932,3.973-25.993,6.623v730.387
	h23.867V544.072h104.07l14.871-129.561H532.002c0,0,0,0,0-84.957C532.002,244.599,663.688,263.712,663.688,263.712z"
      />
    </g>
  </svg>
);

export const TwitterSVG = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
    <path
      fill="#03A9F4"
      d="M1006.701,163.276c-6.71-7.344-17.513-9.249-26.334-4.649c-9.059,4.107-18.431,7.508-28.042,10.136
      c14.983-19.171,26.285-40.938,33.356-64.208c3.113-11.713-3.859-23.729-15.573-26.834c-6.251-1.668-12.92-0.484-18.218,3.219
      c-33.365,18.063-68.824,31.936-105.59,41.3c-75.666-71.428-190.939-80.332-276.685-21.372
      c-66.047,44.667-102.419,121.845-94.796,201.207c-143.168-12.197-274.902-83.141-363.884-195.983
      c-4.574-5.527-11.491-8.575-18.653-8.206c-7.262,0.436-13.833,4.443-17.545,10.703c-30.202,49.365-38.951,108.916-24.231,164.878
      c7.548,28.757,20.485,55.813,38.136,79.74c-7.942-3.894-15.434-8.682-22.292-14.268c-9.413-7.632-23.229-6.193-30.86,3.22
      c-3.17,3.909-4.904,8.788-4.912,13.815c1.314,81.186,45.891,155.489,116.917,194.842c-9.586-1.175-19.04-3.204-28.264-6.054
      c-11.607-3.491-23.846,3.088-27.338,14.687c-1.519,5.06-1.166,10.505,1.004,15.326c30.826,69.055,92.447,119.488,166.24,136.039
      c-70.303,39.665-151.25,56.33-231.5,47.657c-10.399-1.323-20.255,5.002-23.385,15.015c-3.228,9.931,0.993,20.765,10.095,25.891
      c98.254,58.384,210.029,90.139,324.3,92.16c109.632-0.403,216.707-33.152,307.808-94.132
      C820.37,681.983,928.769,474.763,913.672,289.359c37.184-27.533,69.439-61.153,95.403-99.446
      C1014.406,181.519,1013.437,170.586,1006.701,163.276z"
    />
  </svg>
);

export const ImageSvg = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
    <g>
      <g>
        <path
          fill="#E5E1E5"
          d="M163.033,1011.756L2.746,191.353c-4.863-24.879,11.365-48.991,36.245-53.852l124.042-24.234l194.642-42.82
          l279.663,941.308H163.033V1011.756z"
        />
      </g>
      <path
        fill="#99E6FC"
        d="M163.033,680.979L68.355,196.393l94.678-18.501l143.802-23.615l62.994,584.599L163.033,680.979z"
      />
      <g id="XMLID_159_">
        <g>
          <path
            fill="#F9F7F8"
            d="M1014.357,64.9v957.461c0,25.351-20.549,45.899-45.899,45.899H208.93
            c-25.351,0-45.901-20.549-45.901-45.899V64.9c0-25.35,20.551-45.9,45.901-45.9h759.528C993.809,19,1014.357,39.551,1014.357,64.9
            z"
          />
        </g>
        <path
          fill="#EFEDEF"
          d="M574.473,971.206c-90.848,0-164.495-73.646-164.495-164.493V19H208.93
          c-25.351,0-45.901,20.551-45.901,45.9v957.461c0,25.351,20.551,45.899,45.901,45.899h759.528
          c25.351,0,45.899-20.549,45.899-45.899v-51.155H574.473z"
        />
        <path
          fill="#FEC165"
          d="M950.933,737.554V234.861c0-7.122-5.774-12.896-12.897-12.896H239.354c-7.12,0-12.896,5.774-12.896,12.896
          v502.692H950.933z"
        />
        <path
          fill="#FDB441"
          d="M409.978,221.965H239.354c-7.12,0-12.896,5.774-12.896,12.896v502.692h183.52V221.965z"
        />
        <circle fill="#FEE903" cx="588.693" cy="600.309" r="246.948" />
        <path
          fill="#F4D902"
          d="M409.978,770.729V429.889c-42.274,44.316-68.229,104.339-68.229,170.419
          C341.748,666.391,367.703,726.41,409.978,770.729z"
        />
        <g>
          <path
            fill="#99E6FC"
            d="M902.813,668.316c-57.591-25.393-122.604-28.267-182.203-8.034l-51.163,17.336
            c-52.369,17.759-109.135,17.759-161.505,0l-51.163-17.336c-59.602-20.232-124.611-17.358-182.182,8.034l-48.142,21.226v105.269
            l80.12,33.354h599.658l44.699-33.354V689.542L902.813,668.316z"
          />
          <path
            fill="#62DBFB"
            d="M409.978,828.165V649.264c-45.72-6.239-92.605,0.184-135.379,19.053l-48.141,21.226v105.269
            l80.119,33.354H409.978z"
          />
          <path
            fill="#62DBFB"
            d="M950.933,794.811v61.709c0,5.452-4.424,9.878-9.879,9.878H236.332c-5.453,0-9.877-4.426-9.877-9.878
            v-61.709l48.142-21.229c57.57-25.39,122.58-28.268,182.182-8.055l51.163,17.358c52.37,17.759,109.136,17.759,161.505,0
            l51.163-17.358c59.6-20.213,124.612-17.335,182.203,8.055L950.933,794.811z"
          />
          <path
            fill="#01D0FB"
            d="M236.332,866.397h184.86c-7.214-18.51-11.215-38.625-11.215-59.685v-52.188
            c-45.72-6.231-92.605,0.192-135.379,19.061l-48.141,21.226v61.71c-0.003,5.451,4.421,9.875,9.874,9.875V866.397z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const EmailSvg = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10.5" cy="10.5" r="10.5" fill="white" />
    <circle cx="10.5" cy="10.5" r="8.5" fill="#54B986" />
    <g clipPath="url(#clip0_67_455)">
      <path
        d="M10.1677 11.4584C10.2557 11.5461 10.375 11.5954 10.4992 11.5954C10.6235 11.5954 10.7427 11.5461 10.8307 11.4584L14.463 7.82613C14.4876 7.80156 14.505 7.77061 14.513 7.73674C14.5211 7.70288 14.5196 7.66744 14.5087 7.63439C14.4977 7.60134 14.4778 7.57199 14.4511 7.54962C14.4244 7.52726 14.3921 7.51276 14.3576 7.50775C14.322 7.5025 14.286 7.49987 14.25 7.49988H6.74999C6.71372 7.49983 6.6775 7.50247 6.64161 7.50775C6.60716 7.51276 6.57479 7.52726 6.54811 7.54962C6.52144 7.57199 6.50151 7.60134 6.49058 7.63439C6.47964 7.66744 6.47812 7.70288 6.48618 7.73674C6.49425 7.77061 6.51158 7.80156 6.53624 7.82613L10.1677 11.4584Z"
        fill="white"
      />
      <path
        d="M14.958 8.18707C14.9455 8.18175 14.9316 8.1803 14.9183 8.1829C14.9049 8.18551 14.8926 8.19205 14.883 8.20169L12.558 10.5267C12.5405 10.5443 12.5306 10.5682 12.5306 10.5931C12.5306 10.6179 12.5405 10.6418 12.558 10.6594L14.4491 12.5506C14.476 12.5765 14.4974 12.6075 14.5122 12.6418C14.527 12.6761 14.5347 12.713 14.5351 12.7504C14.5354 12.7877 14.5283 12.8248 14.5142 12.8593C14.5001 12.8939 14.4792 12.9253 14.4528 12.9517C14.4264 12.9782 14.395 12.9991 14.3605 13.0132C14.3259 13.0274 14.2889 13.0345 14.2515 13.0342C14.2142 13.0339 14.1773 13.0262 14.1429 13.0114C14.1086 12.9967 14.0776 12.9753 14.0516 12.9484L12.1605 11.0573C12.1518 11.0486 12.1414 11.0417 12.1301 11.0369C12.1187 11.0322 12.1065 11.0298 12.0941 11.0298C12.0818 11.0298 12.0696 11.0322 12.0582 11.0369C12.0468 11.0417 12.0365 11.0486 12.0278 11.0573L11.2294 11.8557C11.036 12.049 10.7738 12.1575 10.5004 12.1575C10.227 12.1575 9.96476 12.049 9.77138 11.8557L8.97225 11.0581C8.95461 11.0405 8.93075 11.0307 8.90587 11.0307C8.881 11.0307 8.85714 11.0405 8.8395 11.0581L6.94837 12.9492C6.89531 13.0004 6.82425 13.0287 6.75051 13.028C6.67676 13.0274 6.60624 12.9978 6.55411 12.9456C6.50199 12.8934 6.47245 12.8229 6.47184 12.7491C6.47124 12.6754 6.49962 12.6043 6.55088 12.5513L8.442 10.6602C8.45954 10.6426 8.46939 10.6187 8.46939 10.5938C8.46939 10.5689 8.45954 10.5451 8.442 10.5274L6.117 8.20244C6.10744 8.19271 6.09516 8.18611 6.08177 8.1835C6.06838 8.18089 6.05452 8.18239 6.042 8.18782C6.02968 8.19295 6.01913 8.20159 6.01167 8.21265C6.0042 8.22371 6.00015 8.23672 6 8.25007V12.7501C6 12.949 6.07902 13.1397 6.21967 13.2804C6.36032 13.4211 6.55109 13.5001 6.75 13.5001H14.25C14.4489 13.5001 14.6397 13.4211 14.7803 13.2804C14.921 13.1397 15 12.949 15 12.7501V8.25007C15 8.23658 14.9961 8.22339 14.9886 8.21217C14.9811 8.20095 14.9705 8.19221 14.958 8.18707Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_67_455">
        <rect width="9" height="9" fill="white" transform="translate(6 6)" />
      </clipPath>
    </defs>
  </svg>
);

export const EmailSVG2 = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3627_24774)">
      <path
        d="M15.9253 3.88808C15.9031 3.87861 15.8784 3.87603 15.8547 3.88067C15.8309 3.8853 15.8091 3.89694 15.792 3.91408L9.294 10.4107C8.95021 10.7543 8.48405 10.9474 7.998 10.9474C7.51195 10.9474 7.04579 10.7543 6.702 10.4107L0.206668 3.91408C0.189673 3.89678 0.167836 3.88503 0.144035 3.88039C0.120233 3.87575 0.0955836 3.87843 0.0733346 3.88808C0.0514725 3.89749 0.0328631 3.91313 0.0198236 3.93305C0.00678413 3.95296 -0.000109405 3.97627 1.31304e-06 4.00008V12.0001C1.31304e-06 12.3537 0.140477 12.6928 0.390526 12.9429C0.640574 13.1929 0.979713 13.3334 1.33333 13.3334H14.6667C15.0203 13.3334 15.3594 13.1929 15.6095 12.9429C15.8595 12.6928 16 12.3537 16 12.0001V4.00008C16.0001 3.9761 15.993 3.95264 15.9797 3.9327C15.9664 3.91275 15.9475 3.89721 15.9253 3.88808Z"
        fill="#F0B4C3"
      />
      <path
        d="M7.40976 9.70408C7.56622 9.86008 7.77815 9.94769 7.99909 9.94769C8.22004 9.94769 8.43197 9.86008 8.58843 9.70408L15.0458 3.24675C15.0895 3.20303 15.1202 3.14802 15.1344 3.08786C15.1487 3.0277 15.1459 2.96476 15.1264 2.90608C15.0531 2.68675 14.8491 2.66675 14.6664 2.66675H1.33309C1.14976 2.66675 0.944428 2.68675 0.872428 2.90608C0.852959 2.96476 0.850193 3.0277 0.864438 3.08786C0.878684 3.14802 0.909379 3.20303 0.953095 3.24675L7.40976 9.70408Z"
        fill="#F0B4C3"
      />
    </g>
    <defs>
      <clipPath id="clip0_3627_24774">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SmSSVG = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10.5" cy="10.5" r="10.5" fill="white" />
    <circle cx="10.5" cy="10.5" r="8.5" fill="#54B986" />
    <path
      d="M12.3749 6.0127H8.62488C8.32651 6.0127 8.04036 6.13122 7.82938 6.3422C7.6184 6.55318 7.49988 6.83933 7.49988 7.1377V13.8622C7.49988 14.1606 7.6184 14.4467 7.82938 14.6577C8.04036 14.8687 8.32651 14.9872 8.62488 14.9872H12.3749C12.6732 14.9872 12.9594 14.8687 13.1704 14.6577C13.3814 14.4467 13.4999 14.1606 13.4999 13.8622V7.1377C13.4999 6.83933 13.3814 6.55318 13.1704 6.3422C12.9594 6.13122 12.6732 6.0127 12.3749 6.0127ZM10.4999 14.4247C10.4257 14.4247 10.3532 14.4027 10.2915 14.3615C10.2299 14.3203 10.1818 14.2617 10.1534 14.1932C10.125 14.1247 10.1176 14.0493 10.1321 13.9765C10.1466 13.9038 10.1823 13.837 10.2347 13.7845C10.2872 13.7321 10.354 13.6964 10.4267 13.6819C10.4995 13.6674 10.5749 13.6749 10.6434 13.7032C10.7119 13.7316 10.7705 13.7797 10.8117 13.8414C10.8529 13.903 10.8749 13.9755 10.8749 14.0497C10.8749 14.1492 10.8354 14.2445 10.765 14.3149C10.6947 14.3852 10.5993 14.4247 10.4999 14.4247ZM12.7499 12.7372C12.7499 12.8367 12.7104 12.932 12.64 13.0024C12.5697 13.0727 12.4743 13.1122 12.3749 13.1122H8.62488C8.52542 13.1122 8.43004 13.0727 8.35971 13.0024C8.28939 12.932 8.24988 12.8367 8.24988 12.7372V7.3252C8.24988 7.22574 8.28939 7.13036 8.35971 7.06003C8.43004 6.9897 8.52542 6.9502 8.62488 6.9502H12.3749C12.4743 6.9502 12.5697 6.9897 12.64 7.06003C12.7104 7.13036 12.7499 7.22574 12.7499 7.3252V12.7372Z"
      fill="white"
    />
  </svg>
);

export const SmSSVG2 = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3611_24078)">
      <path
        d="M13.5 8.46648V15.3882C13.4998 15.9317 13.2838 16.4529 12.8994 16.8371C12.515 17.2214 11.9937 17.4372 11.4503 17.4372H6.54975C6.28061 17.4373 6.01408 17.3844 5.7654 17.2815C5.51672 17.1786 5.29075 17.0276 5.1004 16.8374C4.91006 16.6471 4.75906 16.4212 4.65604 16.1725C4.55302 15.9239 4.5 15.6574 4.5 15.3882V6.77148"
        stroke="#FCFCFD"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.50098 14.0625H13.501"
        stroke="#FCFCFD"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.9585 7.917C9.12308 8.0823 9.31875 8.2134 9.53422 8.30273C9.7497 8.39206 9.98073 8.43787 10.214 8.4375H11.2497V10.6875L13.529 8.4375H15.098C15.5691 8.4375 16.0209 8.25041 16.3541 7.91737C16.6873 7.58432 16.8745 7.13259 16.8747 6.6615V4.02675C16.8747 3.55566 16.6877 3.10385 16.3546 2.77066C16.0216 2.43748 15.5698 2.2502 15.0987 2.25H12.3747"
        stroke="#FCFCFD"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5322 5.0625C11.4766 5.0625 11.4222 5.079 11.376 5.1099C11.3297 5.1408 11.2937 5.18473 11.2724 5.23612C11.2511 5.28751 11.2455 5.34406 11.2564 5.39862C11.2672 5.45318 11.294 5.50329 11.3334 5.54262C11.3727 5.58196 11.4228 5.60874 11.4774 5.6196C11.5319 5.63045 11.5885 5.62488 11.6399 5.60359C11.6912 5.5823 11.7352 5.54626 11.7661 5.5C11.797 5.45375 11.8135 5.39938 11.8135 5.34375C11.8135 5.26916 11.7838 5.19762 11.7311 5.14488C11.6784 5.09213 11.6068 5.0625 11.5322 5.0625"
        stroke="#FCFCFD"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3447 5.0625C14.2891 5.0625 14.2347 5.079 14.1885 5.1099C14.1422 5.1408 14.1062 5.18473 14.0849 5.23612C14.0636 5.28751 14.058 5.34406 14.0689 5.39862C14.0797 5.45318 14.1065 5.50329 14.1459 5.54262C14.1852 5.58196 14.2353 5.60874 14.2899 5.6196C14.3444 5.63045 14.401 5.62488 14.4524 5.60359C14.5037 5.5823 14.5477 5.54626 14.5786 5.5C14.6095 5.45375 14.626 5.39938 14.626 5.34375C14.626 5.26916 14.5963 5.19762 14.5436 5.14488C14.4909 5.09213 14.4193 5.0625 14.3447 5.0625Z"
        fill="#FCFCFD"
        stroke="#FCFCFD"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.90175 0.5625H7.7865C8.25772 0.5625 8.70965 0.749693 9.04285 1.0829C9.37606 1.4161 9.56325 1.86803 9.56325 2.33925V4.4115C9.56305 4.88259 9.37577 5.33432 9.04259 5.66737C8.7094 6.00041 8.25759 6.1875 7.7865 6.1875H6.18825V8.4375L3.90825 6.1875H2.90175C2.66846 6.1876 2.43743 6.14173 2.22187 6.05253C2.00631 5.96332 1.81044 5.83251 1.64544 5.66759C1.48045 5.50266 1.34956 5.30684 1.26026 5.09132C1.17096 4.8758 1.125 4.64479 1.125 4.4115V2.33925C1.125 1.86803 1.31219 1.4161 1.6454 1.0829C1.9786 0.749693 2.43053 0.5625 2.90175 0.5625V0.5625Z"
        stroke="#FCFCFD"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.84473 3.375C6.90035 3.375 6.95473 3.3915 7.00098 3.4224C7.04723 3.4533 7.08328 3.49723 7.10457 3.54862C7.12585 3.60001 7.13142 3.65656 7.12057 3.71112C7.10972 3.76568 7.08293 3.81579 7.0436 3.85512C7.00427 3.89446 6.95415 3.92124 6.8996 3.9321C6.84504 3.94295 6.78849 3.93738 6.7371 3.91609C6.6857 3.8948 6.64178 3.85876 6.61088 3.8125C6.57997 3.76625 6.56348 3.71188 6.56348 3.65625C6.56348 3.58166 6.59311 3.51012 6.64585 3.45738C6.6986 3.40463 6.77013 3.375 6.84473 3.375"
        stroke="#FCFCFD"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.84424 3.375C3.89986 3.375 3.95424 3.3915 4.00049 3.4224C4.04674 3.4533 4.08279 3.49723 4.10408 3.54862C4.12537 3.60001 4.13094 3.65656 4.12008 3.71112C4.10923 3.76568 4.08245 3.81579 4.04311 3.85512C4.00378 3.89446 3.95366 3.92124 3.89911 3.9321C3.84455 3.94295 3.788 3.93738 3.73661 3.91609C3.68522 3.8948 3.64129 3.85876 3.61039 3.8125C3.57948 3.76625 3.56299 3.71188 3.56299 3.65625C3.56299 3.58166 3.59262 3.51012 3.64536 3.45738C3.69811 3.40463 3.76965 3.375 3.84424 3.375Z"
        fill="#FCFCFD"
        stroke="#FCFCFD"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3611_24078">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MarkAsReadSvG = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="18" cy="18" r="18" fill="#EAEEF5" />
    <path
      d="M24.75 12.5625H11.25C10.6287 12.5625 10.125 13.0662 10.125 13.6875V22.6875C10.125 23.3088 10.6287 23.8125 11.25 23.8125H24.75C25.3713 23.8125 25.875 23.3088 25.875 22.6875V13.6875C25.875 13.0662 25.3713 12.5625 24.75 12.5625Z"
      stroke="#A6B2CB"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.6209 12.9751L19.5129 17.6731C19.0792 18.0067 18.5473 18.1876 18.0001 18.1876C17.4529 18.1876 16.9211 18.0067 16.4874 17.6731L10.3794 12.9751"
      stroke="#A6B2CB"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RightArrowHide = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="13" cy="13" r="13" fill="#EAEEF5" />
    <g clipPath="url(#clip0_79_594)">
      <path
        d="M13.7261 12.4998C13.7265 12.6593 13.6952 12.8174 13.6343 12.9649C13.5733 13.1124 13.4838 13.2463 13.3709 13.3591L8.99797 17.7321C8.84519 17.88 8.64041 17.9619 8.42778 17.9602C8.21515 17.9584 8.01172 17.8732 7.86136 17.7229C7.71101 17.5725 7.62578 17.3691 7.62405 17.1564C7.62232 16.9438 7.70424 16.739 7.85214 16.5863L11.8575 12.5809C11.8682 12.5702 11.8766 12.5576 11.8824 12.5437C11.8882 12.5297 11.8912 12.5148 11.8912 12.4998C11.8912 12.4847 11.8882 12.4698 11.8824 12.4558C11.8766 12.4419 11.8682 12.4293 11.8575 12.4186L7.85214 8.41325C7.70424 8.26048 7.62232 8.05569 7.62405 7.84306C7.62578 7.63043 7.71101 7.427 7.86136 7.27665C8.01172 7.12629 8.21515 7.04106 8.42778 7.03933C8.64041 7.03761 8.84519 7.11953 8.99797 7.26742L13.3709 11.6404C13.4838 11.7532 13.5733 11.8871 13.6343 12.0346C13.6952 12.1821 13.7265 12.3402 13.7261 12.4998Z"
        fill="#A6B2CB"
      />
      <path
        d="M18.3853 12.4998C18.3856 12.6593 18.3544 12.8174 18.2935 12.9649C18.2325 13.1124 18.143 13.2463 18.0301 13.3591L13.6572 17.7321C13.5044 17.88 13.2996 17.9619 13.087 17.9602C12.8743 17.9584 12.6709 17.8732 12.5205 17.7229C12.3702 17.5725 12.285 17.3691 12.2832 17.1564C12.2815 16.9438 12.3634 16.739 12.5113 16.5863L16.5167 12.5809C16.5274 12.5702 16.5358 12.5576 16.5416 12.5437C16.5474 12.5297 16.5504 12.5148 16.5504 12.4998C16.5504 12.4847 16.5474 12.4698 16.5416 12.4558C16.5358 12.4419 16.5274 12.4293 16.5167 12.4186L12.5113 8.41325C12.3634 8.26048 12.2815 8.05569 12.2832 7.84306C12.285 7.63043 12.3702 7.427 12.5205 7.27665C12.6709 7.12629 12.8743 7.04106 13.087 7.03933C13.2996 7.03761 13.5044 7.11953 13.6572 7.26742L18.0301 11.6404C18.143 11.7532 18.2325 11.8871 18.2935 12.0346C18.3544 12.1821 18.3856 12.3402 18.3853 12.4998Z"
        fill="#A6B2CB"
      />
    </g>
    <defs>
      <clipPath id="clip0_79_594">
        <rect
          width="11"
          height="11"
          fill="white"
          transform="translate(7.5 7)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const LeftArrowHide = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="13" cy="13" r="13" fill="#EAEEF5" />
    <g clipPath="url(#clip0_79_1000)">
      <path
        d="M12.2739 12.5002C12.2735 12.3407 12.3048 12.1826 12.3657 12.0351C12.4267 11.8876 12.5162 11.7537 12.6291 11.6409L17.002 7.26791C17.1548 7.12002 17.3596 7.0381 17.5722 7.03983C17.7848 7.04155 17.9883 7.12679 18.1386 7.27714C18.289 7.4275 18.3742 7.63093 18.3759 7.84356C18.3777 8.05618 18.2958 8.26097 18.1479 8.41375L14.1425 12.4191C14.1318 12.4298 14.1234 12.4424 14.1176 12.4563C14.1118 12.4703 14.1088 12.4852 14.1088 12.5002C14.1088 12.5153 14.1118 12.5302 14.1176 12.5442C14.1234 12.5581 14.1318 12.5707 14.1425 12.5814L18.1479 16.5867C18.2958 16.7395 18.3777 16.9443 18.3759 17.1569C18.3742 17.3696 18.289 17.573 18.1386 17.7234C17.9883 17.8737 17.7848 17.9589 17.5722 17.9607C17.3596 17.9624 17.1548 17.8805 17.002 17.7326L12.6291 13.3596C12.5162 13.2468 12.4267 13.1129 12.3657 12.9654C12.3048 12.8179 12.2735 12.6598 12.2739 12.5002Z"
        fill="#A6B2CB"
      />
      <path
        d="M7.61468 12.5002C7.61437 12.3407 7.64559 12.1826 7.70654 12.0351C7.7675 11.8876 7.857 11.7537 7.96989 11.6409L12.3428 7.26791C12.4956 7.12002 12.7004 7.0381 12.913 7.03983C13.1257 7.04155 13.3291 7.12679 13.4795 7.27714C13.6298 7.4275 13.715 7.63093 13.7168 7.84356C13.7185 8.05618 13.6366 8.26097 13.4887 8.41375L9.48331 12.4191C9.47264 12.4298 9.46417 12.4424 9.4584 12.4563C9.45262 12.4703 9.44965 12.4852 9.44965 12.5002C9.44965 12.5153 9.45262 12.5302 9.4584 12.5442C9.46417 12.5581 9.47264 12.5707 9.48331 12.5814L13.4887 16.5867C13.6366 16.7395 13.7185 16.9443 13.7168 17.1569C13.715 17.3696 13.6298 17.573 13.4795 17.7234C13.3291 17.8737 13.1257 17.9589 12.913 17.9607C12.7004 17.9624 12.4956 17.8805 12.3428 17.7326L7.96989 13.3596C7.857 13.2468 7.7675 13.1129 7.70654 12.9654C7.64559 12.8179 7.61437 12.6598 7.61468 12.5002Z"
        fill="#A6B2CB"
      />
    </g>
    <defs>
      <clipPath id="clip0_79_1000">
        <rect
          width="11"
          height="11"
          fill="white"
          transform="translate(18.5 18) rotate(-180)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const MarkAsUnreadSVG = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="18" cy="18" r="18" fill="#EAEEF5" />
    <path
      d="M24.75 12.5625H11.25C10.6287 12.5625 10.125 13.0662 10.125 13.6875V22.6875C10.125 23.3088 10.6287 23.8125 11.25 23.8125H24.75C25.3713 23.8125 25.875 23.3088 25.875 22.6875V13.6875C25.875 13.0662 25.3713 12.5625 24.75 12.5625Z"
      stroke="#A6B2CB"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.6209 12.9751L19.5129 17.6731C19.0792 18.0067 18.5473 18.1876 18.0001 18.1876C17.4529 18.1876 16.9211 18.0067 16.4874 17.6731L10.3794 12.9751"
      stroke="#A6B2CB"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="25" cy="13" r="4" fill="#EAEEF5" />
    <circle cx="25" cy="13" r="2" fill="#A6B2CB" />
  </svg>
);

export const MailTabSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_71_809)">
      <path
        d="M18.3334 1.25H4.58341C4.14139 1.25 3.71746 1.42559 3.4049 1.73816C3.09234 2.05072 2.91675 2.47464 2.91675 2.91667V14.1667C2.91675 14.6087 3.09234 15.0326 3.4049 15.3452C3.71746 15.6577 4.14139 15.8333 4.58341 15.8333H18.3334C18.7754 15.8333 19.1994 15.6577 19.5119 15.3452C19.8245 15.0326 20.0001 14.6087 20.0001 14.1667V2.91667C20.0001 2.47464 19.8245 2.05072 19.5119 1.73816C19.1994 1.42559 18.7754 1.25 18.3334 1.25ZM17.9167 2.91667C18.0273 2.91667 18.1332 2.96057 18.2114 3.03871C18.2895 3.11685 18.3334 3.22283 18.3334 3.33333V3.5C18.3334 3.56862 18.3164 3.63616 18.284 3.69664C18.2516 3.75712 18.2047 3.80865 18.1476 3.84667L11.8792 8.02083C11.8123 8.06547 11.7339 8.08977 11.6534 8.0908C11.573 8.09184 11.494 8.06956 11.4259 8.02667L4.77758 3.82833C4.71808 3.79075 4.66907 3.73872 4.63512 3.67708C4.60117 3.61544 4.58338 3.54621 4.58341 3.47583V3.33333C4.58341 3.22283 4.62731 3.11685 4.70545 3.03871C4.78359 2.96057 4.88957 2.91667 5.00008 2.91667H17.9167ZM5.00008 14.1667C4.88957 14.1667 4.78359 14.1228 4.70545 14.0446C4.62731 13.9665 4.58341 13.8605 4.58341 13.75V6.4325C4.58397 6.35822 4.60437 6.28544 4.64251 6.2217C4.68064 6.15795 4.73513 6.10556 4.80031 6.06995C4.8655 6.03434 4.93903 6.0168 5.01327 6.01915C5.08751 6.02151 5.15978 6.04366 5.22258 6.08333L11.2226 9.87167C11.3556 9.95548 11.5096 9.99997 11.6667 10C11.8313 9.99959 11.9921 9.95092 12.1292 9.86L17.6859 6.155C17.7485 6.11332 17.8213 6.08938 17.8964 6.08571C17.9716 6.08204 18.0463 6.09878 18.1127 6.13415C18.1791 6.16953 18.2347 6.22222 18.2735 6.28663C18.3124 6.35104 18.3331 6.42477 18.3334 6.5V13.75C18.3334 13.8605 18.2895 13.9665 18.2114 14.0446C18.1332 14.1228 18.0273 14.1667 17.9167 14.1667H5.00008Z"
        fill="currentColor"
      />
      <path
        d="M16.25 17.0834H2.08333C1.97283 17.0834 1.86685 17.0395 1.78871 16.9614C1.71057 16.8832 1.66667 16.7773 1.66667 16.6667V5.00008C1.66667 4.77907 1.57887 4.56711 1.42259 4.41083C1.26631 4.25455 1.05435 4.16675 0.833333 4.16675C0.61232 4.16675 0.400358 4.25455 0.244078 4.41083C0.0877974 4.56711 0 4.77907 0 5.00008L0 17.0834C0 17.5254 0.175595 17.9494 0.488155 18.2619C0.800716 18.5745 1.22464 18.7501 1.66667 18.7501H16.25C16.471 18.7501 16.683 18.6623 16.8393 18.506C16.9955 18.3497 17.0833 18.1378 17.0833 17.9167C17.0833 17.6957 16.9955 17.4838 16.8393 17.3275C16.683 17.1712 16.471 17.0834 16.25 17.0834Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_71_809">
        <rect width="20" height="20" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

export const PhoneTabSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_71_1255)">
      <path
        d="M15 9.40726V17.0981C14.9998 17.702 14.7597 18.2811 14.3326 18.708C13.9056 19.1349 13.3264 19.3748 12.7225 19.3748H7.2775C6.97845 19.3749 6.68232 19.3161 6.406 19.2017C6.12969 19.0873 5.87861 18.9197 5.66711 18.7082C5.45562 18.4968 5.28785 18.2458 5.17338 17.9695C5.05892 17.6933 5 17.3971 5 17.0981V7.52393"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.00098 15.625H15.001"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.95422 8.79667C10.1371 8.98034 10.3545 9.126 10.5939 9.22526C10.8333 9.32451 11.09 9.37541 11.3492 9.375H12.5001V11.875L15.0326 9.375H16.7759C17.2993 9.375 17.8013 9.16712 18.1715 8.79707C18.5417 8.42703 18.7498 7.9251 18.7501 7.40167V4.47417C18.7501 3.95073 18.5422 3.44872 18.1721 3.07851C17.8021 2.70831 17.3002 2.50022 16.7767 2.5H13.7501"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8135 5.625C12.7517 5.625 12.6913 5.64333 12.6399 5.67767C12.5885 5.712 12.5484 5.76081 12.5248 5.81791C12.5011 5.87501 12.4949 5.93785 12.507 5.99847C12.519 6.05908 12.5488 6.11477 12.5925 6.15847C12.6362 6.20217 12.6919 6.23194 12.7525 6.244C12.8131 6.25605 12.876 6.24986 12.9331 6.22621C12.9902 6.20256 13.039 6.16251 13.0733 6.11112C13.1076 6.05973 13.126 5.99931 13.126 5.9375C13.126 5.85462 13.0931 5.77513 13.0344 5.71653C12.9758 5.65792 12.8964 5.625 12.8135 5.625"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9385 5.625C15.8767 5.625 15.8163 5.64333 15.7649 5.67767C15.7135 5.712 15.6734 5.76081 15.6498 5.81791C15.6261 5.87501 15.6199 5.93785 15.632 5.99847C15.644 6.05908 15.6738 6.11477 15.7175 6.15847C15.7612 6.20217 15.8169 6.23194 15.8775 6.244C15.9381 6.25605 16.001 6.24986 16.0581 6.22621C16.1152 6.20256 16.164 6.16251 16.1983 6.11112C16.2326 6.05973 16.251 5.99931 16.251 5.9375C16.251 5.85462 16.2181 5.77513 16.1594 5.71653C16.1008 5.65792 16.0214 5.625 15.9385 5.625Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.22417 0.625H8.65167C9.17525 0.625 9.67738 0.832992 10.0476 1.20322C10.4178 1.57345 10.6258 2.07559 10.6258 2.59917V4.90167C10.6256 5.4251 10.4175 5.92703 10.0473 6.29707C9.67711 6.66712 9.1751 6.875 8.65167 6.875H6.87583V9.375L4.3425 6.875H3.22417C2.96495 6.87511 2.70826 6.82415 2.46875 6.72503C2.22924 6.62591 2.0116 6.48057 1.82827 6.29732C1.64494 6.11407 1.49951 5.89649 1.40029 5.65702C1.30107 5.41755 1.25 5.16088 1.25 4.90167V2.59917C1.25 2.07559 1.45799 1.57345 1.82822 1.20322C2.19845 0.832992 2.70059 0.625 3.22417 0.625V0.625Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.60486 3.75C7.66667 3.75 7.72708 3.76833 7.77847 3.80267C7.82986 3.837 7.86992 3.88581 7.89357 3.94291C7.91722 4.00001 7.92341 4.06285 7.91135 4.12347C7.8993 4.18408 7.86953 4.23977 7.82583 4.28347C7.78212 4.32717 7.72644 4.35694 7.66582 4.369C7.6052 4.38105 7.54237 4.37486 7.48527 4.35121C7.42817 4.32756 7.37936 4.28751 7.34502 4.23612C7.31069 4.18473 7.29236 4.12431 7.29236 4.0625C7.29236 3.97962 7.32528 3.90013 7.38389 3.84153C7.44249 3.78292 7.52198 3.75 7.60486 3.75"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.27173 3.75C4.33354 3.75 4.39395 3.76833 4.44534 3.80267C4.49673 3.837 4.53679 3.88581 4.56044 3.94291C4.58409 4.00001 4.59028 4.06285 4.57822 4.12347C4.56617 4.18408 4.5364 4.23977 4.4927 4.28347C4.449 4.32717 4.39331 4.35694 4.33269 4.369C4.27208 4.38105 4.20924 4.37486 4.15214 4.35121C4.09504 4.32756 4.04623 4.28751 4.01189 4.23612C3.97756 4.18473 3.95923 4.12431 3.95923 4.0625C3.95923 3.97962 3.99215 3.90013 4.05076 3.84153C4.10936 3.78292 4.18885 3.75 4.27173 3.75Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_71_1255">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const NewContactIcon = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_918_203)">
      <path
        d="M0 5C0 5.16576 0.065848 5.32473 0.183058 5.44194C0.300269 5.55915 0.45924 5.625 0.625 5.625H4.27083C4.29846 5.625 4.32496 5.63597 4.34449 5.65551C4.36403 5.67504 4.375 5.70154 4.375 5.72917V9.375C4.375 9.54076 4.44085 9.69973 4.55806 9.81694C4.67527 9.93415 4.83424 10 5 10C5.16576 10 5.32473 9.93415 5.44194 9.81694C5.55915 9.69973 5.625 9.54076 5.625 9.375V5.72917C5.625 5.70154 5.63597 5.67504 5.65551 5.65551C5.67504 5.63597 5.70154 5.625 5.72917 5.625H9.375C9.54076 5.625 9.69973 5.55915 9.81694 5.44194C9.93415 5.32473 10 5.16576 10 5C10 4.83424 9.93415 4.67527 9.81694 4.55806C9.69973 4.44085 9.54076 4.375 9.375 4.375H5.72917C5.70154 4.375 5.67504 4.36403 5.65551 4.34449C5.63597 4.32496 5.625 4.29846 5.625 4.27083V0.625C5.625 0.45924 5.55915 0.300269 5.44194 0.183058C5.32473 0.065848 5.16576 0 5 0C4.83424 0 4.67527 0.065848 4.55806 0.183058C4.44085 0.300269 4.375 0.45924 4.375 0.625V4.27083C4.375 4.29846 4.36403 4.32496 4.34449 4.34449C4.32496 4.36403 4.29846 4.375 4.27083 4.375H0.625C0.45924 4.375 0.300269 4.44085 0.183058 4.55806C0.065848 4.67527 0 4.83424 0 5H0Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_918_203">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UploadContactIcon = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_918_292)">
      <path
        d="M10 0.916875C9.99927 0.673996 9.90245 0.441285 9.73071 0.269543C9.55896 0.0978015 9.32625 0.000977477 9.08337 0.000208346H7.24546C7.17723 -0.00174163 7.1093 0.0100127 7.0457 0.034776C6.98209 0.0595393 6.9241 0.0968084 6.87515 0.144378C6.8262 0.191948 6.78729 0.248853 6.76072 0.311725C6.73415 0.374598 6.72046 0.44216 6.72046 0.510417C6.72046 0.578673 6.73415 0.646236 6.76072 0.709108C6.78729 0.77198 6.8262 0.828885 6.87515 0.876455C6.9241 0.924025 6.98209 0.961294 7.0457 0.986057C7.1093 1.01082 7.17723 1.02257 7.24546 1.02062H8.87504C8.90267 1.02062 8.92916 1.0316 8.9487 1.05113C8.96823 1.07067 8.97921 1.09716 8.97921 1.12479V8.87521C8.97921 8.90283 8.96823 8.92933 8.9487 8.94886C8.92916 8.9684 8.90267 8.97937 8.87504 8.97937H7.24546C7.17723 8.97742 7.1093 8.98918 7.0457 9.01394C6.98209 9.03871 6.9241 9.07597 6.87515 9.12354C6.8262 9.17111 6.78729 9.22802 6.76072 9.29089C6.73415 9.35376 6.72046 9.42133 6.72046 9.48958C6.72046 9.55784 6.73415 9.6254 6.76072 9.68827C6.78729 9.75115 6.8262 9.80805 6.87515 9.85562C6.9241 9.90319 6.98209 9.94046 7.0457 9.96522C7.1093 9.98999 7.17723 10.0017 7.24546 9.99979H9.08337C9.32618 9.99902 9.55883 9.90226 9.73056 9.7306C9.90229 9.55895 9.99916 9.32635 10 9.08354V0.916875Z"
        fill="#054637"
      />
      <path
        d="M0 0.916667V9.08333C0.00076913 9.32621 0.0975932 9.55892 0.269335 9.73066C0.441077 9.90241 0.673788 9.99923 0.916667 10H2.75542C2.82364 10.0019 2.89157 9.9902 2.95518 9.96543C3.01878 9.94067 3.07678 9.9034 3.12572 9.85583C3.17467 9.80826 3.21358 9.75136 3.24015 9.68848C3.26673 9.62561 3.28042 9.55805 3.28042 9.48979C3.28042 9.42153 3.26673 9.35397 3.24015 9.2911C3.21358 9.22823 3.17467 9.17132 3.12572 9.12375C3.07678 9.07618 3.01878 9.03891 2.95518 9.01415C2.89157 8.98939 2.82364 8.97763 2.75542 8.97958H1.125C1.09737 8.97958 1.07088 8.96861 1.05134 8.94907C1.03181 8.92954 1.02083 8.90304 1.02083 8.87542V1.125C1.02083 1.09737 1.03181 1.07088 1.05134 1.05134C1.07088 1.03181 1.09737 1.02083 1.125 1.02083H2.75542C2.89079 1.02083 3.02061 0.967057 3.11634 0.871336C3.21206 0.775614 3.26583 0.645788 3.26583 0.510417C3.26583 0.375046 3.21206 0.245219 3.11634 0.149498C3.02061 0.0537759 2.89079 0 2.75542 0L0.916667 0C0.673788 0.00076913 0.441077 0.0975932 0.269335 0.269335C0.0975932 0.441077 0.00076913 0.673788 0 0.916667H0Z"
        fill="#054637"
      />
      <path
        d="M7.04168 5.40767C7.11999 5.40773 7.19667 5.38525 7.26255 5.34291C7.32843 5.30056 7.38073 5.24015 7.4132 5.16888C7.44567 5.09761 7.45694 5.01851 7.44566 4.94101C7.43438 4.86351 7.40103 4.7909 7.3496 4.73184L5.30793 2.38476C5.26852 2.34254 5.22084 2.30888 5.16787 2.28587C5.1149 2.26285 5.05777 2.25098 5.00001 2.25098C4.94226 2.25098 4.88512 2.26285 4.83215 2.28587C4.77918 2.30888 4.73151 2.34254 4.6921 2.38476L2.65043 4.73184C2.59899 4.7909 2.56564 4.86351 2.55436 4.94101C2.54308 5.01851 2.55435 5.09761 2.58682 5.16888C2.61929 5.24015 2.67159 5.30056 2.73747 5.34291C2.80335 5.38525 2.88003 5.40773 2.95835 5.40767H4.28293C4.31056 5.40767 4.33705 5.41865 4.35659 5.43818C4.37612 5.45772 4.3871 5.48421 4.3871 5.51184V7.79851C4.3871 7.96084 4.45158 8.11653 4.56637 8.23132C4.68116 8.3461 4.83684 8.41059 4.99918 8.41059C5.16151 8.41059 5.3172 8.3461 5.43199 8.23132C5.54677 8.11653 5.61126 7.96084 5.61126 7.79851V5.51184C5.61126 5.48421 5.62224 5.45772 5.64177 5.43818C5.66131 5.41865 5.6878 5.40767 5.71543 5.40767H7.04168Z"
        fill="#054637"
      />
    </g>
    <defs>
      <clipPath id="clip0_918_292">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DeleteIcon = ({ color = "#61707D" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 3H15"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 1H6.5C6.23478 1 5.98043 1.10536 5.79289 1.29289C5.60536 1.48043 5.5 1.73478 5.5 2V3H10.5V2C10.5 1.73478 10.3946 1.48043 10.2071 1.29289C10.0196 1.10536 9.76522 1 9.5 1Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 11.5V6.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 11.5V6.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5767 14.0827C12.5559 14.3327 12.4419 14.5659 12.2573 14.7358C12.0727 14.9057 11.8309 15 11.58 15H4.42067C4.16975 15 3.92798 14.9057 3.74336 14.7358C3.55874 14.5659 3.44474 14.3327 3.424 14.0827L2.5 3H13.5L12.5767 14.0827Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BillingInfoIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
      stroke="#495867"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 6.66602H10.0083"
      stroke="#495867"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.16669 10H10V13.3333H10.8334"
      stroke="#495867"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InstagramIcon = () => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.1" cx="23" cy="23" r="23" fill="#495867" />
    <g clipPath="url(#clip0_1439_9349)">
      <path
        d="M23.3802 17.1612C20.1505 17.1612 17.5455 19.7663 17.5455 22.996C17.5455 26.2257 20.1505 28.8308 23.3802 28.8308C26.6099 28.8308 29.215 26.2257 29.215 22.996C29.215 19.7663 26.6099 17.1612 23.3802 17.1612ZM23.3802 26.7894C21.2931 26.7894 19.5869 25.0882 19.5869 22.996C19.5869 20.9038 21.288 19.2026 23.3802 19.2026C25.4724 19.2026 27.1736 20.9038 27.1736 22.996C27.1736 25.0882 25.4673 26.7894 23.3802 26.7894ZM30.8146 16.9226C30.8146 17.6792 30.2052 18.2835 29.4537 18.2835C28.697 18.2835 28.0927 17.6741 28.0927 16.9226C28.0927 16.171 28.7021 15.5616 29.4537 15.5616C30.2052 15.5616 30.8146 16.171 30.8146 16.9226ZM34.6791 18.3038C34.5927 16.4808 34.1763 14.8659 32.8408 13.5354C31.5103 12.205 29.8955 11.7886 28.0724 11.6972C26.1935 11.5905 20.5619 11.5905 18.683 11.6972C16.865 11.7835 15.2501 12.1999 13.9146 13.5304C12.5791 14.8608 12.1677 16.4757 12.0763 18.2987C11.9697 20.1776 11.9697 25.8093 12.0763 27.6882C12.1626 29.5112 12.5791 31.1261 13.9146 32.4565C15.2501 33.787 16.8599 34.2034 18.683 34.2948C20.5619 34.4015 26.1935 34.4015 28.0724 34.2948C29.8955 34.2085 31.5103 33.7921 32.8408 32.4565C34.1712 31.1261 34.5876 29.5112 34.6791 27.6882C34.7857 25.8093 34.7857 20.1827 34.6791 18.3038ZM32.2517 29.7042C31.8556 30.6995 31.0888 31.4663 30.0884 31.8675C28.5904 32.4616 25.0357 32.3245 23.3802 32.3245C21.7248 32.3245 18.165 32.4565 16.672 31.8675C15.6767 31.4714 14.9099 30.7046 14.5087 29.7042C13.9146 28.2062 14.0517 24.6515 14.0517 22.996C14.0517 21.3405 13.9197 17.7808 14.5087 16.2878C14.9048 15.2925 15.6716 14.5257 16.672 14.1245C18.1701 13.5304 21.7248 13.6675 23.3802 13.6675C25.0357 13.6675 28.5955 13.5354 30.0884 14.1245C31.0837 14.5206 31.8505 15.2874 32.2517 16.2878C32.8458 17.7858 32.7087 21.3405 32.7087 22.996C32.7087 24.6515 32.8458 28.2112 32.2517 29.7042Z"
        fill="#495867"
      />
    </g>
    <defs>
      <clipPath id="clip0_1439_9349">
        <rect
          width="22.75"
          height="26"
          fill="white"
          transform="translate(12 10)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const TwitterIcon = () => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.1" cx="23" cy="23" r="23" fill="#495867" />
    <path
      d="M30.1497 19.3328C30.1612 19.4927 30.1612 19.6527 30.1612 19.8125C30.1612 24.6894 26.4493 30.3087 19.665 30.3087C17.5749 30.3087 15.6333 29.7034 14 28.6527C14.297 28.6869 14.5825 28.6983 14.8909 28.6983C16.6154 28.6983 18.203 28.1159 19.4708 27.1222C17.849 27.0879 16.4898 26.0257 16.0216 24.5638C16.25 24.598 16.4784 24.6209 16.7183 24.6209C17.0495 24.6209 17.3807 24.5752 17.6891 24.4953C15.9987 24.1526 14.7309 22.6679 14.7309 20.8747V20.8291C15.222 21.1032 15.7931 21.2745 16.3984 21.2973C15.4048 20.6348 14.7538 19.5042 14.7538 18.225C14.7538 17.5397 14.9365 16.9115 15.2563 16.3633C17.0723 18.6019 19.802 20.0638 22.8629 20.2237C22.8058 19.9496 22.7715 19.6641 22.7715 19.3785C22.7715 17.3455 24.4162 15.6895 26.4606 15.6895C27.5228 15.6895 28.4822 16.1349 29.156 16.8544C29.9898 16.6945 30.7893 16.3861 31.4974 15.9636C31.2233 16.8202 30.6408 17.5397 29.8756 17.9965C30.618 17.9166 31.3375 17.711 31.9999 17.4255C31.4975 18.1564 30.8693 18.8074 30.1497 19.3328Z"
      fill="#495867"
    />
  </svg>
);

export const YouTubeIcon = () => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.1" cx="23" cy="23" r="23" fill="#495867" />
    <path
      d="M32.0853 18.3089C31.8672 17.4877 31.2246 16.841 30.4088 16.6215C28.9299 16.2227 23 16.2227 23 16.2227C23 16.2227 17.0702 16.2227 15.5913 16.6215C14.7755 16.841 14.1329 17.4877 13.9148 18.3089C13.5186 19.7973 13.5186 22.9028 13.5186 22.9028C13.5186 22.9028 13.5186 26.0083 13.9148 27.4967C14.1329 28.3179 14.7755 28.9377 15.5913 29.1572C17.0702 29.556 23 29.556 23 29.556C23 29.556 28.9299 29.556 30.4088 29.1572C31.2246 28.9377 31.8672 28.3179 32.0853 27.4967C32.4815 26.0083 32.4815 22.9028 32.4815 22.9028C32.4815 22.9028 32.4815 19.7973 32.0853 18.3089ZM21.0606 25.7223V20.0832L26.0169 22.9029L21.0606 25.7223Z"
      fill="#495867"
    />
  </svg>
);

export const FacebookIcon = () => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.1" cx="23" cy="23" r="23" fill="#495867" />
    <g clipPath="url(#clip0_1439_9358)">
      <path
        d="M27.4678 23.8L28.001 20.3253H24.6669V18.0704C24.6669 17.1198 25.1326 16.1931 26.6259 16.1931H28.1416V13.2348C28.1416 13.2348 26.7661 13 25.451 13C22.7053 13 20.9105 14.6643 20.9105 17.677V20.3253H17.8584V23.8H20.9105V32.2H24.6669V23.8H27.4678Z"
        fill="#495867"
      />
    </g>
    <defs>
      <clipPath id="clip0_1439_9358">
        <rect
          width="12"
          height="19.2"
          fill="white"
          transform="translate(17 13)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const TikTokIcon = () => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.1" cx="23" cy="23" r="23" fill="#495867" />
    <g clipPath="url(#clip0_1463_7643)">
      <path
        d="M30.7501 21.3796C29.2023 21.3834 27.6925 20.9007 26.4339 19.9998V26.2829C26.4335 27.4466 26.0778 28.5824 25.4144 29.5385C24.751 30.4946 23.8116 31.2254 22.7216 31.6332C21.6317 32.0409 20.4433 32.1062 19.3152 31.8203C18.1872 31.5344 17.1734 30.9109 16.4092 30.0332C15.6451 29.1555 15.1671 28.0655 15.0393 26.9088C14.9114 25.7522 15.1396 24.584 15.6936 23.5606C16.2475 22.5372 17.1007 21.7073 18.139 21.1818C19.1773 20.6564 20.3513 20.4605 21.504 20.6203V23.7805C20.9765 23.6146 20.4101 23.6196 19.8856 23.7947C19.3612 23.9699 18.9055 24.3064 18.5836 24.756C18.2618 25.2056 18.0903 25.7455 18.0935 26.2984C18.0968 26.8513 18.2747 27.3891 18.6018 27.8349C18.9289 28.2807 19.3885 28.6118 19.915 28.7808C20.4415 28.9498 21.0079 28.9481 21.5334 28.776C22.0589 28.6039 22.5165 28.2701 22.841 27.8224C23.1655 27.3747 23.3402 26.8358 23.3402 26.2829V14H26.4339C26.4318 14.2613 26.4537 14.5222 26.4993 14.7794C26.6068 15.3537 26.8304 15.9 27.1562 16.3849C27.4821 16.8698 27.9035 17.2832 28.3946 17.5996C29.0933 18.0616 29.9125 18.3079 30.7501 18.3077V21.3796Z"
        fill="#495867"
      />
    </g>
    <defs>
      <clipPath id="clip0_1463_7643">
        <rect
          width="15.75"
          height="18"
          fill="white"
          transform="translate(15 14)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const UploadImageIcon = () => (
  <svg
    width="94"
    height="94"
    viewBox="0 0 94 94"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="94" height="94" rx="6" fill="#F2F2F2" />
    <g opacity="0.9" clipPath="url(#clip0_1219_3055)">
      <path
        d="M44.6251 33.9375C44.6251 35.5122 43.9996 37.0224 42.8861 38.1359C41.7726 39.2494 40.2624 39.875 38.6876 39.875C37.1129 39.875 35.6027 39.2494 34.4892 38.1359C33.3757 37.0224 32.7501 35.5122 32.7501 33.9375C32.7501 32.3628 33.3757 30.8526 34.4892 29.7391C35.6027 28.6256 37.1129 28 38.6876 28C40.2624 28 41.7726 28.6256 42.8861 29.7391C43.9996 30.8526 44.6251 32.3628 44.6251 33.9375ZM54.6595 43.5634C54.4368 43.4518 54.1846 43.4131 53.9387 43.4527C53.6928 43.4924 53.4655 43.6084 53.2891 43.7843L44.4779 54.9705L38.1604 48.387C37.9323 48.2351 37.6587 48.1668 37.386 48.1937C37.1133 48.2205 36.8582 48.3408 36.6641 48.5343L28.0049 58.875V63.625C28.0049 64.2549 28.2551 64.859 28.7005 65.3044C29.1459 65.7498 29.75 66 30.3799 66H63.6299C63.9418 66 64.2506 65.9386 64.5388 65.8192C64.8269 65.6999 65.0887 65.5249 65.3093 65.3044C65.5298 65.0838 65.7047 64.822 65.8241 64.5339C65.9435 64.2457 66.0049 63.9369 66.0049 63.625V52.9375L54.6595 43.5634Z"
        fill="#4C9DAD"
      />
    </g>
    <defs>
      <clipPath id="clip0_1219_3055">
        <rect
          width="38"
          height="38"
          fill="white"
          transform="translate(28 28)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const UploadPlusIcon = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="17" cy="17" r="17" fill="white" />
    <circle cx="17" cy="17" r="13" fill="#4C9DAD" />
    <path
      d="M10.875 17C10.875 17.2031 10.9557 17.3978 11.0992 17.5414C11.2428 17.685 11.4376 17.7656 11.6406 17.7656H16.1068C16.1406 17.7656 16.1731 17.7791 16.197 17.803C16.2209 17.8269 16.2344 17.8594 16.2344 17.8932V22.3594C16.2344 22.5624 16.315 22.7572 16.4586 22.9008C16.6022 23.0443 16.7969 23.125 17 23.125C17.2031 23.125 17.3978 23.0443 17.5414 22.9008C17.685 22.7572 17.7656 22.5624 17.7656 22.3594V17.8932C17.7656 17.8594 17.7791 17.8269 17.803 17.803C17.8269 17.7791 17.8594 17.7656 17.8932 17.7656H22.3594C22.5624 17.7656 22.7572 17.685 22.9008 17.5414C23.0443 17.3978 23.125 17.2031 23.125 17C23.125 16.7969 23.0443 16.6022 22.9008 16.4586C22.7572 16.315 22.5624 16.2344 22.3594 16.2344H17.8932C17.8594 16.2344 17.8269 16.2209 17.803 16.197C17.7791 16.1731 17.7656 16.1406 17.7656 16.1068V11.6406C17.7656 11.4376 17.685 11.2428 17.5414 11.0992C17.3978 10.9557 17.2031 10.875 17 10.875C16.7969 10.875 16.6022 10.9557 16.4586 11.0992C16.315 11.2428 16.2344 11.4376 16.2344 11.6406V16.1068C16.2344 16.1406 16.2209 16.1731 16.197 16.197C16.1731 16.2209 16.1406 16.2344 16.1068 16.2344H11.6406C11.4376 16.2344 11.2428 16.315 11.0992 16.4586C10.9557 16.6022 10.875 16.7969 10.875 17V17Z"
      fill="white"
    />
  </svg>
);

export const AevaBlueLogo = () => (
  <svg
    width="115"
    height="30"
    viewBox="0 0 115 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.68714 15.3707C5.95555 14.2859 6.52989 13.9518 7.40006 14.0196C8.2457 14.0874 9.10144 14.0329 10.2992 14.0329C9.4853 16.1314 8.77819 17.9555 8.00615 19.9498H19.975C17.1494 13.5467 14.4148 7.35023 11.5893 0.948718C13.1161 0.948718 14.4047 0.902414 15.6876 0.983446C15.982 1.00329 16.3803 1.38034 16.526 1.70942C20.3228 10.3004 24.0921 18.9064 27.8599 27.5139C27.9595 27.7421 27.997 28.0084 28.1283 28.4962C26.7285 28.4962 25.4514 28.5607 24.1844 28.4499C23.8828 28.4235 23.4658 27.8678 23.3647 27.4693C22.6331 24.6166 21.0111 23.9287 18.5146 24.1188C14.803 24.4016 11.0611 24.2098 7.33368 24.1784C6.53566 24.1701 6.08254 24.4049 5.71889 25.3178C4.42734 28.5706 4.38837 28.5508 1.25691 28.5094C0.916348 28.5028 0.575785 28.4631 0 28.4218C1.93371 23.9832 3.7895 19.72 5.68714 15.3625V15.3707Z"
      fill="url(#paint0_linear_5362_15675)"
    />
    <path
      d="M112.436 22.6899C113.279 24.6032 114.079 26.4223 115.001 28.5093C113.475 28.5093 112.229 28.5721 110.995 28.4663C110.683 28.4398 110.234 27.9288 110.142 27.5468C109.422 24.5966 107.735 23.9384 105.208 24.1237C101.533 24.3965 97.8326 24.2146 94.1427 24.1782C93.3086 24.17 92.8151 24.3899 92.4312 25.3606C91.1584 28.5854 91.1094 28.5639 87.9476 28.5093C87.6142 28.5027 87.2809 28.4498 86.7715 28.4002C87.8307 25.9212 88.8134 23.5978 89.812 21.2892C90.6966 19.2452 91.6433 17.2326 92.4774 15.1572C92.8324 14.2742 93.3115 13.9633 94.1196 14.0178C94.9696 14.0741 95.8253 14.0311 97.0303 14.0311C96.2236 16.123 95.5194 17.9437 94.7473 19.948H106.709C103.888 13.5548 101.156 7.36165 98.3276 0.953521C99.8803 0.953521 101.207 0.915486 102.525 0.986595C102.784 0.999825 103.124 1.38018 103.257 1.69273C106.318 8.65154 109.357 15.6236 112.436 22.6833H112.435V22.6899H112.436Z"
      fill="url(#paint1_linear_5362_15675)"
    />
    <path
      d="M75.747 10.859C77.0126 8.01957 78.2378 5.2678 79.4456 2.50776C79.7501 1.8132 80.1167 1.40308 80.8829 1.46757C81.9292 1.55687 82.984 1.48907 84.15 1.48907C84.062 1.93557 84.0591 2.24812 83.9466 2.5028C80.1816 11.1054 76.4152 19.703 72.6228 28.2841C72.4771 28.6149 72.0831 28.9969 71.7887 29.0167C70.5029 29.0978 69.2143 29.0515 67.6875 29.0515C70.4178 22.8831 73.0586 16.9116 75.747 10.8557V10.859Z"
      fill="url(#paint2_linear_5362_15675)"
    />
    <path
      d="M36.5136 9.63047C35.6694 9.70819 35.2148 9.47171 34.88 8.56879C34.0301 6.27674 33.0315 4.05912 32.0098 1.61328H52.9386C52.9386 2.71796 53.005 3.87225 52.8895 5.00504C52.8636 5.25971 52.2012 5.60369 51.8303 5.60699C47.7464 5.64999 43.6611 5.63345 39.5772 5.63345H37.9263C38.4516 7.03249 38.8831 8.18347 39.4243 9.62716H36.5107H36.5121V9.63047H36.5136Z"
      fill="url(#paint3_linear_5362_15675)"
    />
    <path
      d="M52.1724 28.5213C45.781 28.5213 39.5022 28.5014 33.222 28.5428C32.2652 28.5494 31.9174 28.26 31.9449 27.109C32.0127 24.0199 31.7573 24.3854 34.3808 24.3837C40.0333 24.3754 45.6843 24.3837 51.3368 24.3837C52.5634 24.3837 53.1753 25.108 53.1753 26.5583C53.1753 26.8742 53.1536 27.19 53.1811 27.5042C53.2402 28.2666 52.9372 28.5891 52.1767 28.5279V28.5213H52.1724Z"
      fill="url(#paint4_linear_5362_15675)"
    />
    <path
      d="M38.3333 12.8335H51.5604C51.5604 14.0821 51.6268 15.2347 51.5085 16.3609C51.4825 16.6123 50.8129 16.9496 50.4363 16.9562C46.3163 16.9992 42.1978 16.9827 38.0793 16.9827C36.6665 16.9827 35.2538 16.9678 33.841 16.9893C33.1094 17.0025 32.7587 16.6784 32.776 15.797C32.8409 12.2398 32.3618 12.9013 35.2725 12.8368C36.2538 12.8153 37.2322 12.8352 38.3318 12.8352H38.3347L38.3333 12.8335Z"
      fill="url(#paint5_linear_5362_15675)"
    />
    <path
      d="M66.5206 15.6695C66.9766 16.7047 67.4023 17.6456 67.9463 18.8562C66.6187 18.8562 65.5075 18.8975 64.4021 18.8231C64.1756 18.8099 63.8927 18.4196 63.7629 18.1285C61.3789 12.7854 59.0137 7.43068 56.65 2.07762C56.6211 2.01312 56.6558 1.91059 56.663 1.71546C57.6702 1.71546 58.6919 1.63442 59.6934 1.75845C60.0542 1.80476 60.4972 2.26614 60.6834 2.6713C62.643 6.95772 64.558 11.2689 66.522 15.6662H66.5206V15.6695Z"
      fill="url(#paint6_linear_5362_15675)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5362_15675"
        x1="-8.51857"
        y1="37.269"
        x2="9.32039"
        y2="-36.3992"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2F6873" />
        <stop offset="1" stopColor="#59C4D9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5362_15675"
        x1="-8.51857"
        y1="37.269"
        x2="9.32039"
        y2="-36.3992"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2F6873" />
        <stop offset="1" stopColor="#59C4D9" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5362_15675"
        x1="-8.51857"
        y1="37.269"
        x2="9.32039"
        y2="-36.3992"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2F6873" />
        <stop offset="1" stopColor="#59C4D9" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5362_15675"
        x1="-8.51857"
        y1="37.269"
        x2="9.32039"
        y2="-36.3992"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2F6873" />
        <stop offset="1" stopColor="#59C4D9" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_5362_15675"
        x1="-8.51857"
        y1="37.269"
        x2="9.32039"
        y2="-36.3992"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2F6873" />
        <stop offset="1" stopColor="#59C4D9" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_5362_15675"
        x1="-8.51857"
        y1="37.269"
        x2="9.32039"
        y2="-36.3992"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2F6873" />
        <stop offset="1" stopColor="#59C4D9" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_5362_15675"
        x1="-8.51857"
        y1="37.269"
        x2="9.32039"
        y2="-36.3992"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2F6873" />
        <stop offset="1" stopColor="#59C4D9" />
      </linearGradient>
    </defs>
  </svg>
);

export const AevaGreenLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="30"
    viewBox="0 0 300 60"
    fill="none"
  >
    <g clipPath="url(#clip0_74_1549)">
      <path
        d="M71.0635 30.9619C67.1752 39.8908 63.287 48.8196 59.2417 58.1155C60.4441 58.2021 61.1571 58.2852 61.8731 58.299C68.426 58.3856 68.5166 58.4236 71.2145 51.6171C71.9758 49.706 72.9275 49.2143 74.5952 49.2316C82.4018 49.3043 90.2296 49.7025 98.003 49.107C103.23 48.7054 106.616 50.1526 108.157 56.1213C108.372 56.9557 109.245 58.1224 109.873 58.1744C112.523 58.4063 115.199 58.2713 118.13 58.2713C117.858 57.25 117.779 56.6926 117.568 56.2148C109.68 38.1943 101.782 20.1773 93.8399 2.19145C93.5347 1.50248 92.7039 0.709652 92.0846 0.671568C89.4018 0.501923 86.7039 0.598863 83.5045 0.598863C89.4199 14.0008 95.145 26.9735 101.06 40.3789H76.003C77.6224 36.2001 79.0997 32.3814 80.8036 27.9914C78.2961 27.9914 76.5136 28.1056 74.7341 27.9637C72.9033 27.8183 71.71 28.5211 71.0604 30.9792"
        fill="#064737"
      />
      <path
        d="M294.541 45.9046C288.172 31.3116 281.809 16.7152 275.408 2.1465C275.121 1.50254 274.411 0.706244 273.876 0.66816C271.115 0.52275 268.344 0.598917 265.087 0.598917C271.006 14.0182 276.728 26.9839 282.634 40.3651H257.592C259.211 36.1725 260.686 32.3503 262.371 27.9776C259.852 27.9776 258.06 28.0745 256.278 27.9499C254.589 27.8356 253.583 28.4831 252.84 30.3353C251.093 34.6734 249.109 38.8833 247.26 43.1729C245.166 48.0096 243.115 52.8704 240.894 58.0602C241.961 58.1606 242.661 58.2748 243.356 58.2887C249.979 58.4029 250.075 58.4479 252.743 51.6968C253.547 49.6575 254.577 49.2005 256.326 49.2213C264.048 49.3009 271.797 49.6783 279.492 49.1071C284.782 48.7158 288.314 50.0903 289.822 56.2737C290.021 57.0735 290.957 58.1398 291.607 58.1987C294.193 58.4168 296.8 58.2887 299.994 58.2887C298.063 53.9091 296.386 50.1007 294.544 45.908"
        fill="#064737"
      />
      <path
        d="M217.713 21.5069C212.181 34.0087 206.655 46.5036 200.939 59.4208C204.136 59.4208 206.834 59.5178 209.526 59.3481C210.142 59.3066 210.967 58.5138 211.272 57.8144C219.211 39.8424 227.103 21.8427 234.979 3.83952C235.211 3.30635 235.226 2.652 235.405 1.71722C232.961 1.71722 230.752 1.85917 228.565 1.67221C226.961 1.53719 226.193 2.3958 225.556 3.8499C223.024 9.62823 220.465 15.3858 217.71 21.5069"
        fill="#064737"
      />
      <path
        d="M135.891 18.7544H141.761C140.625 15.7354 139.722 13.3257 138.625 10.3933H142.082C150.632 10.3933 159.184 10.4244 167.734 10.3379C168.514 10.3344 169.894 9.60738 169.952 9.07767C170.193 6.70956 170.054 4.28952 170.054 1.97681H126.239C128.375 7.09386 130.465 11.7435 132.248 16.5386C132.949 18.4255 133.894 18.9206 135.888 18.7613"
        fill="#064737"
      />
      <path
        d="M168.692 58.3026C170.055 58.4376 170.686 57.7556 170.562 56.1595C170.514 55.5017 170.55 54.8404 170.55 54.1792C170.55 51.1429 169.269 49.6264 166.701 49.6264C154.867 49.6264 143.036 49.6126 131.203 49.6264C125.71 49.6264 126.248 48.8648 126.103 55.3321C126.049 57.7417 126.777 58.3476 128.777 58.3337C141.922 58.2472 155.073 58.2887 168.68 58.2887"
        fill="#064737"
      />
      <path
        d="M139.224 25.4502C137.169 25.4502 135.121 25.4087 133.067 25.4537C126.973 25.5956 127.976 24.2038 127.84 31.6509C127.804 33.4928 128.538 34.1748 130.07 34.1471C133.027 34.0952 135.982 34.1333 138.943 34.1333C147.568 34.1333 156.191 34.1644 164.813 34.0779C165.601 34.0744 167.003 33.3647 167.058 32.8315C167.305 30.4669 167.166 28.0503 167.166 25.4468H139.227"
        fill="#064737"
      />
      <path
        d="M190.831 12.114C189.553 9.275 188.296 6.42566 186.979 3.61093C186.643 2.89427 186.127 1.76907 185.652 1.74137C182.707 1.56826 179.749 1.65482 176.716 1.65482C176.816 2.48919 176.785 2.80425 176.888 3.03275C181.967 14.4994 187.042 25.9625 192.166 37.398C192.477 38.087 193.115 39.046 193.631 39.0737C196.538 39.2364 199.45 39.1533 202.967 39.1533C198.752 29.8021 194.858 21.1536 190.834 12.114H190.831Z"
        fill="#064737"
      />
      <path
        d="M71.1451 30.7647C71.707 28.4935 72.9095 27.7941 74.7312 27.9361C76.5016 28.078 78.2932 27.9638 80.8007 27.9638C79.0968 32.3572 77.6164 36.176 76.0001 40.3513H101.057C95.1421 26.9459 89.417 13.9732 83.5016 0.571275C86.698 0.571275 89.3959 0.474335 92.0817 0.64398C92.698 0.685526 93.5318 1.4749 93.837 2.16386C101.786 20.1497 109.677 38.1667 117.565 56.1872C117.774 56.665 117.852 57.2224 118.127 58.2437C115.196 58.2437 112.523 58.3787 109.87 58.1468C109.239 58.0914 108.366 56.9281 108.154 56.0937C106.622 50.1215 103.227 48.6813 98.0001 49.0794C90.2297 49.6714 82.3959 49.2698 74.5922 49.204C72.9215 49.1867 71.9729 49.6784 71.2116 51.5895C68.5077 58.3995 68.4261 58.358 61.8702 58.2714C61.1572 58.2576 60.4442 58.1745 59.2388 58.0879C63.2871 48.7955 67.1723 39.8701 71.1451 30.7473V30.7647Z"
        fill="#064737"
      />
      <path
        d="M294.631 46.088C296.396 50.0937 298.07 53.9021 300 58.2713C296.807 58.2713 294.196 58.4029 291.613 58.1813C290.961 58.1259 290.021 57.0561 289.828 56.2564C288.32 50.0799 284.789 48.702 279.499 49.0897C271.804 49.661 264.057 49.2801 256.332 49.204C254.586 49.1867 253.553 49.6471 252.749 51.6794C250.085 58.4306 249.982 58.3856 243.363 58.2713C242.665 58.2575 241.967 58.1467 240.9 58.0428C243.118 52.8531 245.175 47.9888 247.266 43.1556C249.118 38.8764 251.1 34.663 252.846 30.318C253.589 28.4692 254.592 27.8183 256.284 27.9325C258.064 28.0502 259.855 27.9602 262.378 27.9602C260.689 32.3399 259.215 36.1517 257.598 40.3478H282.641C276.734 26.9631 271.015 13.9974 265.094 0.581575C268.345 0.581575 271.121 0.501945 273.882 0.650818C274.423 0.678515 275.136 1.47481 275.414 2.12915C281.822 16.6979 288.184 31.2943 294.631 46.0742H294.628V46.088H294.631Z"
        fill="#064737"
      />
      <path
        d="M217.822 21.3198C220.471 15.3753 223.036 9.61431 225.565 3.83599C226.203 2.38189 226.97 1.52327 228.574 1.6583C230.764 1.84525 232.973 1.70331 235.414 1.70331C235.23 2.63809 235.224 3.29243 234.988 3.8256C227.106 21.8357 219.221 39.8354 211.281 57.8005C210.976 58.4929 210.151 59.2927 209.535 59.3342C206.843 59.5039 204.145 59.4069 200.949 59.4069C206.665 46.4931 212.193 33.9913 217.822 21.3129V21.3198Z"
        fill="#064737"
      />
      <path
        d="M135.677 18.7475C133.909 18.9102 132.958 18.4151 132.257 16.5248C130.477 11.7263 128.387 7.08353 126.248 1.96301H170.063C170.063 4.27573 170.202 6.69231 169.961 9.06388C169.906 9.59705 168.519 10.3172 167.743 10.3241C159.193 10.4141 150.64 10.3795 142.09 10.3795H138.634C139.734 13.3085 140.637 15.7181 141.77 18.7406H135.671H135.674V18.7475H135.677Z"
        fill="#064737"
      />
      <path
        d="M168.468 58.2956C155.088 58.2956 141.943 58.2541 128.795 58.3406C126.791 58.3545 126.063 57.7486 126.121 55.3389C126.263 48.8716 125.728 49.6368 131.22 49.6333C143.054 49.616 154.885 49.6333 166.719 49.6333C169.287 49.6333 170.568 51.1497 170.568 54.186C170.568 54.8473 170.523 55.5086 170.58 56.1664C170.704 57.7624 170.069 58.4376 168.477 58.3095V58.2956H168.468Z"
        fill="#064737"
      />
      <path
        d="M139.486 25.4502H167.178C167.178 28.0641 167.317 30.4772 167.069 32.835C167.015 33.3612 165.613 34.0675 164.825 34.0813C156.199 34.1714 147.577 34.1367 138.955 34.1367C135.997 34.1367 133.039 34.1056 130.081 34.1506C128.55 34.1783 127.816 33.4997 127.852 31.6544C127.988 24.2073 126.985 25.5922 133.078 25.4571C135.133 25.4121 137.181 25.4537 139.483 25.4537H139.489L139.486 25.4502Z"
        fill="#064737"
      />
      <path
        d="M190.909 12.3044C194.87 21.1502 198.758 29.7917 202.973 39.1429C199.459 39.1429 196.544 39.2295 193.638 39.0633C193.121 39.0356 192.484 38.0801 192.172 37.3876C187.048 25.9487 181.973 14.489 176.894 3.02238C176.792 2.79041 176.819 2.47882 176.722 1.64444C179.752 1.64444 182.713 1.55789 185.659 1.73099C186.133 1.75869 186.65 2.88389 186.985 3.60055C188.302 6.41182 189.559 9.26463 190.909 12.294M198.435 31.1869C194.399 22.175 190.387 13.1492 186.287 4.17527C185.897 3.32704 184.97 2.35418 184.215 2.26417C182.118 2.0045 179.979 2.17415 177.87 2.17415C177.849 2.57922 177.783 2.79041 177.843 2.93236C182.792 14.1463 187.746 25.3532 192.734 36.536C193.006 37.1488 193.598 37.9554 194.073 37.9901C196.387 38.1459 198.713 38.0593 201.493 38.0593C200.354 35.5181 199.471 33.5516 198.432 31.1904H198.435V31.1869Z"
        fill="#064737"
      />
      <path
        d="M198.505 31.3912C199.459 33.5585 200.351 35.5285 201.49 38.0628C198.71 38.0628 196.384 38.1493 194.07 37.9935C193.595 37.9658 193.003 37.1488 192.731 36.5394C187.74 25.3532 182.789 14.1428 177.84 2.93582C177.78 2.80079 177.852 2.58614 177.867 2.17761C179.976 2.17761 182.115 2.00796 184.212 2.26762C184.967 2.36456 185.894 3.3305 186.284 4.17873C190.387 13.1526 194.396 22.1784 198.508 31.3843H198.505V31.3912Z"
        fill="#064737"
      />
      <path
        d="M34.2475 0.820497C36.0632 1.27404 37.8155 1.96993 39.5194 2.82162C39.2777 3.45865 38.9877 4.06799 38.7188 4.68772C38.2898 4.50768 37.882 4.28611 37.459 4.09569C32.3442 1.7622 26.5617 1.49908 21.2717 3.20245C20.8669 3.33748 20.4681 3.48289 20.0602 3.60753C19.8487 2.92894 19.6101 2.26767 19.4258 1.57871C20.2566 1.3052 21.0874 1.0213 21.9364 0.820497C25.9666 -0.266617 30.2173 -0.283928 34.2475 0.820497Z"
        fill="#064737"
      />
      <path
        d="M17.0605 0.294278C17.2508 0.733971 17.4351 1.1702 17.6224 1.60989C17.0514 1.9665 16.4713 2.30232 15.8943 2.64508C14.6224 3.41021 13.4079 4.29652 12.2327 5.23822C9.54082 7.46439 7.1662 10.2099 5.30819 13.3639C3.48946 16.3794 2.28402 19.897 1.71 23.4941C1.40789 25.4814 1.30215 27.5068 1.37768 29.5183C1.51967 32.8523 2.13599 36.1898 3.25381 39.2711C4.0091 41.4938 5.04535 43.5365 6.25985 45.4718C7.31121 47.106 8.49248 48.7089 9.86408 50.0073C9.55593 50.4158 9.22662 50.807 8.93357 51.2329C7.71303 49.9796 6.61937 48.5912 5.60426 47.1129C3.30517 43.6715 1.64656 39.6727 0.758343 35.4593C-0.0150705 31.9314 -0.193318 28.2269 0.205473 24.6089C0.341425 23.186 0.613328 21.7942 0.954718 20.4163C1.28704 19.2045 1.63448 17.972 2.10275 16.8156C3.09067 14.2502 4.41695 11.9029 5.98191 9.75286C6.72209 8.68999 7.57405 7.71712 8.43206 6.76503C10.3384 4.76045 12.4592 2.99129 14.7372 1.58912C15.4985 1.13212 16.2629 0.650879 17.0635 0.287354V0.294278H17.0605Z"
        fill="#064737"
      />
      <path
        d="M18.3475 2.51697C18.4623 2.79048 18.5771 3.06052 18.6979 3.33403C17.991 3.68025 17.3203 4.10956 16.6224 4.48347C16.4955 4.21688 16.3747 3.94683 16.2568 3.67332C16.9517 3.27518 17.6164 2.84241 18.3414 2.52043H18.3475V2.51697Z"
        fill="#064737"
      />
      <path
        d="M40.1722 3.29248C40.3867 3.3548 40.58 3.4829 40.7764 3.60061C42.0272 4.3519 43.2266 5.2209 44.3655 6.17645C45.6767 7.25318 46.8701 8.55494 47.9637 9.90518C48.0544 10.009 47.9214 10.1233 47.858 10.1925C47.4169 10.6149 46.9547 11.0131 46.5196 11.4389C46.2235 11.1031 45.9426 10.7534 45.6586 10.4037C43.8308 8.24681 41.6918 6.43957 39.3232 5.14127C39.6133 4.52847 39.8942 3.9122 40.1722 3.29248Z"
        fill="#064737"
      />
      <path
        d="M35.0546 4.78125C36.8341 5.43559 38.5743 6.35306 40.1241 7.55097C41.8401 8.89774 43.3024 10.5873 44.2268 12.7442C44.7283 14.0009 45.0577 15.3235 45.1 16.7118C45.1543 18.1417 45.0607 19.5854 44.4776 20.8698C44.1755 21.5346 43.7374 22.0643 43.245 22.5455C43.5622 21.8946 43.7827 21.1988 43.8552 20.4544C44.0335 18.7476 43.9338 16.9888 43.532 15.3304C42.9912 13.3085 41.9126 11.5047 40.5048 10.1441C39.1725 8.86312 37.6438 7.82794 36.0486 7.05242C33.2631 5.68487 30.2691 4.82626 27.2299 4.8678C26.2631 4.87473 25.248 4.90589 24.3145 5.21748C26.1302 4.32078 28.1241 3.7703 30.109 3.81531C31.8129 3.83262 33.4293 4.22384 35.0546 4.77779V4.78125Z"
        fill="#064737"
      />
      <path
        d="M13.6494 5.5706C13.8065 5.83372 13.9576 6.10723 14.1147 6.37036C13.2174 7.03855 12.3987 7.80715 11.58 8.58959C11.018 9.14007 10.5014 9.72864 9.96666 10.3137C9.77632 10.0783 9.57995 9.85674 9.37451 9.63516C10.6343 8.0495 12.0784 6.72696 13.6525 5.56714H13.6494V5.5706Z"
        fill="#064737"
      />
      <path
        d="M9.10572 9.94666C9.36554 10.0228 9.56493 10.3898 9.77943 10.5768C9.04227 11.4215 8.3746 12.3494 7.7462 13.3049C7.11176 14.2466 6.574 15.268 6.0453 16.2928C5.78246 16.1335 5.52566 15.9673 5.2749 15.7942C6.20239 13.8589 7.36856 12.069 8.67974 10.4556C8.81569 10.2859 8.9456 10.099 9.10572 9.95704V9.94666Z"
        fill="#064737"
      />
      <path
        d="M24.8461 10.1544C25.1905 10.1059 25.5409 10.1267 25.8884 10.1302C25.9095 10.4625 25.9216 10.7984 25.9216 11.1377C25.7706 11.1446 25.6165 11.155 25.4654 11.1584C25.5198 11.4008 25.553 11.6466 25.55 11.8993C25.55 12.4221 25.5621 12.9414 25.55 13.4642C26.2539 13.4954 26.9307 13.6927 27.6225 13.8278C27.7071 13.2288 27.837 12.6402 27.9307 12.0378C27.976 12.0759 28.0213 12.1105 28.0697 12.1486C27.9518 12.7926 27.8491 13.4435 27.7434 14.0909C26.6104 13.7447 25.4443 13.5681 24.2721 13.6685C23.2902 13.7447 22.2872 13.9766 21.3869 14.444C21.3627 14.3471 21.3416 14.2501 21.3174 14.1532C21.8129 13.987 22.2932 13.7931 22.8068 13.6858C23.6588 13.4712 24.5319 13.4123 25.405 13.4573C25.408 12.6922 25.3567 11.9201 25.411 11.1584C25.2207 11.1584 25.0334 11.1584 24.84 11.1515C24.834 10.8226 24.8159 10.4868 24.8461 10.1579V10.1544Z"
        fill="#064737"
      />
      <path
        d="M22.6558 10.3691C22.7767 10.7604 22.8643 11.1793 22.9035 11.5947C22.7344 11.3732 22.7193 11.1066 22.6528 10.8296C22.6316 10.66 22.5561 10.5284 22.6558 10.3761V10.3691Z"
        fill="#064737"
      />
      <path
        d="M27.5923 10.4244C27.9911 10.4487 28.3929 10.5733 28.7856 10.646C28.7282 11.1376 28.6346 11.6189 28.559 12.1105C28.1512 12.0482 27.7524 11.9512 27.3506 11.8439C27.4352 11.3765 27.4533 10.8745 27.5893 10.4244H27.5923Z"
        fill="#064737"
      />
      <path
        d="M17.6375 10.7464C17.8701 11.0753 18.0454 11.4631 18.2085 11.8405C18.0997 11.9132 17.994 11.9824 17.8852 12.0551C18.0786 12.4152 18.2478 12.7891 18.4049 13.1734C19.1028 14.7729 19.8399 16.3516 20.5438 17.9442C21.0333 18.9863 21.4774 20.0492 22.0061 21.0671C22.2901 20.9182 22.568 20.759 22.8671 20.6447C23.7583 20.2846 24.7583 20.2431 25.6677 20.5512C27.0605 21.0255 28.275 22.1127 28.8792 23.6464C29.0907 24.2315 29.275 24.8201 29.3324 25.4536C29.4562 26.6585 29.2719 27.9152 28.7342 28.9712C28.1088 30.2729 27.0484 31.2216 25.8278 31.6993C24.7644 32.1079 23.5801 32.0005 22.5469 31.5332C21.4623 30.9931 20.5348 30.0514 19.9849 28.85C19.6133 28.0295 19.3716 27.0947 19.3837 26.1668C19.3596 24.8858 19.7553 23.6568 20.3988 22.6216C20.7976 22.0088 21.3173 21.5795 21.8339 21.1156C21.5106 20.5685 21.2629 19.98 20.991 19.3983C20.5559 18.4393 20.1269 17.4734 19.6889 16.5178C19.139 15.3234 18.6315 14.1116 18.0756 12.9241C17.9577 12.6783 17.8641 12.4117 17.7855 12.1451C17.3565 12.3494 16.9698 12.6402 16.5499 12.8618C16.3867 12.5779 16.2417 12.2802 16.1118 11.9789C16.4411 11.6985 16.8037 11.4769 17.0997 11.1688C17.2689 10.9992 17.417 10.8191 17.6405 10.7395L17.6345 10.7464H17.6375Z"
        fill="#064737"
      />
      <path
        d="M30.5045 11.1273C30.7794 11.155 31.0544 11.2866 31.3263 11.3627C31.3021 11.4839 31.3293 11.5843 31.2115 11.6501C30.9063 11.5636 30.6133 11.4355 30.3232 11.3143C30.3686 11.2381 30.4048 11.11 30.5045 11.1273Z"
        fill="#064737"
      />
      <path
        d="M20.8038 11.2C20.9216 11.522 21.0032 11.8405 21.0636 12.1833C20.6648 12.3564 20.266 12.5399 19.8733 12.7338C19.7434 12.4049 19.6074 12.0967 19.6135 11.7228C19.683 11.8163 19.7555 11.9098 19.825 12.0033H20.1573C20.0304 12.1417 19.8129 12.1833 19.8642 12.4291C19.8824 12.6091 20.1029 12.5537 20.1966 12.4914C20.4382 12.3529 20.6739 12.2179 20.9247 12.1071L20.7766 11.3905C20.7162 11.3835 20.6528 11.3766 20.5923 11.3697C20.6497 11.5324 20.7102 11.6951 20.7645 11.8578H20.5802C20.5682 11.7228 20.5591 11.5843 20.547 11.4528C20.4322 11.5255 20.3234 11.5982 20.2056 11.664L19.9579 11.5393C20.2207 11.3697 20.5017 11.2727 20.7978 11.1931V11.207L20.8038 11.2Z"
        fill="#064737"
      />
      <path
        d="M30.1966 11.4977C30.5531 11.5981 30.9005 11.7643 31.254 11.8924C31.1362 12.294 31.0002 12.6783 30.8643 13.073C30.5078 12.9864 30.1664 12.841 29.8311 12.6783C29.9489 12.2836 30.0365 11.8716 30.1966 11.4943V11.4977Z"
        fill="#064737"
      />
      <path
        d="M17.5015 11.5497C17.577 11.7089 17.6435 11.8647 17.713 12.0275C17.3504 12.3183 16.9577 12.5191 16.5559 12.7199C16.4743 12.5295 16.3957 12.3356 16.3232 12.1348C16.4743 12.0309 16.6284 11.9478 16.7945 11.8786C16.858 12.0344 16.9214 12.1867 16.9879 12.3425C16.9426 12.1625 16.8973 11.9859 16.8489 11.8093C17.0604 11.7055 17.2689 11.5982 17.5015 11.5497Z"
        fill="#064737"
      />
      <path
        d="M20.2238 11.6743C20.3507 11.8301 20.4383 11.9097 20.4444 12.1382C20.3537 12.1002 20.2601 12.0655 20.1694 12.0275L20.2238 11.6743Z"
        fill="#064737"
      />
      <path
        d="M14.9306 12.7996C15.1512 13.0419 15.3808 13.2669 15.6225 13.4816C15.4986 13.7032 15.3717 13.9248 15.2358 14.1394C15.5711 14.496 15.846 14.9184 16.1059 15.3442C16.1965 15.2958 16.2932 15.2473 16.3868 15.2023C16.5167 15.3892 16.6527 15.5727 16.7917 15.7493C16.6859 15.8601 16.5802 15.964 16.4684 16.0748C16.3475 15.9363 16.2207 15.5243 16.0213 15.5935C15.3475 16.1855 14.7161 16.8745 14.1633 17.6154C13.8581 17.3592 13.553 17.1134 13.2418 16.8676C13.0605 16.7187 12.8793 16.5906 12.7705 16.3552C12.9578 16.3725 13.0817 16.4937 13.2267 16.6114C13.5318 16.8676 13.8279 17.1272 14.1391 17.3627C14.6799 16.6322 15.3053 15.9605 15.9941 15.41C15.6769 15.0257 15.3596 14.6449 15.13 14.181C14.9185 14.3506 14.7312 14.5445 14.5379 14.7453C14.2992 14.4995 14.0726 14.2398 13.8611 13.9594C14.1874 13.537 14.556 13.1665 14.9276 12.803H14.9306V12.7996Z"
        fill="#064737"
      />
      <path
        d="M14.5501 13.5162C14.7011 13.627 14.825 13.762 14.9428 13.9178C14.822 14.0632 14.7132 14.2259 14.5742 14.3471C14.4504 14.4233 14.3144 14.1879 14.2479 14.0909C14.1905 13.8832 14.4504 13.6616 14.544 13.5093V13.5162H14.5501Z"
        fill="#064737"
      />
      <path
        d="M41.8096 14.2883C42.3594 15.59 42.8307 16.9922 43.0241 18.4255C43.2084 19.7134 43.2386 21.0983 42.9606 22.3724C42.876 22.774 42.87 23.179 42.9606 23.5807C43.2356 24.7128 43.8337 25.6579 44.5588 26.475C44.9727 26.8905 45.4017 27.3232 45.873 27.6487C46.0603 27.7837 46.2627 27.9118 46.4229 28.0918C46.4924 28.5108 46.296 28.9885 46.0966 29.3278C45.7491 29.8541 45.2809 30.2868 44.7582 30.5603C44.444 30.73 44.1842 31.0104 44.163 31.4328C44.1056 31.8517 44.2235 32.1945 44.4047 32.5476C44.6253 32.9873 44.5981 33.5586 44.2597 33.9082C43.9546 34.2545 43.4954 34.1817 43.1056 34.1541C43.2688 33.5932 43.6736 33.1673 43.7733 32.6169C43.58 32.1668 43.3685 31.7859 43.3836 31.2528C43.3836 30.9066 43.5407 30.6088 43.7582 30.3872C43.9999 30.1414 44.3353 30.0306 44.6253 29.8645C45.0815 29.6117 45.4742 29.224 45.7038 28.7012C45.7431 28.6146 45.7522 28.5281 45.7401 28.4346C45.5618 28.2719 45.3564 28.1542 45.1721 28.0053C44.447 27.434 43.8096 26.7 43.2809 25.8899C42.7129 24.969 42.2899 23.9407 42.2507 22.7982C42.2053 22.0815 42.4017 21.4722 42.4652 20.7694C42.6555 19.1456 42.583 17.4907 42.2597 15.8947C42.1328 15.3511 41.9697 14.8145 41.8096 14.2848V14.2883Z"
        fill="#064737"
      />
      <path
        d="M29.8579 14.7971C30.9093 15.2749 31.864 16.1854 32.6525 17.1064C33.0724 17.5841 33.3927 18.1277 33.731 18.6816L33.6072 18.7509C32.7824 17.3418 31.6917 16.1577 30.4168 15.2991C30.2325 15.178 30.0301 15.081 29.8579 14.9425V14.8006V14.7971Z"
        fill="#064737"
      />
      <path
        d="M12.3054 14.8802C12.4504 15.313 12.7012 15.59 12.9852 15.9016C12.822 16.1578 12.6528 16.4036 12.4534 16.6286C12.2661 16.4417 12.0667 16.272 11.8945 16.0678C12.0214 15.7527 12.2692 15.5 12.4353 15.2022C12.39 15.1711 12.3386 15.1364 12.2933 15.1053C12.1785 15.1849 12.0637 15.2645 11.9489 15.3407C12.0667 15.1849 12.1815 15.0326 12.3054 14.8837V14.8802Z"
        fill="#064737"
      />
      <path
        d="M12.3565 15.6974C12.426 15.7459 12.4955 15.8013 12.562 15.8532V16.1267C12.4411 16.0298 12.3233 15.9294 12.2085 15.822C12.2568 15.777 12.3082 15.7355 12.3565 15.6974Z"
        fill="#064737"
      />
      <path
        d="M11.1448 16.743C11.3563 16.9057 11.5769 17.0511 11.8216 17.1446C12.0451 17.2173 12.1569 17.4042 12.3291 17.5739C12.2113 17.8405 12.1056 18.114 12.0149 18.3944C12.3624 18.5779 12.6886 18.8099 12.9998 19.0591C13.308 19.1111 13.5708 19.2738 13.8397 19.4434C13.7611 19.5542 13.6886 19.8174 13.5497 19.807C13.3382 19.7135 13.1358 19.575 12.9303 19.4677L13.0784 19.1872C12.6524 19.0765 12.3201 18.7787 11.9545 18.5121C11.8578 18.7268 11.7732 18.9518 11.6856 19.1734C11.1569 18.8826 10.4046 18.7441 9.95752 18.3148C10.0633 17.9201 10.2264 17.5358 10.4258 17.1965C10.4469 17.3281 10.4379 17.4839 10.4862 17.605C10.5497 17.6431 10.6101 17.6777 10.6766 17.7089C10.6766 17.5635 10.6766 17.4112 10.6766 17.2657C10.7188 17.4008 10.7611 17.5289 10.8034 17.6639C10.9122 17.3662 10.9636 16.9957 11.1448 16.7464V16.7395V16.743Z"
        fill="#064737"
      />
      <path
        d="M11.3294 17.1099C11.5499 17.2483 11.7614 17.3938 11.9849 17.5253C11.9064 17.7919 11.8188 18.0516 11.7312 18.3182C11.3958 18.1831 11.0756 18.0066 10.7402 17.875C10.849 17.785 10.9547 17.7019 11.0665 17.6153C11.1028 17.4526 11.136 17.2864 11.1753 17.1237C11.2297 17.1237 11.278 17.1168 11.3324 17.1168V17.1099H11.3294Z"
        fill="#064737"
      />
      <path
        d="M18.1449 17.5669C18.0603 17.7019 17.9667 17.83 17.8972 17.9754C17.9334 18.2662 18.1298 18.5398 18.2295 18.8167C18.4017 19.2807 18.6223 19.7134 18.8126 20.1635C18.0633 20.9875 17.4319 21.95 17.0362 23.0579C16.6102 24.2765 16.3383 25.6164 16.5195 26.932C15.9002 26.9251 15.2778 26.9182 14.6585 26.9078C14.4591 25.374 14.6827 23.7468 15.1177 22.2823C15.447 21.171 15.9697 20.1739 16.6041 19.2599C17.0543 18.6367 17.5558 18.017 18.1479 17.5669H18.1449Z"
        fill="#064737"
      />
      <path
        d="M27.5377 18.5882C28.3474 19.0868 29.1057 19.7861 29.6434 20.6413C29.5286 20.5686 29.4199 20.482 29.3322 20.3678C28.7945 19.6892 28.1389 19.1214 27.4199 18.7129C26.148 17.9546 24.728 17.7054 23.3081 17.8439L23.293 17.7469C24.7522 17.5634 26.2205 17.8023 27.5316 18.5882H27.5377Z"
        fill="#064737"
      />
      <path
        d="M28.8129 17.7192C28.9126 17.7053 28.9911 17.7573 29.0727 17.8092C30.0123 18.4739 30.8612 19.3499 31.4896 20.3954C31.6739 20.707 31.8672 20.9805 31.9307 21.3614C31.5893 20.9528 31.3899 20.4231 31.0485 20.0111C30.3808 19.1871 29.5863 18.4774 28.7041 17.9789C28.7373 17.8888 28.7675 17.7988 28.8098 17.7192H28.8129Z"
        fill="#064737"
      />
      <path
        d="M10.7733 17.9166C11.0603 18.1486 11.3081 18.3321 11.6615 18.3909C11.6132 18.5502 11.5618 18.706 11.5044 18.8653C11.4138 18.8479 11.3232 18.8341 11.2325 18.8168L11.1842 18.4463C11.1026 18.5363 11.0241 18.6264 10.9425 18.7198C10.8186 18.6402 10.6917 18.5571 10.5679 18.481C10.6313 18.2905 10.6978 18.1036 10.7703 17.9166H10.7733Z"
        fill="#064737"
      />
      <path
        d="M17.7312 18.1382C17.9245 18.6333 18.2267 19.1249 18.3475 19.6477C18.2448 19.8208 18.1058 19.9731 17.985 20.1358C17.414 20.8767 17.0001 21.7354 16.6708 22.6424C16.2387 23.9304 16.1149 25.2771 16.136 26.6447C15.6828 26.5927 15.2327 26.5962 14.7795 26.5997C14.6315 24.7924 14.9608 22.9229 15.6466 21.2922C16.139 20.1982 16.7765 19.1595 17.562 18.3113C17.6164 18.2559 17.6708 18.1936 17.7251 18.1382H17.7312Z"
        fill="#064737"
      />
      <path
        d="M11.0392 19.0487H11.1026L11.1359 19.1145L11.0996 19.1803H11.0362L11.0029 19.1145L11.0392 19.0487Z"
        fill="#064737"
      />
      <path
        d="M24.7493 19.7584C26.0938 19.883 27.4231 20.5374 28.3596 21.666C29.1028 22.5246 29.5681 23.6637 29.8037 24.8304C29.9639 25.6786 29.9276 26.5338 29.8007 27.382L29.6345 27.3439C29.6919 26.655 29.7524 25.9764 29.6738 25.284C29.4684 23.8126 28.8339 22.4312 27.8339 21.4687C27.0303 20.6655 26.0303 20.1738 24.9759 20.0284C24.5409 19.9419 24.1089 19.9973 23.6738 19.9626C23.6074 19.9176 23.5439 19.8657 23.4805 19.8138C23.8853 19.6822 24.3445 19.7203 24.7584 19.7584H24.7493Z"
        fill="#064737"
      />
      <path
        d="M9.71601 19.6926C10.0846 19.7896 10.4411 19.9073 10.8006 20.0458C10.7674 20.302 10.7341 20.5582 10.7009 20.8109C11.3625 20.9321 12.0121 21.126 12.6707 21.2679C12.5287 21.8807 12.3897 22.5039 12.3202 23.134C12.2145 23.9753 12.2145 24.8374 12.2659 25.6821C11.2568 25.7929 10.2598 25.9383 9.24471 26.018C9.21148 25.6891 9.17825 25.3602 9.13595 25.0347C9.41692 24.9412 9.70393 24.872 9.98792 24.7993L10.003 24.872C9.76133 24.9378 9.52568 25.007 9.28399 25.0763C9.31118 25.3152 9.34139 25.5575 9.36556 25.8033C10.2779 25.7098 11.1903 25.5679 12.1027 25.4917C12.0846 24.9655 12.0816 24.4358 12.1027 23.9061C11.4834 23.8334 10.861 23.7849 10.2357 23.7191C10.2689 24.2869 10.3958 24.8235 10.3807 25.3809C10.1964 24.8616 10.1752 24.2557 10.0846 23.7053C9.73414 23.7053 9.39275 23.6776 9.04834 23.6256C9.07553 23.546 9.10574 23.4629 9.13293 23.3833C10.1178 23.5391 11.1088 23.5668 12.0906 23.7295C12.1752 22.9574 12.2991 22.2165 12.4683 21.4618C11.855 21.2818 11.2387 21.1744 10.6375 20.9459C10.5831 21.1502 10.5559 21.3371 10.4169 21.486C10.4532 21.0636 10.5982 20.6655 10.6314 20.2396C10.3565 20.1046 10.0725 20.0042 9.77341 19.9419C9.76133 20.0631 9.74925 20.1843 9.73716 20.3124C9.86707 20.3539 10.003 20.392 10.1329 20.4335C10.0755 20.8386 10.0151 21.2437 9.96677 21.6557C10.1118 21.7007 10.2538 21.7457 10.3988 21.7907C10.3444 22.0677 10.2991 22.3516 10.2296 22.6216C9.85801 22.6147 9.48036 22.4554 9.11783 22.3654C9.23867 21.7526 9.35952 21.1156 9.54683 20.5235C9.63444 20.257 9.67372 19.98 9.71299 19.6996V19.6926H9.71601Z"
        fill="#064737"
      />
      <path
        d="M9.60714 20.4716C9.72798 20.4924 9.84883 20.5097 9.96968 20.527C9.91227 20.9598 9.85487 21.3925 9.82768 21.8288C9.95759 21.853 10.0905 21.8772 10.2204 21.9049L10.1358 22.4727C9.86393 22.3758 9.5165 22.355 9.27783 22.175C9.34128 21.6937 9.47723 21.2263 9.5588 20.7451C9.57693 20.6516 9.59203 20.5616 9.60714 20.4681V20.4716Z"
        fill="#064737"
      />
      <path
        d="M28.4228 23.733C27.8911 22.5317 26.9394 21.6073 25.8276 21.1745C25.1237 20.901 24.3382 20.8664 23.6041 20.9702C21.7793 21.2818 20.2415 23.0752 19.9304 25.1456C19.7884 26.0561 19.8397 27.0255 20.1237 27.8911C20.5195 29.1963 21.3835 30.318 22.4863 30.8928C23.3473 31.3671 24.3473 31.5125 25.2838 31.2874C26.3715 31.0693 27.3564 30.3042 28.0029 29.2967C29.0301 27.7145 29.1932 25.4987 28.4198 23.7365H28.4228V23.733ZM26.876 27.4618C26.5104 28.4035 25.7068 29.1063 24.8156 29.2482C23.9062 29.3833 22.9062 28.9609 22.3231 28.1369C21.9062 27.5622 21.6796 26.8351 21.7068 26.0838C21.6826 24.6401 22.6705 23.2553 23.9183 23.0198C24.6645 22.8813 25.447 23.0614 26.0452 23.6049C27.0542 24.4809 27.3956 26.1462 26.876 27.4652V27.4618Z"
        fill="#064737"
      />
      <path
        d="M10.6102 26.5754C10.7371 27.0151 10.8338 27.4652 10.9335 27.9118C10.8489 27.9603 10.7613 28.0088 10.6736 28.0572C10.7159 27.9672 10.7522 27.8737 10.7884 27.7768C10.7703 27.4167 10.6404 27.0601 10.5588 26.707C10.299 26.752 10.0815 26.8039 9.88512 27.0186C10.0332 27.3544 10.1147 27.7179 10.2144 28.078C10.0694 28.1161 9.9244 28.1507 9.7824 28.1888C9.69177 27.7491 9.58301 27.3163 9.53467 26.8663C9.89721 26.7485 10.2326 26.6066 10.6102 26.5789V26.5754Z"
        fill="#064737"
      />
      <path
        d="M31.2358 26.8558L31.3144 26.8281C31.1754 29.1374 30.2268 31.3358 28.5742 32.6999C28.7887 32.3364 29.109 32.0837 29.3688 31.7478C30.4443 30.4045 31.0788 28.6665 31.2389 26.8593H31.2358V26.8558Z"
        fill="#064737"
      />
      <path
        d="M10.5078 27.9742L10.5622 27.9326L10.6196 27.9638V28.0365L10.5652 28.078L10.5078 28.0469V27.9742Z"
        fill="#064737"
      />
      <path
        d="M10.3536 28.1022C10.4291 28.251 10.2086 28.3791 10.1904 28.1818C10.2237 28.0814 10.278 28.0502 10.3536 28.1022Z"
        fill="#064737"
      />
      <path
        d="M10.556 28.1368C10.704 28.0191 10.7675 28.2684 10.6134 28.3169C10.5258 28.2961 10.5077 28.2372 10.556 28.1368Z"
        fill="#064737"
      />
      <path
        d="M16.4111 28.2719C16.5803 30.3768 17.3084 32.4091 18.5289 34.0017C18.7525 34.2891 18.9881 34.5176 19.1634 34.8465C18.8582 34.6664 18.6498 34.3514 18.4141 34.0744C18.0607 34.4275 17.7072 34.7772 17.3597 35.1407C17.544 35.6047 18.0848 35.8055 18.2782 36.2452C17.7918 35.9682 17.3718 35.4904 16.9942 35.0507C16.1664 34.109 15.532 32.9423 15.0637 31.7236C14.8492 31.0485 14.6286 30.3526 14.541 29.6394C14.7011 29.6152 14.8582 29.5909 15.0184 29.5702C15.1845 30.7092 15.5138 31.8136 15.9579 32.8523C16.3205 33.6382 16.7162 34.386 17.251 35.0369C17.5652 34.6353 17.9247 34.2994 18.2752 33.9359C17.2298 32.5441 16.5712 30.7577 16.396 28.9366C16.3718 28.715 16.3597 28.4934 16.4171 28.2719H16.4081H16.4111Z"
        fill="#064737"
      />
      <path
        d="M12.7495 29.3625C12.9398 29.9822 13.0849 30.6088 13.3447 31.2009C13.5018 31.5956 13.7193 31.9141 13.8099 32.3191C13.6891 32.198 13.5864 32.0664 13.5078 31.9037C13.1634 31.1974 12.8855 30.46 12.7223 29.6671C12.6981 29.5356 12.7012 29.4767 12.7495 29.359V29.3625Z"
        fill="#064737"
      />
      <path
        d="M11.3533 29.7122C11.027 29.9684 10.5859 30.0445 10.1992 30.1172C10.5527 29.9026 10.9605 29.8022 11.3533 29.7122Z"
        fill="#064737"
      />
      <path
        d="M11.8158 31.7029C12.0424 32.1668 12.2266 32.6446 12.5137 33.0704C12.1904 33.3128 11.8702 33.569 11.5227 33.7559C11.7312 33.4478 12.0665 33.3059 12.3626 33.1258C12.3143 32.97 12.2629 32.8177 12.2115 32.6688C12.1209 32.7831 12.0303 32.9008 11.9487 33.0254C11.8279 33.2228 11.6134 33.3336 11.4321 33.4547C11.281 33.1397 11.13 32.8177 10.9819 32.4957C11.1511 32.3918 11.3263 32.288 11.4955 32.1876C11.4563 32.0768 11.414 31.966 11.3717 31.8552C11.5197 31.8033 11.6677 31.7513 11.8218 31.7098V31.7029H11.8158Z"
        fill="#064737"
      />
      <path
        d="M11.5074 32.3087C11.6464 32.5199 11.7793 32.7069 11.8579 32.9596C11.8458 33.0392 11.8126 33.1154 11.7491 33.1777C11.5437 33.0288 11.4198 32.8142 11.2778 32.5961C11.3534 32.4991 11.4289 32.4057 11.5074 32.3122V32.3087Z"
        fill="#064737"
      />
      <path
        d="M20.9607 33.0774C21.0786 33.8737 21.2417 34.6596 21.3716 35.4524C21.7583 37.7928 21.9094 40.2405 21.5136 42.5879C21.1269 44.9318 20.1964 47.1406 18.8761 48.979C17.7402 50.5058 16.2659 51.6172 14.6405 52.3373C14.1662 52.5589 13.6707 52.7112 13.1934 52.9328C13.6647 53.2651 14.145 53.5975 14.6405 53.8849C15.5076 54.3799 16.3444 54.875 17.2538 55.2593C18.8157 55.9622 20.4471 56.5299 22.1057 56.845C23.9215 57.2293 25.7704 57.4059 27.6193 57.302C31.9517 57.1289 36.2477 55.6263 39.9335 53.0089C38.8036 52.6039 37.6767 52.1746 36.574 51.6899C36.1692 51.4994 35.7674 51.2952 35.3625 51.1082C34.2538 50.5127 33.1934 49.6922 32.3746 48.6466C31.6979 47.8296 31.1873 46.8775 30.7613 45.8665C30.5227 45.3057 30.2931 44.7171 30.148 44.1181C29.8641 43.0345 29.6314 41.8435 29.6979 40.7114C29.7523 39.9047 29.9819 39.0426 30.4592 38.4368C30.9094 37.8967 31.5559 37.5124 32.2115 37.4951C32.7281 37.4777 33.136 37.6924 33.6465 37.7824C32.8429 37.1281 32.0604 36.4703 31.3323 35.6982C32.8278 36.6018 34.3565 37.5955 35.9426 38.3191C37.0544 38.8557 38.2568 39.3577 39.4562 39.562C39.9215 39.6174 40.5106 39.6762 40.9184 39.3646C41.1662 39.1846 41.2659 38.8903 41.3112 38.5718C41.3897 38.0109 41.429 37.3358 41.6677 36.8303C41.8792 36.4253 42.2387 36.0998 42.5045 35.7294C42.8308 35.3139 42.9184 34.805 43.3474 34.483C43.4894 34.6873 43.6375 34.8431 43.6707 35.1166C43.7039 35.4939 43.6163 35.9163 43.3565 36.1725C43.0332 36.5222 42.4532 36.4703 42.2387 36.9342C41.9366 37.5539 42.0151 38.416 41.852 39.1084C41.7372 39.697 41.3988 40.2682 40.8701 40.4344C40.4713 40.5521 40.0242 40.5141 39.6163 40.4829C38.3686 40.3375 37.1057 39.9497 35.8822 39.6312C35.3867 39.51 34.8278 39.2227 34.3233 39.3438C33.8459 39.4754 33.4139 39.8666 33.0997 40.289C32.6012 40.9503 32.2085 41.7535 32.0242 42.6052C31.8187 43.6611 31.9215 44.8002 32.3202 45.7765C32.7795 46.9536 33.6586 47.9161 34.6737 48.4493C35.6405 48.9721 36.6798 49.346 37.6586 49.7372C38.8278 50.1769 39.994 50.627 41.1601 51.0805C41.8731 51.3921 42.707 51.6933 43.2145 52.3754C42.1027 53.3171 40.9638 54.1999 39.7523 54.9651C37.0725 56.6442 34.2326 57.8906 31.2115 58.4584C26.139 59.452 20.8308 58.7561 16.0997 56.4261C14.6526 55.7094 13.2568 54.8854 11.9456 53.8745C11.3051 53.4071 10.7039 52.8912 10.0967 52.3684C10.5317 51.7799 11.1692 51.496 11.7644 51.1705C13.7795 50.1319 16 49.0967 17.6677 47.4003C19.0544 46.0154 19.9607 44.1666 20.4864 42.162C21.148 39.8043 21.2296 37.3496 21.1118 34.895C21.0725 34.2822 20.9728 33.6902 20.9758 33.0774L20.9637 33.0704V33.0774H20.9607Z"
        fill="#064737"
      />
      <path
        d="M13.7646 34.3999C13.5048 34.7773 13.1422 35.1131 12.7827 35.3658C13.0516 35.0058 13.4051 34.6492 13.7646 34.3999Z"
        fill="#064737"
      />
      <path
        d="M51.598 35.4004C52.03 35.4558 52.459 35.5942 52.888 35.6877C52.45 37.5192 51.8759 39.3126 51.172 41.0263C50.6856 42.11 50.1992 43.2213 49.6131 44.2358C48.5376 46.2196 47.2657 48.0545 45.8246 49.706C45.3382 50.2426 44.8397 50.7584 44.3442 51.2812C44.0844 50.89 43.7551 50.5646 43.5225 50.156C43.743 49.834 44.0542 49.5917 44.308 49.3043C46.5043 46.9432 48.311 44.0903 49.7037 41.0402C50.2808 39.7038 50.8034 38.3466 51.1932 36.9202C51.3442 36.4182 51.4439 35.892 51.601 35.3934V35.4004H51.598Z"
        fill="#064737"
      />
      <path
        d="M15.5376 35.8331C15.3563 36.2624 15.021 36.5636 14.7612 36.9583C14.6101 37.1487 14.5346 37.3634 14.2959 37.4153C14.5013 37.0172 14.7702 36.7333 15.021 36.3594C15.166 36.1447 15.314 35.9543 15.5346 35.8331H15.5376Z"
        fill="#064737"
      />
      <path
        d="M16.465 37.1938C16.7792 37.5712 17.2234 37.7582 17.5315 38.1425C17.3442 38.0802 17.1811 37.9798 17.0149 37.8759C16.9454 37.9971 16.8729 38.1217 16.8034 38.2463C16.8487 38.1113 16.8941 37.9798 16.9424 37.8447C16.8215 37.7651 16.7007 37.682 16.5768 37.6058C16.5527 37.5054 16.5224 37.4016 16.4953 37.2977C16.4076 37.4604 16.3231 37.6266 16.2354 37.7928C16.3533 37.8794 16.4681 37.959 16.5889 38.0386C16.4016 38.0455 16.2928 38.0836 16.1357 38.2048C16.1539 38.049 16.169 37.9001 16.1811 37.7478C16.2777 37.5643 16.3684 37.3843 16.465 37.1973V37.1938Z"
        fill="#064737"
      />
      <path
        d="M53.3534 37.8759C53.6676 37.9797 53.9848 38.0732 54.296 38.184C54.1178 38.9145 53.9123 39.6208 53.6918 40.334C53.3655 40.2543 53.0483 40.1401 52.728 40.0258C52.9486 39.3126 53.1782 38.6064 53.3534 37.8759Z"
        fill="#064737"
      />
      <path
        d="M52.3021 41.3969C52.6132 41.5111 52.9426 41.6566 53.2084 41.8747C52.9848 42.5671 52.6737 43.2353 52.3806 43.8896C52.0876 43.72 51.7975 43.5504 51.5015 43.3772C51.7522 42.7125 52.0181 42.0478 52.3021 41.3934V41.3969Z"
        fill="#064737"
      />
      <path
        d="M50.8642 44.769C51.127 44.9664 51.3868 45.1707 51.6648 45.3507C51.3597 46.0604 50.9186 46.7217 50.5077 47.3622C50.2479 47.1095 49.9911 46.8671 49.7373 46.6109C50.124 46.0016 50.4805 45.3749 50.8672 44.769H50.8642Z"
        fill="#064737"
      />
      <path
        d="M48.8914 47.8157C49.1391 48.0788 49.4261 48.2935 49.6618 48.5739C49.5832 48.7955 49.4412 48.9755 49.3083 49.1555C49.0545 49.4914 48.7977 49.8306 48.547 50.1665C48.2781 49.9207 48.0243 49.6541 47.7856 49.3667C48.1693 48.8682 48.55 48.3558 48.8914 47.8157Z"
        fill="#064737"
      />
      <path
        d="M46.7279 50.3846C46.9907 50.6443 47.2083 50.9663 47.456 51.2433C47.027 51.7799 46.5466 52.2438 46.0844 52.7458C45.8638 52.4446 45.6463 52.1469 45.4258 51.8491C45.8548 51.3575 46.2959 50.8797 46.7249 50.3846H46.7279Z"
        fill="#064737"
      />
    </g>
    <defs>
      <clipPath id="clip0_74_1549">
        <rect width="300" height="59.4485" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AevaLogo = () => (
  <svg
    width="123"
    height="30"
    viewBox="0 0 123 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.06525 15.395C6.35151 14.238 6.96404 13.8818 7.89206 13.9541C8.79392 14.0264 9.70656 13.9682 10.9839 13.9682C10.1159 16.2063 9.36182 18.1516 8.53845 20.2786H21.303C18.2896 13.4497 15.3732 6.8412 12.3598 0.0140466C13.9881 0.0140466 15.3624 -0.035336 16.7306 0.0510836C17.0446 0.0722476 17.4693 0.474364 17.6248 0.825333C21.6739 9.98758 25.6938 19.1657 29.7122 28.3456C29.8184 28.589 29.8584 28.8729 29.9985 29.3932C28.5056 29.3932 27.1436 29.462 25.7923 29.3438C25.4707 29.3156 25.0259 28.723 24.9182 28.298C24.1379 25.2556 22.408 24.522 19.7455 24.7248C15.7872 25.0264 11.7965 24.8218 7.82127 24.7883C6.97019 24.7794 6.48694 25.0299 6.09911 26.0034C4.72169 29.4726 4.68014 29.4514 1.34048 29.4073C0.977272 29.4003 0.614066 29.3579 0 29.3138C2.06228 24.5802 4.04145 20.0334 6.06525 15.3862V15.395Z"
      fill="#F4F2EF"
    />
    <path
      d="M119.91 23.2013C120.809 25.2418 121.662 27.1819 122.645 29.4076C121.018 29.4076 119.689 29.4746 118.373 29.3618C118.041 29.3335 117.562 28.7886 117.463 28.3812C116.695 25.2348 114.896 24.5328 112.201 24.7304C108.282 25.0214 104.336 24.8274 100.4 24.7886C99.5108 24.7797 98.9844 25.0143 98.5751 26.0496C97.2177 29.4887 97.1653 29.4658 93.7934 29.4076C93.4378 29.4006 93.0823 29.3441 92.5391 29.2912C93.6687 26.6475 94.7168 24.1695 95.7818 21.7074C96.7252 19.5275 97.7348 17.3812 98.6243 15.1678C99.0029 14.226 99.5139 13.8944 100.376 13.9526C101.282 14.0126 102.195 13.9667 103.48 13.9667C102.62 16.1977 101.869 18.1395 101.045 20.2771H113.802C110.793 13.4588 107.88 6.85384 104.863 0.0196253C106.519 0.0196253 107.934 -0.020939 109.34 0.0548987C109.616 0.069008 109.979 0.474652 110.121 0.807985C113.385 8.2295 116.626 15.6651 119.91 23.1942H119.909V23.2013H119.91Z"
      fill="#F4F2EF"
    />
    <path
      d="M80.7848 10.583C82.1346 7.55478 83.4412 4.62004 84.7293 1.67648C85.0541 0.93574 85.445 0.498351 86.2622 0.567134C87.378 0.662372 88.503 0.590061 89.7465 0.590061C89.6526 1.06625 89.6496 1.39958 89.5295 1.67119C85.5142 10.8458 81.4974 20.0151 77.4529 29.1668C77.2974 29.5195 76.8773 29.9269 76.5633 29.9481C75.1921 30.0345 73.8177 29.9851 72.1895 29.9851C75.1013 23.4066 77.9177 17.038 80.7848 10.5795V10.583Z"
      fill="#F4F2EF"
    />
    <path
      d="M38.94 9.27243C38.0397 9.35532 37.5549 9.10311 37.1978 8.14015C36.2913 5.69571 35.2263 3.33063 34.1367 0.722168H56.457C56.457 1.9003 56.5278 3.13134 56.4047 4.33945C56.377 4.61105 55.6706 4.9779 55.2751 4.98142C50.9197 5.02728 46.5627 5.00964 42.2073 5.00964H40.4467C41.0069 6.50171 41.467 7.72922 42.0442 9.2689H38.9369H38.9384V9.27243H38.94Z"
      fill="#F4F2EF"
    />
    <path
      d="M55.6423 29.4193C48.826 29.4193 42.1298 29.3981 35.432 29.4422C34.4116 29.4493 34.0407 29.1406 34.07 27.9131C34.1423 24.6186 33.8699 25.0084 36.6678 25.0066C42.6961 24.9978 48.7229 25.0066 54.7512 25.0066C56.0594 25.0066 56.7119 25.7791 56.7119 27.3258C56.7119 27.6627 56.6888 27.9995 56.7181 28.3346C56.7812 29.1477 56.458 29.4916 55.6469 29.4264V29.4193H55.6423Z"
      fill="#F4F2EF"
    />
    <path
      d="M40.8805 12.6885H54.9871C54.9871 14.0201 55.0579 15.2494 54.9317 16.4504C54.904 16.7185 54.1899 17.0783 53.7882 17.0853C49.3943 17.1312 45.002 17.1135 40.6097 17.1135C39.103 17.1135 37.5963 17.0977 36.0896 17.1206C35.3093 17.1347 34.9353 16.789 34.9538 15.849C35.023 12.0553 34.5121 12.7608 37.6163 12.692C38.6628 12.6691 39.7062 12.6903 40.879 12.6903H40.8821L40.8805 12.6885Z"
      fill="#F4F2EF"
    />
    <path
      d="M70.9432 15.7138C71.4295 16.8178 71.8835 17.8213 72.4638 19.1123C71.0479 19.1123 69.8628 19.1564 68.6839 19.0771C68.4423 19.063 68.1407 18.6467 68.0022 18.3363C65.4597 12.6379 62.9373 6.92716 60.4164 1.21817C60.3856 1.14939 60.4225 1.04004 60.4302 0.831931C61.5044 0.831931 62.5941 0.745511 63.6621 0.877786C64.0469 0.927169 64.5194 1.41923 64.7179 1.85133C66.8079 6.42276 68.8501 11.0206 70.9447 15.7102H70.9432V15.7138Z"
      fill="#F4F2EF"
    />
  </svg>
);

export const PayloadCardIcon = () => (
  <svg
    width="186"
    height="213"
    viewBox="0 0 186 213"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1552_8479)">
      <rect x="6.5" y="6" width="167" height="195" rx="6" fill="white" />
      <rect x="7" y="6.5" width="166" height="194" rx="5.5" stroke="#E6E6E6" />
    </g>
    <circle cx="37.5" cy="51" r="17.5" fill="#F2F2F2" stroke="#F2F2F2" />
    <rect
      x="20"
      y="83.5"
      width="137"
      height="7"
      rx="1.5"
      fill="#F2F2F2"
      stroke="#F2F2F2"
    />
    <rect
      x="20"
      y="97.5"
      width="137"
      height="7"
      rx="1.5"
      fill="#F2F2F2"
      stroke="#F2F2F2"
    />
    <rect
      x="20"
      y="111.5"
      width="137"
      height="7"
      rx="1.5"
      fill="#F2F2F2"
      stroke="#F2F2F2"
    />
    <rect
      x="20"
      y="125.5"
      width="137"
      height="7"
      rx="1.5"
      fill="#F2F2F2"
      stroke="#F2F2F2"
    />
    <rect
      x="20"
      y="139.5"
      width="137"
      height="7"
      rx="1.5"
      fill="#F2F2F2"
      stroke="#F2F2F2"
    />
    <rect
      x="20"
      y="153.5"
      width="137"
      height="7"
      rx="1.5"
      fill="#F2F2F2"
      stroke="#F2F2F2"
    />
    <rect
      x="20"
      y="167.5"
      width="137"
      height="7"
      rx="1.5"
      fill="#F2F2F2"
      stroke="#F2F2F2"
    />
    <defs>
      <filter
        id="filter0_d_1552_8479"
        x="0.5"
        y="0"
        width="185"
        height="213"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="3" />
        <feGaussianBlur stdDeviation="4.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1552_8479"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1552_8479"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const FormCardIcon = () => (
  <svg
    width="186"
    height="213"
    viewBox="0 0 186 213"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1552_8480)">
      <rect x="6.5" y="6" width="167" height="195" rx="6" fill="white" />
      <rect x="7" y="6.5" width="166" height="194" rx="5.5" stroke="#E6E6E6" />
    </g>
    <rect x="18.5" y="62" width="32" height="5" rx="2" fill="#DEDEDE" />
    <rect x="18.5" y="70" width="138" height="8" rx="2" fill="#F2F2F2" />
    <rect x="18.5" y="86" width="37" height="5" rx="2" fill="#DEDEDE" />
    <rect x="18.5" y="94" width="138" height="8" rx="2" fill="#F2F2F2" />
    <rect x="18.5" y="110" width="43" height="5" rx="2" fill="#DEDEDE" />
    <rect x="18.5" y="118" width="138" height="8" rx="2" fill="#F2F2F2" />
    <rect x="18.5" y="134" width="35" height="5" rx="2" fill="#DEDEDE" />
    <rect x="18.5" y="142" width="138" height="8" rx="2" fill="#F2F2F2" />
    <rect x="18.5" y="158" width="32" height="5" rx="2" fill="#DEDEDE" />
    <rect x="18.5" y="166" width="138" height="8" rx="2" fill="#F2F2F2" />
    <defs>
      <filter
        id="filter0_d_1552_8480"
        x="0.5"
        y="0"
        width="185"
        height="213"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="3" />
        <feGaussianBlur stdDeviation="4.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1552_8480"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1552_8480"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const ChatWidgetCardIcon = () => (
  <svg
    width="186"
    height="213"
    viewBox="0 0 186 213"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1552_8481)">
      <rect x="6.5" y="6" width="167" height="195" rx="6" fill="white" />
      <rect x="7" y="6.5" width="166" height="194" rx="5.5" stroke="#E6E6E6" />
    </g>
    <rect x="7.5" y="62" width="165" height="1" fill="#E6E6E6" />
    <rect x="7.5" y="113" width="165" height="1" fill="#E6E6E6" />
    <rect x="7.5" y="164" width="165" height="1" fill="#E6E6E6" />
    <rect x="102.5" y="127" width="25" height="5" fill="#DEDEDE" />
    <rect x="102.5" y="136" width="51" height="3" rx="1" fill="#F2F2F2" />
    <rect x="102.5" y="142" width="40" height="3" rx="1" fill="#F2F2F2" />
    <rect x="102.5" y="148" width="45" height="3" rx="1" fill="#F2F2F2" />
    <path
      d="M55.201 121.25C55.7783 120.25 57.2217 120.25 57.799 121.25L75.9856 152.75C76.5629 153.75 75.8412 155 74.6865 155H38.3135C37.1588 155 36.4371 153.75 37.0144 152.75L55.201 121.25Z"
      fill="white"
      stroke="#E6E6E6"
    />
    <circle cx="35.5" cy="138" r="13.5" fill="white" stroke="#E6E6E6" />
    <rect x="24.5" y="76" width="25" height="5" rx="1" fill="#DEDEDE" />
    <rect x="24.5" y="85" width="51" height="3" rx="1" fill="#F2F2F2" />
    <rect x="24.5" y="91" width="40" height="3" rx="1" fill="#F2F2F2" />
    <rect x="24.5" y="97" width="45" height="3" rx="1" fill="#F2F2F2" />
    <rect x="77.5" y="22" width="25" height="5" rx="1" fill="#DEDEDE" />
    <rect x="59.5" y="31" width="61" height="3" rx="1" fill="#F2F2F2" />
    <rect x="66.5" y="37" width="47" height="3" rx="1" fill="#F2F2F2" />
    <rect x="63.5" y="43" width="53" height="3" rx="1" fill="#F2F2F2" />
    <path
      d="M121.201 70.25C121.778 69.25 123.222 69.25 123.799 70.25L141.986 101.75C142.563 102.75 141.841 104 140.687 104H104.313C103.159 104 102.437 102.75 103.014 101.75L121.201 70.25Z"
      fill="white"
      stroke="#E6E6E6"
    />
    <circle cx="141.5" cy="87" r="13.5" fill="white" stroke="#E6E6E6" />
    <g clipPath="url(#clip0_1552_8481)">
      <rect x="24.5" y="178" width="25" height="5" fill="#DEDEDE" />
      <rect x="24.5" y="187" width="51" height="3" rx="1" fill="#F2F2F2" />
      <rect x="24.5" y="193" width="40" height="3" rx="1" fill="#F2F2F2" />
      <path
        d="M121.201 173.25C121.778 172.25 123.222 172.25 123.799 173.25L141.986 204.75C142.563 205.75 141.841 207 140.687 207H104.313C103.159 207 102.437 205.75 103.014 204.75L121.201 173.25Z"
        fill="white"
        stroke="#E6E6E6"
      />
      <circle cx="141.5" cy="190" r="13.5" fill="white" stroke="#E6E6E6" />
    </g>
    <defs>
      <filter
        id="filter0_d_1552_8481"
        x="0.5"
        y="0"
        width="185"
        height="213"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="3" />
        <feGaussianBlur stdDeviation="4.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1552_8481"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1552_8481"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_1552_8481">
        <rect
          width="131"
          height="30"
          fill="white"
          transform="translate(24.5 170)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const RedCheckedIcon = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="13" cy="13" r="13" fill="#054637" />
    <path
      d="M7.75 13L11.5 16.75L19 9.25"
      stroke="white"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LoyaltyTotalIcon = () => (
  <svg
    width="22"
    height="6"
    viewBox="0 0 22 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.5" width="22" height="5" rx="2" fill="#747C92" />
  </svg>
);

export const LoyaltyProgresIcon = () => (
  <svg
    width="22"
    height="6"
    viewBox="0 0 22 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.5" width="22" height="5" rx="2" fill="#3066BE" />
  </svg>
);

export const LoyaltyRedemedIcon = () => (
  <svg
    width="22"
    height="6"
    viewBox="0 0 22 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.5" width="22" height="5" rx="2" fill="#F5BB00" />
  </svg>
);
export const LoyaltyCompletedIcon = () => (
  <svg
    width="22"
    height="6"
    viewBox="0 0 22 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.5" width="22" height="5" rx="2" fill="#054637" />
  </svg>
);

export const CTIcon = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="34" height="34" rx="6" fill="#FFF8E1" />
    <path
      d="M13.816 22.168C13.0507 22.168 12.3553 21.986 11.73 21.622C11.1047 21.258 10.6053 20.726 10.232 20.026C9.868 19.3167 9.686 18.458 9.686 17.45C9.686 16.4513 9.87267 15.5973 10.246 14.888C10.6287 14.1693 11.1373 13.6233 11.772 13.25C12.4067 12.8673 13.1067 12.676 13.872 12.676C14.4507 12.676 14.964 12.7927 15.412 13.026C15.86 13.2593 16.2287 13.53 16.518 13.838L15.65 14.888C15.4167 14.6453 15.1553 14.454 14.866 14.314C14.586 14.1647 14.2687 14.09 13.914 14.09C13.4193 14.09 12.976 14.2253 12.584 14.496C12.2013 14.7573 11.898 15.1353 11.674 15.63C11.4593 16.1247 11.352 16.7173 11.352 17.408C11.352 18.4533 11.5807 19.2747 12.038 19.872C12.4953 20.46 13.1067 20.754 13.872 20.754C14.2827 20.754 14.6467 20.67 14.964 20.502C15.2813 20.3247 15.5707 20.096 15.832 19.816L16.7 20.838C16.3267 21.2673 15.8973 21.5987 15.412 21.832C14.936 22.056 14.404 22.168 13.816 22.168ZM19.8713 22V14.216H17.2253V12.844H24.1413V14.216H21.4953V22H19.8713Z"
      fill="#F5BB00"
    />
  </svg>
);

export const iphonex = () => (
  <svg
    width="600"
    height="160"
    viewBox="0 0 600 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M41 79.2C22.1 121.2 6.49998 155.8 6.29998 156.2C6.09998 156.7 6.99998 157 8.29998 157C10.5 157 13.2 151.4 44 83C62.3 42.2 77.4 9.1 77.6 9.2C77.7 9.4 92.7 42.6 110.9 83C141.7 151.5 144.1 156.5 146.5 156.8C148.8 157.1 149 156.9 148.2 155.3C147.7 154.3 132.1 119.6 113.5 78.2C83.8 12.4 79.3 3 77.4 3C75.5 3 71 12.5 41 79.2Z"
      fill="#CC1943"
    />
    <path
      d="M200 5C200 7 200.7 7 239 7C277.3 7 278 7 278 5C278 3 277.3 3 239 3C200.7 3 200 3 200 5Z"
      fill="#CC1943"
    />
    <path
      d="M318 3.3C318 5.2 387.2 156.7 388.3 157.4C389.4 158.1 390.3 158.1 391 157.4C391.6 156.8 407.6 121.9 426.5 79.9C457.4 11.3 460.7 3.5 458.9 3.2C457.7 3 456.6 3 456.4 3.3C456.2 3.5 441.2 36.5 423.2 76.6C405.2 116.8 390.1 149.7 389.6 149.9C389 150 373.7 117.1 355.6 76.6C325.8 10.2 322.3 3 320.3 3C319 3 318 3.2 318 3.3Z"
      fill="#CC1943"
    />
    <path
      d="M491 72.7C473.8 111.1 458.1 145.8 456.3 149.8L453 157.1L455.6 156.8C457.9 156.5 460.6 151 491.3 82.7L524.4 9L526.6 13.2C527.7 15.6 542.8 48.9 560 87.3C589.1 152 591.5 157 593.8 157C595.3 157 596 156.6 595.7 155.7C595.4 155.1 580 121 561.5 80C543 39 527.6 4.9 527.3 4.2C527 3.6 525.8 3 524.6 3C522.7 3 518.6 11.5 491 72.7Z"
      fill="#CC1943"
    />
    <path
      d="M200 79C200 81 200.7 81 239 81C277.3 81 278 81 278 79C278 77 277.3 77 239 77C200.7 77 200 77 200 79Z"
      fill="#CC1943"
    />
    <path
      d="M200 156C200 158 200.7 158 239 158C277.3 158 278 158 278 156C278 154 277.3 154 239 154C200.7 154 200 154 200 156Z"
      fill="#CC1943"
    />
  </svg>
);

export const CompletedIcon = () => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="25"
      cy="25"
      r="24"
      fill="#27AE60"
      fillOpacity="0.2"
      stroke="#27AE60"
      strokeWidth="2"
    />
    <g clipPath="url(#clip0_1690_10624)">
      <path
        d="M15.2773 25.0011L22.2218 31.9455L36.1107 18.0566"
        stroke="#27AE60"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1690_10624">
        <rect
          width="33.3333"
          height="33.3333"
          fill="white"
          transform="translate(8.33301 8.33398)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ICampaginIcon = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="34" height="34" rx="6" fill="#FFE7ED" />
    <path d="M16.162 22V12.844H17.786V22H16.162Z" fill="#054637" />
  </svg>
);

export const CSCampaginIcon = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="34" height="34" rx="6" fill="#DEFFE3" />
    <path
      d="M13.816 22.168C13.0507 22.168 12.3553 21.986 11.73 21.622C11.1047 21.258 10.6053 20.726 10.232 20.026C9.868 19.3167 9.686 18.458 9.686 17.45C9.686 16.4513 9.87267 15.5973 10.246 14.888C10.6287 14.1693 11.1373 13.6233 11.772 13.25C12.4067 12.8673 13.1067 12.676 13.872 12.676C14.4507 12.676 14.964 12.7927 15.412 13.026C15.86 13.2593 16.2287 13.53 16.518 13.838L15.65 14.888C15.4167 14.6453 15.1553 14.454 14.866 14.314C14.586 14.1647 14.2687 14.09 13.914 14.09C13.4193 14.09 12.976 14.2253 12.584 14.496C12.2013 14.7573 11.898 15.1353 11.674 15.63C11.4593 16.1247 11.352 16.7173 11.352 17.408C11.352 18.4533 11.5807 19.2747 12.038 19.872C12.4953 20.46 13.1067 20.754 13.872 20.754C14.2827 20.754 14.6467 20.67 14.964 20.502C15.2813 20.3247 15.5707 20.096 15.832 19.816L16.7 20.838C16.3267 21.2673 15.8973 21.5987 15.412 21.832C14.936 22.056 14.404 22.168 13.816 22.168ZM20.5333 22.168C19.9173 22.168 19.3199 22.0513 18.7413 21.818C18.1719 21.5847 17.6679 21.2533 17.2293 20.824L18.1813 19.718C18.5079 20.026 18.8813 20.278 19.3013 20.474C19.7213 20.6607 20.1413 20.754 20.5613 20.754C21.0839 20.754 21.4806 20.6467 21.7513 20.432C22.0219 20.2173 22.1573 19.9327 22.1573 19.578C22.1573 19.1953 22.0219 18.92 21.7513 18.752C21.4899 18.584 21.1539 18.4113 20.7433 18.234L19.4833 17.688C19.1846 17.5573 18.8906 17.3893 18.6013 17.184C18.3213 16.9787 18.0879 16.7173 17.9013 16.4C17.7239 16.0827 17.6353 15.7 17.6353 15.252C17.6353 14.7667 17.7659 14.3327 18.0273 13.95C18.2979 13.558 18.6619 13.25 19.1193 13.026C19.5859 12.7927 20.1179 12.676 20.7153 12.676C21.2473 12.676 21.7606 12.7833 22.2553 12.998C22.7499 13.2033 23.1746 13.4833 23.5293 13.838L22.7033 14.874C22.4139 14.6313 22.1059 14.44 21.7793 14.3C21.4619 14.16 21.1073 14.09 20.7153 14.09C20.2859 14.09 19.9359 14.188 19.6653 14.384C19.4039 14.5707 19.2733 14.832 19.2733 15.168C19.2733 15.4013 19.3386 15.5973 19.4693 15.756C19.6093 15.9053 19.7913 16.036 20.0153 16.148C20.2393 16.2507 20.4773 16.3533 20.7293 16.456L21.9753 16.974C22.5166 17.2073 22.9599 17.5153 23.3053 17.898C23.6506 18.2713 23.8233 18.7893 23.8233 19.452C23.8233 19.9467 23.6926 20.3993 23.4313 20.81C23.1699 21.2207 22.7919 21.552 22.2973 21.804C21.8119 22.0467 21.2239 22.168 20.5333 22.168Z"
      fill="#054637"
    />
  </svg>
);

export const CampaginFolderIcon = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="34" height="34" rx="6" fill="#E7EEFA" />
    <path
      d="M11.75 11H14.75L17 13.25H22.25C22.6478 13.25 23.0294 13.408 23.3107 13.6893C23.592 13.9706 23.75 14.3522 23.75 14.75V20.75C23.75 21.1478 23.592 21.5294 23.3107 21.8107C23.0294 22.092 22.6478 22.25 22.25 22.25H11.75C11.3522 22.25 10.9706 22.092 10.6893 21.8107C10.408 21.5294 10.25 21.1478 10.25 20.75V12.5C10.25 12.1022 10.408 11.7206 10.6893 11.4393C10.9706 11.158 11.3522 11 11.75 11"
      stroke="#3066BE"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CustomCampaginIcon = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="34" height="34" rx="6" fill="#F0EBFF" />
    <g clipPath="url(#clip0_2151_4267)">
      <path
        d="M17 19.1565L14.6855 20.3734L15.1276 17.796L13.2526 15.9709L15.8401 15.5959L16.9974 13.251L18.1546 15.5959L20.7421 15.9709L18.8671 17.796L19.3092 20.3734L17 19.1565Z"
        stroke="#5E2BFF"
        strokeWidth="0.5625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M17 21.0728L12.6282 23.3713L13.4633 18.503L9.92162 15.0555L14.8091 14.3472L16.995 9.91797L19.1809 14.3472L24.0684 15.0555L20.5268 18.503L21.3619 23.3713L17 21.0728Z"
      stroke="#5E2BFF"
      strokeWidth="1.0625"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <clipPath id="clip0_2151_4267">
        <rect
          width="9"
          height="9"
          fill="white"
          transform="translate(12.5 12.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const CTCampaginIcon = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="34" height="34" rx="6" fill="#FFF8E1" />
    <path
      d="M13.816 22.168C13.0507 22.168 12.3553 21.986 11.73 21.622C11.1047 21.258 10.6053 20.726 10.232 20.026C9.868 19.3167 9.686 18.458 9.686 17.45C9.686 16.4513 9.87267 15.5973 10.246 14.888C10.6287 14.1693 11.1373 13.6233 11.772 13.25C12.4067 12.8673 13.1067 12.676 13.872 12.676C14.4507 12.676 14.964 12.7927 15.412 13.026C15.86 13.2593 16.2287 13.53 16.518 13.838L15.65 14.888C15.4167 14.6453 15.1553 14.454 14.866 14.314C14.586 14.1647 14.2687 14.09 13.914 14.09C13.4193 14.09 12.976 14.2253 12.584 14.496C12.2013 14.7573 11.898 15.1353 11.674 15.63C11.4593 16.1247 11.352 16.7173 11.352 17.408C11.352 18.4533 11.5807 19.2747 12.038 19.872C12.4953 20.46 13.1067 20.754 13.872 20.754C14.2827 20.754 14.6467 20.67 14.964 20.502C15.2813 20.3247 15.5707 20.096 15.832 19.816L16.7 20.838C16.3267 21.2673 15.8973 21.5987 15.412 21.832C14.936 22.056 14.404 22.168 13.816 22.168ZM19.8713 22V14.216H17.2253V12.844H24.1413V14.216H21.4953V22H19.8713Z"
      fill="#F5BB00"
    />
  </svg>
);

export const RCampaignIcon = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="34" height="34" rx="6" fill="#8dcfec" />
    <path
      d="M13.662 22V12.844H16.756C17.3907 12.844 17.96 12.928 18.464 13.096C18.9773 13.264 19.3787 13.5487 19.668 13.95C19.9667 14.342 20.116 14.8787 20.116 15.56C20.116 16.26 19.948 16.8247 19.612 17.254C19.2853 17.6833 18.8467 17.9913 18.296 18.178L20.48 22H18.66L16.686 18.416H15.286V22H13.662ZM15.286 17.128H16.588C17.2133 17.128 17.6893 16.9973 18.016 16.736C18.352 16.4653 18.52 16.0733 18.52 15.56C18.52 15.0373 18.352 14.6733 18.016 14.468C17.6893 14.2533 17.2133 14.146 16.588 14.146H15.286V17.128Z"
      fill="#296d98"
    />
  </svg>
);

export const FCampaignIcon = () => (
  <div
    style={{
      width: "34px",
      height: "34px",
      backgroundColor: "#f5d9c4",
      border: "none",
      borderRadius: "25%",
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
    }}
  >
    <p style={{ color: "#ed7b0c", fontSize: "20px", fontWeight: "bolder" }}>
      F
    </p>
  </div>
);

export const CDCampaignIcon = () => (
  <div
    style={{
      width: "34px",
      height: "34px",
      backgroundColor: "#b2aaf2",
      border: "none",
      borderRadius: "25%",
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
    }}
  >
    <p
      style={{
        color: "#4934eb",
        paddingTop: "0.5em",
        fontSize: "12px",
      }}
    >
      CD
    </p>
  </div>
);
export const PhoneTypeSvg = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 3H8C6.89543 3 6 3.89543 6 5V19C6 20.1046 6.89543 21 8 21H16C17.1046 21 18 20.1046 18 19V5C18 3.89543 17.1046 3 16 3Z"
      stroke="#054637"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 4H13"
      stroke="#054637"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 17V17.01"
      stroke="#054637"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MailTypeSvg = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 44 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.3958 9.10449H9.60417C7.64816 9.10449 6.0625 10.6902 6.0625 12.6462V30.3545C6.0625 32.3105 7.64816 33.8962 9.60417 33.8962H34.3958C36.3518 33.8962 37.9375 32.3105 37.9375 30.3545V12.6462C37.9375 10.6902 36.3518 9.10449 34.3958 9.10449Z"
      stroke="#054637"
      strokeWidth="2.65625"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.0625 12.6455L22 23.2705L37.9375 12.6455"
      stroke="#054637"
      strokeWidth="2.65625"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CustomSelectIcon = () => (
  <svg
    height="20"
    width="20"
    viewBox="0 0 20 20"
    aria-hidden="true"
    focusable="false"
    className="css-tj5bde-Svg"
  >
    <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
  </svg>
);

export const FolderIcon = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="34" height="34" rx="6" fill="#E7EEFA" />
    <path
      d="M11.75 11H14.75L17 13.25H22.25C22.6478 13.25 23.0294 13.408 23.3107 13.6893C23.592 13.9706 23.75 14.3522 23.75 14.75V20.75C23.75 21.1478 23.592 21.5294 23.3107 21.8107C23.0294 22.092 22.6478 22.25 22.25 22.25H11.75C11.3522 22.25 10.9706 22.092 10.6893 21.8107C10.408 21.5294 10.25 21.1478 10.25 20.75V12.5C10.25 12.1022 10.408 11.7206 10.6893 11.4393C10.9706 11.158 11.3522 11 11.75 11"
      stroke="#3066BE"
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EditIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2546_14935)">
      <path
        d="M4.95801 4.9585H4.24967C3.87395 4.9585 3.51362 5.10775 3.24794 5.37343C2.98226 5.6391 2.83301 5.99944 2.83301 6.37516V12.7502C2.83301 13.1259 2.98226 13.4862 3.24794 13.7519C3.51362 14.0176 3.87395 14.1668 4.24967 14.1668H10.6247C11.0004 14.1668 11.3607 14.0176 11.6264 13.7519C11.8921 13.4862 12.0413 13.1259 12.0413 12.7502V12.0418"
        stroke="#054637"
        strokeWidth="1.0625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4394 4.66445C14.7183 4.38548 14.8751 4.00711 14.8751 3.61258C14.8751 3.21805 14.7183 2.83968 14.4394 2.5607C14.1604 2.28173 13.782 2.125 13.3875 2.125C12.993 2.125 12.6146 2.28173 12.3356 2.5607L6.375 8.50008V10.6251H8.5L14.4394 4.66445V4.66445Z"
        stroke="#054637"
        strokeWidth="1.0625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.333 3.5415L13.458 5.6665"
        stroke="#054637"
        strokeWidth="1.0625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2546_14935">
        <rect width="17" height="17" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const RatingStartBadge = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.6665 1.0446C1.6665 0.867785 1.73674 0.698216 1.86177 0.573192C1.98679 0.448168 2.15636 0.37793 2.33317 0.37793H13.6665C13.8433 0.37793 14.0129 0.448168 14.1379 0.573192C14.2629 0.698216 14.3332 0.867785 14.3332 1.0446V5.22126C14.3336 7.31748 13.7781 9.37633 12.7234 11.1879C11.6687 12.9994 10.1524 14.4988 8.32917 15.5333C8.22878 15.5903 8.1153 15.6203 7.99984 15.6203C7.88438 15.6203 7.77089 15.5903 7.6705 15.5333C5.84725 14.4989 4.33094 12.9995 3.27619 11.1879C2.22145 9.37637 1.666 7.3175 1.6665 5.22126V1.0446Z"
      stroke="currentColor"
      strokeWidth="0.666667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66748 2.37793H14.3341"
      stroke="currentColor"
      strokeWidth="0.666667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.39277 4.7021L9.24811 6.37944H10.9148C10.9987 6.37646 11.0815 6.39939 11.1519 6.44513C11.2223 6.49086 11.2769 6.55717 11.3083 6.63503C11.3397 6.7129 11.3463 6.79855 11.3273 6.88033C11.3083 6.96211 11.2646 7.03605 11.2021 7.0921L9.75544 8.59944L10.5554 10.4401C10.5906 10.5243 10.5984 10.6174 10.5779 10.7063C10.5573 10.7951 10.5094 10.8753 10.4409 10.9356C10.3723 10.9958 10.2866 11.033 10.1958 11.0419C10.1051 11.0509 10.0137 11.0311 9.93477 10.9854L8.00011 9.89744L6.06677 10.9868C5.9878 11.0324 5.8965 11.0522 5.80571 11.0433C5.71492 11.0343 5.62923 10.9971 5.56069 10.9369C5.49216 10.8767 5.44424 10.7965 5.42369 10.7076C5.40313 10.6187 5.41097 10.5256 5.44611 10.4414L6.24611 8.60077L4.80344 7.0921C4.74065 7.03629 4.69662 6.96245 4.67737 6.88068C4.65811 6.7989 4.66457 6.71318 4.69586 6.63521C4.72715 6.55724 4.78174 6.49083 4.85218 6.44506C4.92263 6.39928 5.00549 6.37636 5.08944 6.37944H6.75611L7.61277 4.7021C7.64999 4.63085 7.70602 4.57116 7.77478 4.5295C7.84353 4.48784 7.92238 4.46582 8.00277 4.46582C8.08316 4.46582 8.16202 4.48784 8.23077 4.5295C8.29953 4.57116 8.35555 4.63085 8.39277 4.7021V4.7021Z"
      stroke="currentColor"
      strokeWidth="0.666667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MembershipStar = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
    >
      <path
        d="M5.35984 0.634335C5.62926 -0.194844 6.80233 -0.194843 7.07174 0.634336L7.9221 3.25146C8.04258 3.62228 8.38814 3.87335 8.77805 3.87335L11.5299 3.87335C12.4017 3.87335 12.7642 4.989 12.0589 5.50146L9.8326 7.11893C9.51716 7.34811 9.38517 7.75434 9.50566 8.12516L10.356 10.7423C10.6254 11.5715 9.6764 12.261 8.97106 11.7485L6.7448 10.131C6.42936 9.90187 6.00222 9.90187 5.68678 10.131L3.46052 11.7485C2.75518 12.261 1.80615 11.5715 2.07557 10.7423L2.92592 8.12516C3.04641 7.75434 2.91442 7.34811 2.59898 7.11893L0.372718 5.50146C-0.332624 4.989 0.0298743 3.87335 0.901725 3.87335L3.65353 3.87335C4.04344 3.87335 4.389 3.62228 4.50948 3.25146L5.35984 0.634335Z"
        fill="#1A1E1D"
      />
    </svg>
  );
};

export const NotificationBellIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2541_12823)">
      <path
        d="M11.67 10.5747C11.8049 11.2687 12.088 11.9254 12.5 12.5H0.5C0.5 12.5 1.5 10.9473 1.5 7C1.5 5.67392 2.02678 4.40215 2.96447 3.46447C3.90215 2.52678 5.17392 2 6.5 2V0.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 8.5C13.7091 8.5 15.5 6.70914 15.5 4.5C15.5 2.29086 13.7091 0.5 11.5 0.5C9.29086 0.5 7.5 2.29086 7.5 4.5C7.5 6.70914 9.29086 8.5 11.5 8.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 3V5.5H13"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.16553 14.5C5.25021 14.7885 5.42604 15.0417 5.6667 15.2219C5.90736 15.4021 6.1999 15.4994 6.50053 15.4994C6.80116 15.4994 7.0937 15.4021 7.33436 15.2219C7.57502 15.0417 7.75085 14.7885 7.83553 14.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2541_12823">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DomainIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2541_12811)">
      <path
        d="M15.6668 8.00071C15.6663 9.8677 14.9842 11.6703 13.7486 13.0699C12.513 14.4695 10.8088 15.3697 8.95631 15.6016C7.10377 15.8335 5.23032 15.3809 3.68787 14.329C2.14542 13.2771 1.04011 11.6983 0.579561 9.88897C0.119014 8.07968 0.334924 6.16448 1.18673 4.50314C2.03854 2.8418 3.46764 1.54863 5.20557 0.866549C6.9435 0.184468 8.87068 0.160412 10.6251 0.798899C12.3795 1.43739 13.8404 2.69448 14.7334 4.33404C15.3472 5.45862 15.6682 6.71955 15.6668 8.00071V8.00071Z"
        stroke="currentColor"
        strokeWidth="0.666667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3446 4.33301C10.7219 2.65529 9.54091 1.2429 7.99994 0.333008C6.45897 1.2429 5.27798 2.65529 4.65527 4.33301"
        stroke="currentColor"
        strokeWidth="0.666667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.65479 11.667C5.27799 13.3446 6.45914 14.7569 8.00012 15.667C9.61394 14.8309 10.8349 13.3944 11.4001 11.667"
        stroke="currentColor"
        strokeWidth="0.666667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.18799 3H13.812"
        stroke="currentColor"
        strokeWidth="0.666667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.18799 13H13.812"
        stroke="currentColor"
        strokeWidth="0.666667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.3335 6.66699V7.56366C6.33366 8.07244 6.43072 8.57653 6.6195 9.04899L7.00016 10.0003L7.66683 7.66699L8.3335 10.0003L8.71416 9.04899C8.90294 8.57653 9 8.07244 9.00016 7.56366V6.66699"
        stroke="currentColor"
        strokeWidth="0.666667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3335 6.66699V7.56366C10.3337 8.07244 10.4307 8.57653 10.6195 9.04899L11.0002 10.0003L11.6668 7.66699L12.3335 10.0003L12.7142 9.04899C12.9029 8.57653 13 8.07244 13.0002 7.56366V6.66699"
        stroke="currentColor"
        strokeWidth="0.666667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.3335 6.66699V7.56366C2.33366 8.07244 2.43072 8.57653 2.6195 9.04899L3.00016 10.0003L3.66683 7.66699L4.3335 10.0003L4.71416 9.04899C4.90294 8.57653 5 8.07244 5.00016 7.56366V6.66699"
        stroke="currentColor"
        strokeWidth="0.666667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2541_12811">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const OpenBookIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2541_12801)">
      <path
        d="M8.00001 14.75V3.14136C8.00001 3.14136 6.36335 1.32336 0.845345 1.25003C0.800043 1.24946 0.75509 1.25802 0.713169 1.2752C0.671247 1.29238 0.633216 1.31783 0.601345 1.35003C0.536318 1.41537 0.499873 1.50384 0.500012 1.59603V12.5127C0.499276 12.6025 0.533763 12.689 0.596076 12.7537C0.65839 12.8184 0.743568 12.8561 0.833345 12.8587C6.36201 12.9334 8.00001 14.75 8.00001 14.75Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.99983 7.45333C4.86533 7.07175 3.68706 6.83542 2.49316 6.75"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.99983 10.2502C4.86533 9.86862 3.68706 9.63229 2.49316 9.54688"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 7.45333C11.1345 7.07175 12.3128 6.83542 13.5067 6.75"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10.2502C11.1345 9.86862 12.3128 9.63229 13.5067 9.54688"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 14.75V3.14136C8 3.14136 9.63667 1.32336 15.1547 1.25003C15.2 1.24946 15.2449 1.25802 15.2868 1.2752C15.3288 1.29238 15.3668 1.31783 15.3987 1.35003C15.4637 1.41537 15.5001 1.50384 15.5 1.59603V12.5127C15.5007 12.6025 15.4662 12.689 15.4039 12.7537C15.3416 12.8184 15.2564 12.8561 15.1667 12.8587C9.638 12.9334 8 14.75 8 14.75Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2541_12801">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CreditCardIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2541_12792)">
      <path
        d="M12 3.33301H4C2.89543 3.33301 2 4.22844 2 5.33301V10.6663C2 11.7709 2.89543 12.6663 4 12.6663H12C13.1046 12.6663 14 11.7709 14 10.6663V5.33301C14 4.22844 13.1046 3.33301 12 3.33301Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 6.66699H14"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.6665 10H4.67317"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.3335 10H8.66683"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2541_12792">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const TeamIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2541_12776)">
      <path
        d="M4 4.5C5.10457 4.5 6 3.60457 6 2.5C6 1.39543 5.10457 0.5 4 0.5C2.89543 0.5 2 1.39543 2 2.5C2 3.60457 2.89543 4.5 4 4.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.03667 7.25884C6.65271 6.58998 6.05862 6.06663 5.34667 5.77009C4.63472 5.47355 3.84478 5.42042 3.09953 5.61895C2.35429 5.81748 1.69547 6.25655 1.2254 6.86798C0.755326 7.4794 0.500324 8.22894 0.5 9.00017V10.5002H2L2.5 15.5002H5.5L5.716 13.3448"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 15.5C13.7091 15.5 15.5 13.7091 15.5 11.5C15.5 9.29086 13.7091 7.5 11.5 7.5C9.29086 7.5 7.5 9.29086 7.5 11.5C7.5 13.7091 9.29086 15.5 11.5 15.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 13.5V11.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 9.54004C11.4506 9.54004 11.4022 9.5547 11.3611 9.58217C11.32 9.60964 11.288 9.64869 11.269 9.69437C11.2501 9.74005 11.2452 9.79032 11.2548 9.83881C11.2645 9.88731 11.2883 9.93185 11.3232 9.96682C11.3582 10.0018 11.4027 10.0256 11.4512 10.0352C11.4997 10.0449 11.55 10.0399 11.5957 10.021C11.6414 10.0021 11.6804 9.97004 11.7079 9.92893C11.7353 9.88782 11.75 9.83948 11.75 9.79004C11.75 9.72373 11.7237 9.66015 11.6768 9.61326C11.6299 9.56638 11.5663 9.54004 11.5 9.54004"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 4C11.9665 4 12.75 3.2165 12.75 2.25C12.75 1.2835 11.9665 0.5 11 0.5C10.0335 0.5 9.25 1.2835 9.25 2.25C9.25 3.2165 10.0335 4 11 4Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5998 6.00026C13.3612 5.58712 13.0274 5.23687 12.6262 4.97858C12.225 4.72029 11.7681 4.56141 11.2932 4.51512C10.8183 4.46884 10.3392 4.53649 9.89574 4.71246C9.45225 4.88843 9.05712 5.16765 8.74316 5.52692"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2541_12776">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const ProductIcon = () => (
  <svg
    aria-hidden="true"
    height="16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
    className="text-gray-400"
  >
    <path
      d="M13.788 3.119a1.04 1.04 0 01-.31.283L8.5 6.362a.97.97 0 01-.998 0l-4.98-2.96a1.04 1.04 0 01-.309-.283L6.99.279a1.97 1.97 0 012.02 0zm1.194 1.647c.012.09.018.182.018.274v5.92c0 .743-.385 1.43-1.01 1.802l-4.98 2.96a1.97 1.97 0 01-2.02 0l-4.98-2.96A2.092 2.092 0 011 10.96V5.04c0-.092.006-.184.018-.274.147.133.308.252.481.355l4.98 2.96a2.97 2.97 0 003.042 0l4.98-2.96c.173-.103.334-.222.481-.355z"
      fillRule="evenodd"
    ></path>
  </svg>
);

export const DocumentFolderIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3294_22193)">
      <path
        d="M5 4.5H9L12 7.5H19C19.5304 7.5 20.0391 7.71071 20.4142 8.08579C20.7893 8.46086 21 8.96957 21 9.5V17.5C21 18.0304 20.7893 18.5391 20.4142 18.9142C20.0391 19.2893 19.5304 19.5 19 19.5H5C4.46957 19.5 3.96086 19.2893 3.58579 18.9142C3.21071 18.5391 3 18.0304 3 17.5V6.5C3 5.96957 3.21071 5.46086 3.58579 5.08579C3.96086 4.71071 4.46957 4.5 5 4.5"
        stroke="#747C92"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3294_22193">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const TimeOfferIcon = ({ color = "#000000" }) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 126.000000 124.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,124.000000) scale(0.100000,-0.100000)"
      fill={color}
      stroke="none"
    >
      <path
        d="M898 1183 c-10 -2 -18 -9 -18 -14 0 -5 -7 -9 -15 -9 -9 0 -15 -9 -15
-24 0 -17 7 -26 25 -30 14 -4 25 -11 25 -16 0 -6 7 -10 15 -10 9 0 18 -7 21
-15 4 -8 17 -15 30 -15 15 0 24 -6 24 -15 0 -8 6 -15 13 -15 7 0 21 -11 31
-25 20 -27 66 -35 66 -11 0 8 6 17 13 20 10 5 10 7 0 12 -7 3 -13 12 -13 20 0
8 -7 14 -15 14 -8 0 -15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 8 -4
14 -9 13 -5 -2 -20 9 -34 25 -14 15 -35 27 -47 27 -11 0 -20 7 -20 15 0 15 -2
16 -32 8z"
      />
      <path
        d="M320 1170 c0 -5 -7 -10 -15 -10 -8 0 -15 -7 -15 -15 0 -8 -9 -15 -20
-15 -11 0 -37 -18 -59 -40 -21 -22 -44 -40 -50 -40 -6 0 -11 -7 -11 -15 0 -8
-4 -15 -10 -15 -15 0 -12 -19 4 -36 22 -21 56 -17 82 11 13 14 28 25 34 25 5
0 9 6 8 13 -2 7 9 13 25 15 15 2 27 9 27 18 0 8 7 14 15 14 8 0 15 4 15 10 0
5 11 12 25 16 18 4 25 13 25 30 0 15 -6 24 -15 24 -8 0 -15 5 -15 10 0 6 -11
10 -25 10 -14 0 -25 -4 -25 -10z"
      />
      <path
        d="M490 1090 c0 -5 -18 -13 -40 -16 -22 -4 -40 -10 -40 -15 0 -5 -9 -9
-19 -9 -11 0 -26 -7 -35 -15 -8 -8 -19 -15 -25 -15 -6 0 -11 -7 -11 -15 0 -8
-5 -15 -11 -15 -14 0 -99 -85 -99 -99 0 -6 -7 -11 -15 -11 -9 0 -15 -9 -15
-25 0 -14 -4 -25 -9 -25 -5 0 -12 -13 -16 -30 -4 -16 -11 -30 -16 -30 -5 0 -9
-13 -9 -29 0 -45 -12 -91 -21 -85 -5 3 -9 -22 -9 -56 0 -34 4 -59 9 -56 12 8
21 -29 21 -85 0 -32 5 -49 15 -53 8 -3 15 -17 15 -31 0 -14 4 -25 10 -25 5 0
12 -11 16 -25 3 -14 10 -25 15 -25 5 0 9 -7 9 -15 0 -8 7 -15 15 -15 8 0 15
-7 15 -15 0 -8 5 -15 11 -15 13 0 69 -55 69 -68 0 -5 -12 -13 -26 -16 -44 -11
-75 -56 -39 -56 8 0 15 -4 15 -10 0 -6 125 -10 356 -10 295 0 358 2 370 14 16
17 19 36 4 36 -5 0 -10 7 -10 15 0 10 -10 15 -30 15 -20 0 -30 5 -30 15 0 8 7
15 15 15 8 0 15 7 15 15 0 8 5 15 11 15 6 0 24 13 40 29 16 16 29 34 29 40 0
6 7 11 15 11 9 0 15 9 15 25 0 14 7 28 15 31 8 4 15 17 15 30 0 15 6 24 15 24
12 0 15 13 15 55 0 30 5 55 10 55 6 0 10 30 10 70 0 40 -4 70 -10 70 -5 0 -10
20 -10 44 0 26 -6 51 -15 60 -8 8 -15 26 -15 40 0 14 -4 26 -9 26 -5 0 -13 10
-16 22 -4 11 -18 31 -31 43 -13 12 -24 27 -24 34 0 6 -7 11 -15 11 -8 0 -15 7
-15 15 0 8 -7 15 -15 15 -8 0 -15 5 -15 10 0 6 -7 10 -15 10 -8 0 -15 7 -15
15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 9 -10 15 -26 15 -14 0 -32 7 -40 15
-9 8 -29 15 -45 15 -16 0 -29 5 -29 10 0 6 -52 10 -135 10 -82 0 -135 -4 -135
-10z m191 -53 c4 -5 30 -12 58 -15 28 -2 51 -8 51 -12 0 -5 14 -11 30 -15 17
-4 30 -11 30 -16 0 -5 7 -9 15 -9 8 0 15 -7 15 -15 0 -9 9 -15 25 -15 16 0 25
-6 25 -15 0 -8 7 -15 15 -15 8 0 15 -7 15 -15 0 -8 4 -15 10 -15 5 0 12 -11
16 -25 3 -14 12 -25 20 -25 8 0 14 -10 14 -24 0 -13 7 -26 15 -30 9 -3 15 -18
15 -36 0 -16 5 -30 10 -30 6 0 10 -43 10 -110 0 -67 -4 -110 -10 -110 -5 0
-10 -18 -10 -40 0 -29 -4 -40 -15 -40 -9 0 -15 -9 -15 -25 0 -14 -7 -28 -15
-31 -8 -4 -15 -12 -15 -20 0 -8 -5 -14 -11 -14 -14 0 -39 -25 -39 -39 0 -6 -7
-11 -15 -11 -8 0 -15 -7 -15 -15 0 -8 -7 -15 -15 -15 -8 0 -15 -4 -15 -9 0 -5
-13 -12 -30 -16 -16 -4 -30 -13 -30 -21 0 -10 -13 -14 -42 -14 -32 0 -39 -3
-28 -10 10 -7 -31 -10 -125 -10 -94 0 -135 3 -125 10 11 7 5 10 -23 10 -24 0
-40 5 -43 15 -4 8 -17 15 -30 15 -15 0 -24 6 -24 15 0 8 -7 15 -15 15 -8 0
-15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15 5 -15 10 0 6 -7 10 -15 10 -8 0 -15 5
-15 10 0 6 -11 21 -24 33 -14 13 -28 35 -31 50 -4 15 -11 27 -16 27 -5 0 -9
18 -9 40 0 29 -4 40 -15 40 -12 0 -15 17 -15 96 0 71 4 99 15 110 8 9 15 29
15 45 0 16 5 29 10 29 6 0 10 11 10 25 0 14 7 28 15 31 8 4 15 12 15 20 0 8 7
14 15 14 9 0 15 9 15 25 0 16 6 25 15 25 8 0 15 7 15 15 0 8 3 14 8 14 24 -4
42 3 42 16 0 8 7 15 15 15 8 0 15 4 15 9 0 5 14 12 30 16 17 4 30 11 30 16 0
5 20 9 45 9 25 0 50 6 57 14 15 16 110 19 119 3z"
      />
      <path
        d="M600 813 c-1 -117 -10 -153 -39 -153 -12 0 -15 -17 -12 -68 3 -33
-24 -72 -47 -72 -6 0 -13 -11 -16 -25 -4 -14 -11 -25 -16 -25 -6 0 -10 -5 -10
-10 0 -6 -11 -21 -25 -34 -14 -13 -25 -28 -25 -35 0 -6 -7 -11 -15 -11 -20 0
-19 -6 5 -30 21 -21 46 -28 35 -10 -3 6 1 10 9 10 9 0 16 7 16 15 0 8 7 15 15
15 8 0 15 7 15 15 0 8 7 15 15 15 8 0 15 5 15 11 0 14 25 39 39 39 6 0 11 7
11 15 0 8 7 15 15 15 8 0 15 7 15 15 0 11 11 15 41 15 55 0 69 17 69 84 0 43
-3 56 -15 56 -8 0 -15 7 -15 15 0 8 -6 14 -12 12 -10 -1 -14 29 -16 121 l-3
122 -24 0 -25 0 0 -117z"
      />
    </g>
  </svg>
);

export const VCAvatarIcon = () => (
  <svg
    width="186"
    height="213"
    viewBox="0 0 186 213"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1552_8481)">
      <rect
        x="7"
        y="6.5"
        width="166"
        height="194"
        rx="5.5"
        fill="white"
        stroke="#E6E6E6"
      ></rect>
      <ellipse
        stroke="#e6e6e6"
        fill="#e6e6e6"
        cx="63.01689"
        cy="38"
        id="svg_13"
        rx="10"
        ry="10"
      />
      <rect
        x="86"
        y="112"
        width="70"
        height="5"
        rx="2"
        fill="#F2F2F2"
        id="svg_2"
        stroke="null"
      />
      <rect
        id="svg_1"
        fill="#DEDEDE"
        rx="2"
        height="5"
        width="32"
        y="102"
        x="86"
      />
      <rect
        fill="#e6e6e6"
        x="41.8997"
        y="50"
        width="7"
        height="40"
        id="svg_15"
        stroke="#e6e6e6"
        rx="2"
      />
      <rect
        fill="#e6e6e6"
        x="52.33669"
        y="97.40365"
        width="7"
        height="44"
        id="svg_17"
        stroke="#e6e6e6"
        rx="2"
      />
      <rect
        fill="#e6e6e6"
        x="66.61401"
        y="97.40365"
        width="7"
        height="44"
        id="svg_18"
        stroke="#e6e6e6"
        rx="2"
      />
      <rect
        fill="#e6e6e6"
        x="76.87443"
        y="50"
        width="7"
        height="40"
        id="svg_21"
        stroke="#e6e6e6"
        rx="2"
      />
      <rect
        fill="#e6e6e6"
        x="53"
        y="50.71431"
        width="20"
        height="44"
        id="svg_23"
        rx="4"
        stroke="#e6e6e6"
      />
      <rect
        id="svg_3"
        fill="#DEDEDE"
        rx="2"
        height="5"
        width="32"
        y="102"
        x="86"
      />
      <rect
        x="86"
        y="133"
        width="70"
        height="5"
        rx="2"
        fill="#F2F2F2"
        id="svg_4"
        stroke="null"
      />
      <rect
        id="svg_5"
        fill="#DEDEDE"
        rx="2"
        height="5"
        width="32"
        y="123"
        x="86"
      />
      <rect
        id="svg_6"
        fill="#DEDEDE"
        rx="2"
        height="5"
        width="32"
        y="123"
        x="86"
      />
      <rect
        x="86"
        y="154"
        width="70"
        height="5"
        rx="2"
        fill="#F2F2F2"
        id="svg_7"
        stroke="null"
      />
      <rect
        id="svg_8"
        fill="#DEDEDE"
        rx="2"
        height="5"
        width="32"
        y="144"
        x="86"
      />
      <rect
        id="svg_9"
        fill="#DEDEDE"
        rx="2"
        height="5"
        width="32"
        y="144"
        x="86"
      />
      <rect
        x="86"
        y="175"
        width="70"
        height="5"
        rx="2"
        fill="#F2F2F2"
        id="svg_10"
        stroke="null"
      />
      <rect
        id="svg_11"
        fill="#DEDEDE"
        rx="2"
        height="5"
        width="32"
        y="165"
        x="86"
      />
      <rect
        id="svg_12"
        fill="#DEDEDE"
        rx="2"
        height="5"
        width="32"
        y="165"
        x="86"
      />
      <path
        id="svg_14"
        d="m83,66.5"
        opacity="NaN"
        stroke="#000"
        fill="#e6e6e6"
      />
    </g>
  </svg>
);

export const UploadFileIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.224 9.2081L10.5657 16.8664C9.62747 17.8046 8.35499 18.3317 7.02817 18.3317C5.70135 18.3317 4.42887 17.8046 3.49067 16.8664C2.55247 15.9282 2.02539 14.6558 2.02539 13.3289C2.02539 12.0021 2.55247 10.7296 3.49067 9.79144L11.149 2.1331C11.7745 1.50763 12.6228 1.15625 13.5073 1.15625C14.3919 1.15625 15.2402 1.50763 15.8657 2.1331C16.4911 2.75857 16.8425 3.60689 16.8425 4.49144C16.8425 5.37598 16.4911 6.2243 15.8657 6.84977L8.199 14.5081C7.88627 14.8208 7.46211 14.9965 7.01984 14.9965C6.57756 14.9965 6.15341 14.8208 5.84067 14.5081C5.52794 14.1954 5.35224 13.7712 5.35224 13.3289C5.35224 12.8867 5.52794 12.4625 5.84067 12.1498L12.9157 5.0831"
      stroke="#1A1E1D"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EmojiIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.3577 18.3337C14.9601 18.3337 18.6911 14.6027 18.6911 10.0003C18.6911 5.39795 14.9601 1.66699 10.3577 1.66699C5.75537 1.66699 2.02441 5.39795 2.02441 10.0003C2.02441 14.6027 5.75537 18.3337 10.3577 18.3337Z"
      stroke="#1A1E1D"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.02441 11.667C7.02441 11.667 8.27441 13.3337 10.3577 13.3337C12.4411 13.3337 13.6911 11.667 13.6911 11.667"
      stroke="#1A1E1D"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.85742 7.5H7.86742"
      stroke="#1A1E1D"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8574 7.5H12.8674"
      stroke="#1A1E1D"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DollarSign = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_233_1963)">
      <path
        d="M10.3574 0.833008V19.1663"
        stroke="#1A1E1D"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5241 4.16699H8.27409C7.50054 4.16699 6.75867 4.47428 6.21169 5.02126C5.66471 5.56825 5.35742 6.31011 5.35742 7.08366C5.35742 7.85721 5.66471 8.59907 6.21169 9.14605C6.75867 9.69304 7.50054 10.0003 8.27409 10.0003H12.4408C13.2143 10.0003 13.9562 10.3076 14.5032 10.8546C15.0501 11.4016 15.3574 12.1434 15.3574 12.917C15.3574 13.6905 15.0501 14.4324 14.5032 14.9794C13.9562 15.5264 13.2143 15.8337 12.4408 15.8337H5.35742"
        stroke="#1A1E1D"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_233_1963">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.357422)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const NoDataIcon = ({ size = 146 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 146 146"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect opacity="0.8" width="146" height="146" rx="73" fill="#F4F6F5" />
    <path
      d="M104.5 59V101.5C104.5 103.157 103.157 104.5 101.5 104.5H44.5C42.8431 104.5 41.5 103.157 41.5 101.5V59"
      fill="white"
    />
    <path
      d="M104.5 59V101.5C104.5 103.157 103.157 104.5 101.5 104.5H44.5C42.8431 104.5 41.5 103.157 41.5 101.5V59"
      stroke="#CCD7D2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M108.5 41.5H37.5C35.8431 41.5 34.5 42.8431 34.5 44.5V56C34.5 57.6569 35.8431 59 37.5 59H108.5C110.157 59 111.5 57.6569 111.5 56V44.5C111.5 42.8431 110.157 41.5 108.5 41.5Z"
      fill="white"
      stroke="#CCD7D2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M66 73H80"
      stroke="#CCD7D2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SideBarIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6667 2H3.33333C2.59695 2 2 2.59695 2 3.33333V12.6667C2 13.403 2.59695 14 3.33333 14H12.6667C13.403 14 14 13.403 14 12.6667V3.33333C14 2.59695 13.403 2 12.6667 2Z"
      stroke="black"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 2V14"
      stroke="black"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EditActionIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_253_3269)">
      <path
        d="M11.3335 1.99955C11.5086 1.82445 11.7165 1.68556 11.9452 1.5908C12.174 1.49604 12.4192 1.44727 12.6668 1.44727C12.9145 1.44727 13.1597 1.49604 13.3884 1.5908C13.6172 1.68556 13.8251 1.82445 14.0002 1.99955C14.1753 2.17465 14.3142 2.38252 14.4089 2.61129C14.5037 2.84006 14.5524 3.08526 14.5524 3.33288C14.5524 3.58051 14.5037 3.8257 14.4089 4.05448C14.3142 4.28325 14.1753 4.49112 14.0002 4.66622L5.00016 13.6662L1.3335 14.6662L2.3335 10.9996L11.3335 1.99955Z"
        stroke="#242827"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_253_3269">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CancelActionIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 3L3 13"
      stroke="#22281E"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 3L13 13"
      stroke="#22281E"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ProfileIcon = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="36" height="36" rx="10" fill="#EDEEEE" />
    <path
      d="M26 26.9993V25.2098C26 24.2606 25.5505 23.3503 24.7503 22.6791C23.9502 22.0079 22.8649 21.6309 21.7333 21.6309H14.2667C13.1351 21.6309 12.0498 22.0079 11.2497 22.6791C10.4495 23.3503 10 24.2606 10 25.2098V26.9993"
      stroke="#044737"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 18.0526C20.2091 18.0526 22 16.25 22 14.0263C22 11.8026 20.2091 10 18 10C15.7909 10 14 11.8026 14 14.0263C14 16.25 15.7909 18.0526 18 18.0526Z"
      stroke="#044737"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8333 3.33301H4.16667C3.24619 3.33301 2.5 4.0792 2.5 4.99967V16.6663C2.5 17.5868 3.24619 18.333 4.16667 18.333H15.8333C16.7538 18.333 17.5 17.5868 17.5 16.6663V4.99967C17.5 4.0792 16.7538 3.33301 15.8333 3.33301Z"
      stroke="#242827"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.333 1.66699V5.00033"
      stroke="#242827"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66699 1.66699V5.00033"
      stroke="#242827"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 8.33301H17.5"
      stroke="#242827"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RightArrowIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.16699 10H15.8337"
      stroke="black"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 4.16699L15.8333 10.0003L10 15.8337"
      stroke="black"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PhoneCallIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_511_1193)">
      <path
        d="M18.3332 14.1004V16.6004C18.3341 16.8325 18.2866 17.0622 18.1936 17.2749C18.1006 17.4875 17.9643 17.6784 17.7933 17.8353C17.6222 17.9922 17.4203 18.1116 17.2005 18.186C16.9806 18.2603 16.7477 18.288 16.5165 18.2671C13.9522 17.9884 11.489 17.1122 9.32486 15.7087C7.31139 14.4293 5.60431 12.7222 4.32486 10.7087C2.91651 8.53474 2.04007 6.05957 1.76653 3.48374C1.7457 3.2533 1.77309 3.02104 1.84695 2.80176C1.9208 2.58248 2.03951 2.38098 2.1955 2.21009C2.3515 2.0392 2.54137 1.90266 2.75302 1.80917C2.96468 1.71569 3.19348 1.66729 3.42486 1.66707H5.92486C6.32928 1.66309 6.72136 1.80631 7.028 2.07002C7.33464 2.33373 7.53493 2.69995 7.59153 3.10041C7.69705 3.90046 7.89274 4.68601 8.17486 5.44207C8.28698 5.74034 8.31125 6.0645 8.24478 6.37614C8.17832 6.68778 8.02392 6.97383 7.79986 7.20041L6.74153 8.25874C7.92783 10.345 9.65524 12.0724 11.7415 13.2587L12.7999 12.2004C13.0264 11.9764 13.3125 11.8219 13.6241 11.7555C13.9358 11.689 14.2599 11.7133 14.5582 11.8254C15.3143 12.1075 16.0998 12.3032 16.8999 12.4087C17.3047 12.4658 17.6744 12.6697 17.9386 12.9817C18.2029 13.2936 18.3433 13.6917 18.3332 14.1004Z"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_511_1193">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const StatusChangeIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.333 0.666504L13.9997 3.33317L11.333 5.99984"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 7.3335V6.00016C2 5.29292 2.28095 4.61464 2.78105 4.11454C3.28115 3.61445 3.95942 3.3335 4.66667 3.3335H14"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66667 15.3333L2 12.6667L4.66667 10"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 8.6665V9.99984C14 10.7071 13.719 11.3854 13.219 11.8855C12.7189 12.3856 12.0406 12.6665 11.3333 12.6665H2"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MailActivityIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66634 2.66699H13.333C14.0663 2.66699 14.6663 3.26699 14.6663 4.00033V12.0003C14.6663 12.7337 14.0663 13.3337 13.333 13.3337H2.66634C1.93301 13.3337 1.33301 12.7337 1.33301 12.0003V4.00033C1.33301 3.26699 1.93301 2.66699 2.66634 2.66699Z"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6663 4L7.99967 8.66667L1.33301 4"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarActivityIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6667 2.66699H3.33333C2.59695 2.66699 2 3.26395 2 4.00033V13.3337C2 14.07 2.59695 14.667 3.33333 14.667H12.6667C13.403 14.667 14 14.07 14 13.3337V4.00033C14 3.26395 13.403 2.66699 12.6667 2.66699Z"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.667 1.33301V3.99967"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33301 1.33301V3.99967"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 6.66699H14"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PatientBookingIcon = () => (
  <svg
    width="78"
    height="78"
    viewBox="0 0 78 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="77"
      height="77"
      rx="38.5"
      fill="#F2F3F3"
      stroke="#CED9D9"
    />
    <path
      d="M43.666 28.6665H45.9994C46.6182 28.6665 47.2117 28.9123 47.6493 29.3499C48.0869 29.7875 48.3327 30.381 48.3327 30.9998V47.3332C48.3327 47.952 48.0869 48.5455 47.6493 48.9831C47.2117 49.4207 46.6182 49.6665 45.9994 49.6665H31.9993C31.3805 49.6665 30.787 49.4207 30.3494 48.9831C29.9118 48.5455 29.666 47.952 29.666 47.3332V30.9998C29.666 30.381 29.9118 29.7875 30.3494 29.3499C30.787 28.9123 31.3805 28.6665 31.9993 28.6665H34.3327"
      stroke="#45564D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42.5007 26.3335H35.5007C34.8563 26.3335 34.334 26.8558 34.334 27.5002V29.8335C34.334 30.4778 34.8563 31.0002 35.5007 31.0002H42.5007C43.145 31.0002 43.6673 30.4778 43.6673 29.8335V27.5002C43.6673 26.8558 43.145 26.3335 42.5007 26.3335Z"
      stroke="#45564D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NewPatientIcon = () => (
  <svg
    width="78"
    height="78"
    viewBox="0 0 78 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="77"
      height="77"
      rx="38.5"
      fill="#F2F3F3"
      stroke="#CED9D9"
    />
    <path
      d="M43.666 47.5V45.1667C43.666 43.929 43.1743 42.742 42.2992 41.8668C41.424 40.9917 40.237 40.5 38.9993 40.5H30.8327C29.595 40.5 28.408 40.9917 27.5329 41.8668C26.6577 42.742 26.166 43.929 26.166 45.1667V47.5"
      stroke="#45564D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.9167 35.8333C37.494 35.8333 39.5833 33.744 39.5833 31.1667C39.5833 28.5893 37.494 26.5 34.9167 26.5C32.3393 26.5 30.25 28.5893 30.25 31.1667C30.25 33.744 32.3393 35.8333 34.9167 35.8333Z"
      stroke="#45564D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.334 32.3335V39.3335"
      stroke="#45564D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.834 35.8335H44.834"
      stroke="#45564D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DailyRevenueIcon = () => (
  <svg
    width="78"
    height="78"
    viewBox="0 0 78 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="77"
      height="77"
      rx="38.5"
      fill="#F2F3F3"
      stroke="#CED9D9"
    />
    <path
      d="M39 25.1665V50.8332"
      stroke="#45564D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.8333 29.8335H36.0833C35.0004 29.8335 33.9618 30.2637 33.196 31.0295C32.4302 31.7953 32 32.8339 32 33.9168C32 34.9998 32.4302 36.0384 33.196 36.8042C33.9618 37.57 35.0004 38.0002 36.0833 38.0002H41.9167C42.9996 38.0002 44.0382 38.4304 44.804 39.1961C45.5698 39.9619 46 41.0005 46 42.0835C46 43.1665 45.5698 44.2051 44.804 44.9708C44.0382 45.7366 42.9996 46.1668 41.9167 46.1668H32"
      stroke="#45564D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PrevIconAction = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="13"
      cy="13"
      r="12"
      transform="rotate(-180 13 13)"
      fill="white"
      stroke="#D2D2C6"
    />
    <path
      d="M15 8L10 13L15 18"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NextIconAction = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="13" cy="13" r="12" fill="white" stroke="#D2D2C6" />
    <path
      d="M11 18L16 13L11 8"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DeleteActionIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="1">
      <path
        d="M2 4H3.33333H14"
        stroke="#242827"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6663 4.00016V13.3335C12.6663 13.6871 12.5259 14.0263 12.2758 14.2763C12.0258 14.5264 11.6866 14.6668 11.333 14.6668H4.66634C4.31272 14.6668 3.97358 14.5264 3.72353 14.2763C3.47348 14.0263 3.33301 13.6871 3.33301 13.3335V4.00016M5.33301 4.00016V2.66683C5.33301 2.31321 5.47348 1.97407 5.72353 1.72402C5.97358 1.47397 6.31272 1.3335 6.66634 1.3335H9.33301C9.68663 1.3335 10.0258 1.47397 10.2758 1.72402C10.5259 1.97407 10.6663 2.31321 10.6663 2.66683V4.00016"
        stroke="#242827"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const PlusIconAction = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="31.5"
      y="31.5"
      width="31"
      height="31"
      rx="5.5"
      transform="rotate(-180 31.5 31.5)"
      fill="#F4F6F5"
      stroke="#D9E1DF"
    />
    <g clipPath="url(#clip0_678_18279)">
      <path
        d="M16.0002 22.6663C19.6821 22.6663 22.6668 19.6816 22.6668 15.9997C22.6668 12.3178 19.6821 9.33301 16.0002 9.33301C12.3183 9.33301 9.3335 12.3178 9.3335 15.9997C9.3335 19.6816 12.3183 22.6663 16.0002 22.6663Z"
        stroke="#242827"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 13.333V18.6663"
        stroke="#242827"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3335 16H18.6668"
        stroke="#242827"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_678_18279">
        <rect width="16" height="16" fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </svg>
);

export const EyeToggleIcon = ({ color = "#242827" }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="31.5"
      y="31.5"
      width="31"
      height="31"
      rx="5.5"
      transform="rotate(-180 31.5 31.5)"
      fill="#F4F6F5"
      stroke="#D9E1DF"
    />
    <path
      d="M8.6665 16.0003C8.6665 16.0003 11.3332 10.667 15.9998 10.667C20.6665 10.667 23.3332 16.0003 23.3332 16.0003C23.3332 16.0003 20.6665 21.3337 15.9998 21.3337C11.3332 21.3337 8.6665 16.0003 8.6665 16.0003Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 18C17.1046 18 18 17.1046 18 16C18 14.8954 17.1046 14 16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SendMessageIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="31.5"
      y="31.5"
      width="31"
      height="31"
      rx="5.5"
      transform="rotate(-180 31.5 31.5)"
      fill="#F4F6F5"
      stroke="#D9E1DF"
    />
    <path
      d="M10.6668 10.667H21.3335C22.0668 10.667 22.6668 11.267 22.6668 12.0003V20.0003C22.6668 20.7337 22.0668 21.3337 21.3335 21.3337H10.6668C9.9335 21.3337 9.3335 20.7337 9.3335 20.0003V12.0003C9.3335 11.267 9.9335 10.667 10.6668 10.667Z"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.6668 12L16.0002 16.6667L9.3335 12"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckoutIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="31.5"
      y="31.5"
      width="31"
      height="31"
      rx="5.5"
      transform="rotate(-180 31.5 31.5)"
      fill="#F4F6F5"
      stroke="#D9E1DF"
    />
    <path
      d="M16 8.66699V23.3337"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.3333 11.333H14.3333C13.7145 11.333 13.121 11.5788 12.6834 12.0164C12.2458 12.454 12 13.0475 12 13.6663C12 14.2852 12.2458 14.8787 12.6834 15.3163C13.121 15.7538 13.7145 15.9997 14.3333 15.9997H17.6667C18.2855 15.9997 18.879 16.2455 19.3166 16.6831C19.7542 17.1207 20 17.7142 20 18.333C20 18.9518 19.7542 19.5453 19.3166 19.9829C18.879 20.4205 18.2855 20.6663 17.6667 20.6663H12"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DangerIcon = ({ color }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="31.5"
      y="31.5"
      width="31"
      height="31"
      rx="5.5"
      transform="rotate(-180 31.5 31.5)"
      fill="#F4F6F5"
      stroke="#D9E1DF"
    />
    <path
      d="M14.86 10.5735L9.21335 20.0001C9.09693 20.2018 9.03533 20.4303 9.03467 20.6631C9.03402 20.896 9.09434 21.1249 9.20963 21.3272C9.32492 21.5294 9.49116 21.698 9.69182 21.816C9.89247 21.9341 10.1205 21.9976 10.3533 22.0001H21.6467C21.8795 21.9976 22.1076 21.9341 22.3082 21.816C22.5089 21.698 22.6751 21.5294 22.7904 21.3272C22.9057 21.1249 22.966 20.896 22.9654 20.6631C22.9647 20.4303 22.9031 20.2018 22.7867 20.0001L17.14 10.5735C17.0212 10.3775 16.8538 10.2155 16.6541 10.1031C16.4545 9.9907 16.2292 9.93164 16 9.93164C15.7709 9.93164 15.5456 9.9907 15.3459 10.1031C15.1462 10.2155 14.9789 10.3775 14.86 10.5735Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 14V16.6667"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 19.333H16.0067"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarActionIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="31.5"
      y="31.5"
      width="31"
      height="31"
      rx="5.5"
      transform="rotate(-180 31.5 31.5)"
      fill="#F4F6F5"
      stroke="#D9E1DF"
    />
    <path
      d="M20.6667 10.667H11.3333C10.597 10.667 10 11.2639 10 12.0003V21.3337C10 22.07 10.597 22.667 11.3333 22.667H20.6667C21.403 22.667 22 22.07 22 21.3337V12.0003C22 11.2639 21.403 10.667 20.6667 10.667Z"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.6665 9.33301V11.9997"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3335 9.33301V11.9997"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 14.667H22"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SelectedCheckIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="11.5" fill="#473F3D" stroke="white" />
    <path d="M8 11.5L11 14.5L16.5 9" stroke="white" strokeWidth="2" />
  </svg>
);

export const ConcernIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 10.6667V5.33335C13.9998 5.09953 13.938 4.86989 13.821 4.66746C13.704 4.46503 13.5358 4.29692 13.3333 4.18002L8.66667 1.51335C8.46397 1.39633 8.23405 1.33472 8 1.33472C7.76595 1.33472 7.53603 1.39633 7.33333 1.51335L2.66667 4.18002C2.46418 4.29692 2.29599 4.46503 2.17897 4.66746C2.06196 4.86989 2.00024 5.09953 2 5.33335V10.6667C2.00024 10.9005 2.06196 11.1301 2.17897 11.3326C2.29599 11.535 2.46418 11.7031 2.66667 11.82L7.33333 14.4867C7.53603 14.6037 7.76595 14.6653 8 14.6653C8.23405 14.6653 8.46397 14.6037 8.66667 14.4867L13.3333 11.82C13.5358 11.7031 13.704 11.535 13.821 11.3326C13.938 11.1301 13.9998 10.9005 14 10.6667Z"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.17993 4.64001L7.99993 8.00668L13.8199 4.64001"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 14.72V8"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlusActionIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_943_4321)">
      <path
        d="M7.99967 14.6663C11.6816 14.6663 14.6663 11.6816 14.6663 7.99967C14.6663 4.31778 11.6816 1.33301 7.99967 1.33301C4.31778 1.33301 1.33301 4.31778 1.33301 7.99967C1.33301 11.6816 4.31778 14.6663 7.99967 14.6663Z"
        stroke="#242827"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 5.33301V10.6663"
        stroke="#242827"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33301 8H10.6663"
        stroke="#242827"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_943_4321">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AddItemIcon = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 12.167V23.8337"
      stroke="#473F3D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.167 18H23.8337"
      stroke="#473F3D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="1"
      y="1"
      width="34"
      height="34"
      rx="9"
      stroke="#473F3D"
      strokeWidth="2"
    />
  </svg>
);

export const RemoveItemIcon = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      opacity="0.1"
      x="1"
      y="1"
      width="34"
      height="34"
      rx="9"
      fill="#473F3D"
      stroke="#473F3D"
      strokeWidth="2"
    />
    <path
      d="M12.167 18H23.8337"
      stroke="#473F3D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AddressIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1194_13092)">
      <path
        d="M17.5 8.3335C17.5 14.1668 10 19.1668 10 19.1668C10 19.1668 2.5 14.1668 2.5 8.3335C2.5 6.34437 3.29018 4.43672 4.6967 3.0302C6.10322 1.62367 8.01088 0.833496 10 0.833496C11.9891 0.833496 13.8968 1.62367 15.3033 3.0302C16.7098 4.43672 17.5 6.34437 17.5 8.3335Z"
        stroke="#CBC8C7"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10.8335C11.3807 10.8335 12.5 9.71421 12.5 8.3335C12.5 6.95278 11.3807 5.8335 10 5.8335C8.61929 5.8335 7.5 6.95278 7.5 8.3335C7.5 9.71421 8.61929 10.8335 10 10.8335Z"
        stroke="#CBC8C7"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1194_13092">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PhoneEmployeeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1194_13097)">
      <path
        d="M18.3332 14.0999V16.5999C18.3341 16.832 18.2866 17.0617 18.1936 17.2744C18.1006 17.487 17.9643 17.6779 17.7933 17.8348C17.6222 17.9917 17.4203 18.1112 17.2005 18.1855C16.9806 18.2599 16.7477 18.2875 16.5165 18.2666C13.9522 17.988 11.489 17.1117 9.32486 15.7083C7.31139 14.4288 5.60431 12.7217 4.32486 10.7083C2.91651 8.53426 2.04007 6.05908 1.76653 3.48325C1.7457 3.25281 1.77309 3.02055 1.84695 2.80127C1.9208 2.58199 2.03951 2.38049 2.1955 2.2096C2.3515 2.03871 2.54137 1.90218 2.75302 1.80869C2.96468 1.7152 3.19348 1.6668 3.42486 1.66658H5.92486C6.32928 1.6626 6.72136 1.80582 7.028 2.06953C7.33464 2.33324 7.53493 2.69946 7.59153 3.09992C7.69705 3.89997 7.89274 4.68552 8.17486 5.44158C8.28698 5.73985 8.31125 6.06401 8.24478 6.37565C8.17832 6.68729 8.02392 6.97334 7.79986 7.19992L6.74153 8.25825C7.92783 10.3445 9.65524 12.072 11.7415 13.2583L12.7999 12.1999C13.0264 11.9759 13.3125 11.8215 13.6241 11.755C13.9358 11.6885 14.2599 11.7128 14.5582 11.8249C15.3143 12.107 16.0998 12.3027 16.8999 12.4083C17.3047 12.4654 17.6744 12.6693 17.9386 12.9812C18.2029 13.2931 18.3433 13.6912 18.3332 14.0999Z"
        stroke="#CBC8C7"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1194_13097">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const EmailEmployeeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33366 3.3335H16.667C17.5837 3.3335 18.3337 4.0835 18.3337 5.00016V15.0002C18.3337 15.9168 17.5837 16.6668 16.667 16.6668H3.33366C2.41699 16.6668 1.66699 15.9168 1.66699 15.0002V5.00016C1.66699 4.0835 2.41699 3.3335 3.33366 3.3335Z"
      stroke="#CBC8C7"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3337 5L10.0003 10.8333L1.66699 5"
      stroke="#CBC8C7"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MemberShipBoxIcon = () => (
  <svg
    width="195"
    height="195"
    viewBox="0 0 195 195"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M170.625 130V64.9999C170.622 62.1503 169.87 59.3515 168.444 56.8844C167.018 54.4172 164.968 52.3685 162.5 50.9437L105.625 18.4437C103.155 17.0175 100.352 16.2666 97.5 16.2666C94.6475 16.2666 91.8453 17.0175 89.375 18.4437L32.5 50.9437C30.0321 52.3685 27.9823 54.4172 26.5562 56.8844C25.1302 59.3515 24.3779 62.1503 24.375 64.9999V130C24.3779 132.85 25.1302 135.648 26.5562 138.115C27.9823 140.583 30.0321 142.631 32.5 144.056L89.375 176.556C91.8453 177.982 94.6475 178.733 97.5 178.733C100.352 178.733 103.155 177.982 105.625 176.556L162.5 144.056C164.968 142.631 167.018 140.583 168.444 138.115C169.87 135.648 170.622 132.85 170.625 130Z"
      stroke="#3FAA90"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.5688 56.55L97.5001 97.5813L168.431 56.55"
      stroke="#3FAA90"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M97.5 179.4V97.5"
      stroke="#3FAA90"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CompletedStepIcon = () => (
  <svg
    width="98"
    height="98"
    viewBox="0 0 98 98"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="49" cy="49" r="48.5" fill="#E6EDEB" stroke="#044737" />
    <path
      d="M31 49L43.3333 61L68 37"
      stroke="#044334"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MailActionIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="31.5"
      y="31.5"
      width="31"
      height="31"
      rx="5.5"
      transform="rotate(-180 31.5 31.5)"
      stroke="#DDE6E4"
    />
    <path
      d="M10.6663 10.668H21.333C22.0663 10.668 22.6663 11.268 22.6663 12.0013V20.0013C22.6663 20.7346 22.0663 21.3346 21.333 21.3346H10.6663C9.93301 21.3346 9.33301 20.7346 9.33301 20.0013V12.0013C9.33301 11.268 9.93301 10.668 10.6663 10.668Z"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.6663 12L15.9997 16.6667L9.33301 12"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PhoneActionIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="31.5"
      y="31.5"
      width="31"
      height="31"
      rx="5.5"
      transform="rotate(-180 31.5 31.5)"
      stroke="#DDE6E4"
    />
    <g clipPath="url(#clip0_372_22148)">
      <path
        d="M22.6669 19.2807V21.2807C22.6677 21.4664 22.6297 21.6502 22.5553 21.8203C22.4809 21.9904 22.3718 22.1431 22.235 22.2686C22.0982 22.3941 21.9367 22.4897 21.7608 22.5492C21.5849 22.6087 21.3985 22.6308 21.2136 22.614C19.1622 22.3911 17.1916 21.6901 15.4603 20.5674C13.8495 19.5438 12.4838 18.1782 11.4603 16.5674C10.3336 14.8282 9.63244 12.848 9.41361 10.7874C9.39695 10.603 9.41886 10.4172 9.47795 10.2418C9.53703 10.0664 9.63199 9.90518 9.75679 9.76846C9.88159 9.63175 10.0335 9.52252 10.2028 9.44773C10.3721 9.37294 10.5552 9.33422 10.7403 9.33405H12.7403C13.0638 9.33086 13.3775 9.44543 13.6228 9.6564C13.8681 9.86737 14.0283 10.1603 14.0736 10.4807C14.158 11.1208 14.3146 11.7492 14.5403 12.354C14.63 12.5927 14.6494 12.852 14.5962 13.1013C14.543 13.3506 14.4195 13.5795 14.2403 13.7607L13.3936 14.6074C14.3427 16.2764 15.7246 17.6583 17.3936 18.6074L18.2403 17.7607C18.4215 17.5815 18.6504 17.4579 18.8997 17.4048C19.149 17.3516 19.4083 17.371 19.6469 17.4607C20.2518 17.6864 20.8802 17.843 21.5203 17.9274C21.8441 17.9731 22.1399 18.1362 22.3513 18.3857C22.5627 18.6352 22.6751 18.9538 22.6669 19.2807Z"
        stroke="black"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_372_22148">
        <rect width="16" height="16" fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </svg>
);

export const MessageActionIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="31.5"
      y="31.5"
      width="31"
      height="31"
      rx="5.5"
      transform="rotate(-180 31.5 31.5)"
      stroke="#DDE6E4"
    />
    <path
      d="M19.333 9.33203H12.6663C11.93 9.33203 11.333 9.92898 11.333 10.6654V21.332C11.333 22.0684 11.93 22.6654 12.6663 22.6654H19.333C20.0694 22.6654 20.6663 22.0684 20.6663 21.332V10.6654C20.6663 9.92898 20.0694 9.33203 19.333 9.33203Z"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 20H16.0067"
      stroke="#242827"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ScheduleActionIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="31.5"
      y="31.5"
      width="31"
      height="31"
      rx="5.5"
      transform="rotate(-180 31.5 31.5)"
      stroke="#DDE6E4"
    />
    <path
      d="M20.6667 10.666H11.3333C10.597 10.666 10 11.263 10 11.9993V21.3327C10 22.0691 10.597 22.666 11.3333 22.666H20.6667C21.403 22.666 22 22.0691 22 21.3327V11.9993C22 11.263 21.403 10.666 20.6667 10.666Z"
      stroke="#242827"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.666 9.33398V12.0007"
      stroke="#242827"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.334 9.33398V12.0007"
      stroke="#242827"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 14.666H22"
      stroke="#242827"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PriceIcon = () => (
  <svg
    width="10"
    height="16"
    viewBox="0 0 10 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 0C5.53125 0 6 0.46875 6 1V2.125C6.03125 2.125 6.09375 2.15625 6.125 2.15625C6.15625 2.15625 6.15625 2.15625 6.15625 2.15625L7.65625 2.4375C8.21875 2.53125 8.5625 3.0625 8.46875 3.59375C8.375 4.125 7.84375 4.5 7.3125 4.40625L5.8125 4.125C4.84375 3.96875 3.96875 4.09375 3.375 4.3125C2.78125 4.5625 2.53125 4.90625 2.46875 5.1875C2.40625 5.53125 2.46875 5.71875 2.5 5.84375C2.5625 5.96875 2.6875 6.09375 2.90625 6.25C3.40625 6.59375 4.1875 6.8125 5.21875 7.0625L5.3125 7.09375C6.1875 7.34375 7.28125 7.625 8.09375 8.15625C8.53125 8.4375 8.96875 8.84375 9.21875 9.375C9.5 9.9375 9.53125 10.5625 9.4375 11.25C9.21875 12.4375 8.375 13.2188 7.375 13.625C6.9375 13.8125 6.46875 13.9062 6 13.9688V15C6 15.5625 5.53125 16 5 16C4.4375 16 4 15.5625 4 15V13.9375C3.96875 13.9062 3.96875 13.9062 3.9375 13.9062C3.1875 13.8125 1.9375 13.4688 1.09375 13.0938C0.5625 12.875 0.34375 12.2812 0.5625 11.7812C0.8125 11.2812 1.375 11.0312 1.90625 11.2812C2.53125 11.5625 3.625 11.8438 4.25 11.9375C5.25 12.0938 6.0625 12 6.625 11.7812C7.15625 11.5625 7.375 11.25 7.46875 10.875C7.5 10.5312 7.46875 10.3438 7.40625 10.25C7.34375 10.125 7.25 9.96875 7 9.8125C6.5 9.5 5.71875 9.28125 4.6875 9L4.59375 8.96875C3.71875 8.75 2.625 8.4375 1.8125 7.90625C1.375 7.625 0.9375 7.21875 0.6875 6.6875C0.4375 6.125 0.375 5.5 0.5 4.84375C0.71875 3.625 1.625 2.875 2.625 2.46875C3.0625 2.28125 3.5 2.1875 4 2.125V1C4 0.46875 4.4375 0 5 0Z"
      fill="#8F9BB7"
    />
  </svg>
);

export const MemberShipUsersIcon = () => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5 0C5.375 0 6.1875 0.5 6.65625 1.25C7.09375 2.03125 7.09375 3 6.65625 3.75C6.1875 4.53125 5.375 5 4.5 5C3.59375 5 2.78125 4.53125 2.3125 3.75C1.875 3 1.875 2.03125 2.3125 1.25C2.78125 0.5 3.59375 0 4.5 0ZM16 0C16.875 0 17.6875 0.5 18.1562 1.25C18.5938 2.03125 18.5938 3 18.1562 3.75C17.6875 4.53125 16.875 5 16 5C15.0938 5 14.2812 4.53125 13.8125 3.75C13.375 3 13.375 2.03125 13.8125 1.25C14.2812 0.5 15.0938 0 16 0ZM0 9.34375C0 7.5 1.46875 6 3.3125 6H4.65625C5.15625 6 5.625 6.125 6.0625 6.3125C6 6.53125 6 6.78125 6 7C6 8.21875 6.5 9.28125 7.34375 10C7.34375 10 7.34375 10 7.3125 10H0.65625C0.28125 10 0 9.71875 0 9.34375ZM12.6562 10H12.625C13.4688 9.28125 13.9688 8.21875 13.9688 7C13.9688 6.78125 13.9688 6.53125 13.9375 6.3125C14.3438 6.125 14.8125 6 15.3125 6H16.6562C18.5 6 20 7.5 20 9.34375C20 9.71875 19.6875 10 19.3125 10H12.6562ZM7 7C7 5.9375 7.5625 4.96875 8.5 4.40625C9.40625 3.875 10.5625 3.875 11.5 4.40625C12.4062 4.96875 13 5.9375 13 7C13 8.09375 12.4062 9.0625 11.5 9.625C10.5625 10.1562 9.40625 10.1562 8.5 9.625C7.5625 9.0625 7 8.09375 7 7ZM4 15.1875C4 12.875 5.84375 11 8.15625 11H11.8125C14.125 11 16 12.875 16 15.1875C16 15.625 15.625 16 15.1562 16H4.8125C4.375 16 4 15.6562 4 15.1875Z"
      fill="#8F9BB7"
    />
  </svg>
);

export const AssigneeIcon = () => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 7.75C5.74219 7.75 4.59375 7.09375 3.96484 6C3.33594 4.93359 3.33594 3.59375 3.96484 2.5C4.59375 1.43359 5.74219 0.75 7 0.75C8.23047 0.75 9.37891 1.43359 10.0078 2.5C10.6367 3.59375 10.6367 4.93359 10.0078 6C9.37891 7.09375 8.23047 7.75 7 7.75ZM5.74219 9.0625H8.23047C10.9375 9.0625 13.125 11.25 13.125 13.957C13.125 14.3945 12.7422 14.75 12.3047 14.75H1.66797C1.23047 14.75 0.875 14.3945 0.875 13.957C0.875 11.25 3.03516 9.0625 5.74219 9.0625Z"
      fill="#B8C3D6"
    />
  </svg>
);

export const UserGroupIcon = () => (
  <svg
    width="25"
    height="21"
    viewBox="0 0 25 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.75 5.19531C3.75 3.4375 4.6875 1.79688 6.25 0.898438C7.77344 0 9.6875 0 11.25 0.898438C12.7734 1.79688 13.75 3.4375 13.75 5.19531C13.75 6.99219 12.7734 8.63281 11.25 9.53125C9.6875 10.4297 7.77344 10.4297 6.25 9.53125C4.6875 8.63281 3.75 6.99219 3.75 5.19531ZM0 19.0625C0 15.1953 3.08594 12.0703 6.95312 12.0703H10.5078C14.375 12.0703 17.5 15.1953 17.5 19.0625C17.5 19.6875 16.9531 20.1953 16.3281 20.1953H1.13281C0.507812 20.1953 0 19.6875 0 19.0625ZM23.7891 20.1953H18.3984C18.5938 19.8438 18.75 19.4141 18.75 18.9453V18.6328C18.75 16.2891 17.6562 14.1406 16.0156 12.7344C16.0938 12.7344 16.1719 12.6953 16.2891 12.6953H18.6719C22.1484 12.6953 25 15.5469 25 19.0234C25 19.6875 24.4531 20.1953 23.7891 20.1953ZM16.875 10.1953C15.6641 10.1953 14.5703 9.72656 13.75 8.94531C14.5312 7.89062 15 6.60156 15 5.19531C15 4.17969 14.7266 3.16406 14.2578 2.30469C15 1.79688 15.8984 1.44531 16.875 1.44531C19.2578 1.44531 21.25 3.4375 21.25 5.82031C21.25 8.24219 19.2578 10.1953 16.875 10.1953Z"
      fill="#4C9DAD"
    />
  </svg>
);

export const BullsEyeArrowIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0859 9.57031L14.2969 8.35938L15.4297 8.55469C15.5469 9.02344 15.625 9.49219 15.625 10C15.625 13.125 13.0859 15.625 10 15.625C6.875 15.625 4.375 13.125 4.375 10C4.375 6.91406 6.875 4.375 10 4.375C10.5078 4.375 10.9766 4.45312 11.4453 4.57031L11.6406 5.70312L10.4297 6.91406C10.2734 6.91406 10.1172 6.875 10 6.875C8.24219 6.875 6.875 8.28125 6.875 10C6.875 11.7578 8.24219 13.125 10 13.125C11.7188 13.125 13.125 11.7578 13.125 10C13.125 9.88281 13.0859 9.72656 13.0859 9.57031ZM17.3828 8.75L17.7344 8.39844L19.4141 6.71875C19.8047 7.73438 20 8.86719 20 10C20 15.5469 15.5078 20 10 20C4.45312 20 0 15.5469 0 10C0 4.49219 4.45312 0 10 0C11.1328 0 12.2656 0.195312 13.2812 0.585938L11.6016 2.26562L11.25 2.61719C10.8203 2.53906 10.3906 2.5 10 2.5C5.85938 2.5 2.5 5.85938 2.5 10C2.5 14.1406 5.85938 17.5 10 17.5C14.1406 17.5 17.5 14.1406 17.5 10C17.5 9.57031 17.4609 9.17969 17.3828 8.75ZM14.2578 7.07031L10.625 10.6641C10.2734 11.0547 9.6875 11.0547 9.33594 10.6641C8.94531 10.3125 8.94531 9.72656 9.33594 9.33594L12.9297 5.74219L12.5781 3.78906C12.5391 3.39844 12.6562 2.96875 12.9297 2.69531L14.9219 0.703125C15.2734 0.351562 15.7812 0.46875 15.9766 0.898438L16.875 3.125L19.1016 4.02344C19.5312 4.21875 19.6484 4.72656 19.2969 5.07812L17.3047 7.07031C17.0312 7.34375 16.6406 7.46094 16.2109 7.42188L14.2578 7.07031Z"
      fill="#4CAAD2"
    />
  </svg>
);

export const RotateIcon = () => (
  <svg
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.92188 5.15625C4.25781 5.85938 3.75 6.64062 3.47656 7.5C3.24219 8.16406 2.5 8.51562 1.875 8.28125C1.21094 8.04688 0.859375 7.34375 1.09375 6.67969C1.52344 5.46875 2.22656 4.33594 3.16406 3.39844C6.5625 0 12.0703 0 15.5078 3.35938L17.1484 1.71875C17.3828 1.48438 17.8125 1.40625 18.1641 1.52344C18.5156 1.67969 18.75 2.03125 18.75 2.38281V7.38281C18.75 7.92969 18.3203 8.32031 17.8125 8.32031H17.4609H12.8125C12.4219 8.32031 12.0703 8.125 11.9141 7.77344C11.7969 7.42188 11.875 6.99219 12.1484 6.71875L13.75 5.11719C11.2891 2.73438 7.38281 2.73438 4.92188 5.15625ZM0 11.7578C0 11.25 0.390625 10.8203 0.9375 10.8203H1.21094H1.25H5.9375C6.28906 10.8203 6.64062 11.0547 6.79688 11.4062C6.91406 11.7578 6.83594 12.1875 6.60156 12.4219L4.96094 14.0625C7.42188 16.4453 11.3672 16.4453 13.7891 14.0234C14.4531 13.3203 14.9609 12.5391 15.2734 11.6797C15.4688 11.0156 16.2109 10.6641 16.8359 10.8984C17.5 11.1328 17.8516 11.8359 17.6172 12.5C17.1875 13.7109 16.4844 14.8047 15.5469 15.7812C12.1484 19.1797 6.64062 19.1797 3.20312 15.8203L1.60156 17.4219C1.32812 17.6953 0.898438 17.7734 0.546875 17.6562C0.195312 17.5 0 17.1484 0 16.7578V12.1094V12.0703V11.7578Z"
      fill="#4CADA4"
    />
  </svg>
);

export const SackDollarIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 3.75H7.5L5.625 0.976562C5.35156 0.585938 5.66406 0 6.13281 0H13.8281C14.2969 0 14.6094 0.585938 14.3359 0.976562L12.5 3.75ZM7.5 5H12.5C12.6172 5.11719 12.8125 5.23438 13.0078 5.35156C15.1953 6.75781 20 9.80469 20 16.25C20 18.3203 18.3203 20 16.25 20H3.75C1.67969 20 0 18.3203 0 16.25C0 9.80469 4.76562 6.75781 6.99219 5.35156C7.14844 5.23438 7.34375 5.11719 7.5 5ZM10.7812 8.4375C10.7812 8.00781 10.4297 7.65625 10 7.65625C9.57031 7.65625 9.21875 8.00781 9.21875 8.4375V8.98438C8.90625 9.0625 8.59375 9.17969 8.32031 9.33594C7.77344 9.64844 7.30469 10.2344 7.34375 11.0547C7.34375 11.8359 7.8125 12.3438 8.28125 12.6562C8.71094 12.8906 9.25781 13.0469 9.6875 13.2031H9.76562C10.2344 13.3594 10.5859 13.4766 10.8594 13.6328C11.0547 13.75 11.0547 13.8281 11.0547 13.9453C11.0938 14.1406 11.0156 14.2578 10.8594 14.3359C10.6641 14.4922 10.3516 14.5312 10 14.5312C9.57031 14.5312 9.17969 14.375 8.63281 14.2188C8.55469 14.1797 8.4375 14.1406 8.35938 14.1016C7.92969 13.9844 7.5 14.1797 7.38281 14.6094C7.22656 15 7.46094 15.4688 7.85156 15.5859C7.92969 15.625 8.00781 15.625 8.08594 15.6641C8.4375 15.7812 8.78906 15.8984 9.17969 16.0156V16.5625C9.17969 16.9922 9.53125 17.3438 9.96094 17.3438C10.3906 17.3438 10.7422 16.9922 10.7422 16.5625V16.0547C11.0547 15.9766 11.3672 15.8594 11.6797 15.7031C12.2266 15.3516 12.6562 14.7656 12.6172 13.9453C12.6172 13.125 12.1875 12.6172 11.6797 12.3047C11.2109 12.0312 10.6641 11.8359 10.2344 11.7188H10.1953C9.6875 11.5625 9.33594 11.4453 9.10156 11.2891C8.90625 11.1719 8.86719 11.0938 8.86719 11.0547C8.86719 10.8984 8.94531 10.7812 9.14062 10.6641C9.33594 10.5469 9.64844 10.4688 9.96094 10.4688C10.3516 10.4688 10.7422 10.5859 11.1719 10.7031C11.6016 10.7812 12.0312 10.5469 12.1484 10.1172C12.2656 9.72656 11.9922 9.29688 11.6016 9.17969C11.3281 9.10156 11.0547 9.02344 10.7812 8.98438V8.4375Z"
      fill="#E29B32"
    />
  </svg>
);

export const VoucherTicketIcon = () => (
  <svg
    width="23"
    height="15"
    viewBox="0 0 23 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 0H20C21.3672 0 22.5 1.13281 22.5 2.5V5C22.5 5.35156 22.1875 5.625 21.875 5.74219C21.1328 6.01562 20.625 6.67969 20.625 7.5C20.625 8.32031 21.1328 9.02344 21.875 9.29688C22.1875 9.41406 22.5 9.6875 22.5 10V12.5C22.5 13.9062 21.3672 15 20 15H2.5C1.09375 15 0 13.9062 0 12.5V10C0 9.6875 0.273438 9.41406 0.585938 9.29688C1.32812 9.02344 1.875 8.32031 1.875 7.5C1.875 6.67969 1.32812 6.01562 0.585938 5.74219C0.273438 5.625 0 5.35156 0 5V2.5C0 1.13281 1.09375 0 2.5 0ZM5 4.375C5 4.0625 5.27344 3.75 5.625 3.75H16.875C17.1875 3.75 17.5 4.0625 17.5 4.375V10.625C17.5 10.9766 17.1875 11.25 16.875 11.25H5.625C5.27344 11.25 5 10.9766 5 10.625V4.375ZM3.75 3.75V11.25C3.75 11.9531 4.29688 12.5 5 12.5H17.5C18.1641 12.5 18.75 11.9531 18.75 11.25V3.75C18.75 3.08594 18.1641 2.5 17.5 2.5H5C4.29688 2.5 3.75 3.08594 3.75 3.75Z"
      fill="#9853E1"
    />
  </svg>
);

export const BadgeProcentIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 0C15.9688 0 17.7188 1.14844 18.5938 2.84375C20.3984 2.24219 22.4766 2.67969 23.8984 4.10156C25.3203 5.52344 25.7578 7.60156 25.1562 9.40625C26.8516 10.2812 28 12.0312 28 14C28 16.0234 26.8516 17.7734 25.1562 18.6484C25.7578 20.4531 25.3203 22.4766 23.8984 23.8984C22.4766 25.3203 20.3984 25.7578 18.5938 25.2109C17.7188 26.9062 15.9688 28 14 28C11.9766 28 10.2266 26.9062 9.35156 25.2109C7.54688 25.7578 5.52344 25.3203 4.10156 23.8984C2.67969 22.4766 2.24219 20.4531 2.78906 18.6484C1.09375 17.7734 0 16.0234 0 14C0 12.0312 1.09375 10.2812 2.78906 9.40625C2.24219 7.60156 2.67969 5.52344 4.10156 4.10156C5.52344 2.67969 7.54688 2.24219 9.35156 2.84375C10.2266 1.14844 11.9766 0 14 0ZM10.5 12.25C11.4297 12.25 12.25 11.4844 12.25 10.5C12.25 9.57031 11.4297 8.75 10.5 8.75C9.51562 8.75 8.75 9.57031 8.75 10.5C8.75 11.4844 9.51562 12.25 10.5 12.25ZM19.25 17.5C19.25 16.5703 18.4297 15.75 17.5 15.75C16.5156 15.75 15.75 16.5703 15.75 17.5C15.75 18.4844 16.5156 19.25 17.5 19.25C18.4297 19.25 19.25 18.4844 19.25 17.5ZM18.4297 11.4297C18.9219 10.9375 18.9219 10.1172 18.4297 9.625C17.8828 9.07812 17.0625 9.07812 16.5703 9.625L9.57031 16.5703C9.02344 17.1172 9.02344 17.9375 9.57031 18.4297C10.0625 18.9766 10.8828 18.9766 11.375 18.4297L18.4297 11.4297Z"
      fill="#4C9DAD"
    />
  </svg>
);

export const HourglassIcon = () => (
  <svg
    width="32"
    height="29"
    viewBox="0 0 32 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 1.75C0 0.820312 0.765625 0 1.75 0H3.5H17.5H19.25C20.1797 0 21 0.820312 21 1.75C21 2.73438 20.1797 3.5 19.25 3.5V4.10156C19.25 6.45312 18.3203 8.69531 16.6797 10.3359L12.9609 14L14.9297 15.9688C14.3281 17.2266 14 18.5938 14 20.0156L10.5 16.5156L6.78125 20.2344C5.79688 21.2188 5.25 22.5312 5.25 23.9531V24.5547H15.0391C15.75 25.9219 16.7891 27.125 18.0469 28.0547H17.5H3.5H1.75C0.765625 28.0547 0 27.2344 0 26.3047C0 25.3203 0.765625 24.5547 1.75 24.5547V23.8984C1.75 21.6016 2.625 19.3594 4.26562 17.7188L7.98438 14L4.26562 10.3359C2.625 8.69531 1.75 6.45312 1.75 4.10156V3.5C0.765625 3.5 0 2.73438 0 1.75ZM5.25 3.5V4.10156C5.25 5.52344 5.79688 6.83594 6.78125 7.82031L10.5 11.5391L14.1641 7.82031C15.1484 6.83594 15.75 5.52344 15.75 4.10156V3.5H5.25ZM15.75 20.125C15.75 17.3359 17.2266 14.7656 19.6875 13.3438C22.0938 11.9219 25.1016 11.9219 27.5625 13.3438C29.9688 14.7656 31.5 17.3359 31.5 20.125C31.5 22.9688 29.9688 25.5391 27.5625 26.9609C25.1016 28.3828 22.0938 28.3828 19.6875 26.9609C17.2266 25.5391 15.75 22.9688 15.75 20.125ZM23.625 15.75C23.1328 15.75 22.75 16.1875 22.75 16.625V20.125C22.75 20.6172 23.1328 21 23.625 21H26.25C26.6875 21 27.125 20.6172 27.125 20.125C27.125 19.6875 26.6875 19.25 26.25 19.25H24.5V16.625C24.5 16.1875 24.0625 15.75 23.625 15.75Z"
      fill="#4CAAD2"
    />
  </svg>
);

export const TrophyIcon = () => (
  <svg
    width="27"
    height="24"
    viewBox="0 0 27 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.24935 0H18.7493C19.9681 0 20.9993 1.03125 20.9525 2.29688C20.9056 2.53125 20.9056 2.76562 20.9056 3H25.8743C26.4837 3 26.9993 3.51562 26.9993 4.125C26.9993 8.48438 25.4056 11.4844 23.2962 13.5469C21.2337 15.5625 18.7025 16.5938 16.8275 17.1094C15.7025 17.3906 14.9525 18.3281 14.9525 19.2656C14.9525 20.2031 15.7493 21 16.7337 21H17.9525C18.7962 21 19.4525 21.7031 19.4525 22.5C19.4525 23.3438 18.7962 24 17.9525 24H8.95247C8.1556 24 7.45247 23.3438 7.45247 22.5C7.45247 21.7031 8.1556 21 8.95247 21H10.2181C11.1556 21 11.9525 20.2031 11.9525 19.2656C11.9525 18.3281 11.2493 17.3906 10.1243 17.1094C8.24935 16.5938 5.7181 15.5625 3.6556 13.5469C1.54622 11.4844 -0.000652313 8.48438 -0.000652313 4.125C-0.000652313 3.51562 0.468098 3 1.12435 3H6.04622C6.04622 2.76562 6.04622 2.53125 5.99935 2.29688C5.95247 1.03125 6.98372 0 8.24935 0ZM6.23372 5.25H2.24935C2.48372 8.39062 3.70247 10.5 5.20247 11.9531C6.2806 12.9844 7.49935 13.6875 8.67122 14.2031C7.5931 12.3281 6.6556 9.51562 6.23372 5.25ZM18.2806 14.2031C19.4525 13.6875 20.6712 12.9844 21.7493 11.9531C23.2493 10.5 24.4681 8.39062 24.7025 5.25H20.7181C20.2962 9.51562 19.3587 12.3281 18.2806 14.2031ZM13.8275 4.07812C13.6868 3.79688 13.265 3.79688 13.1243 4.07812L12.2337 5.90625C12.1868 6 12.0931 6.09375 11.9525 6.09375L9.93685 6.375C9.6556 6.42188 9.51497 6.79688 9.74935 7.03125L11.2025 8.4375C11.2962 8.53125 11.3431 8.67188 11.2962 8.76562L10.9681 10.7812C10.9212 11.1094 11.2493 11.3438 11.4837 11.1562L13.3118 10.2188C13.4056 10.1719 13.5462 10.1719 13.64 10.2188L15.4681 11.2031C15.7493 11.3438 16.0306 11.1094 15.9837 10.7812L15.6556 8.76562C15.6556 8.67188 15.6556 8.53125 15.7493 8.4375L17.2025 7.03125C17.4368 6.84375 17.2962 6.42188 17.015 6.42188L14.9993 6.09375C14.8587 6.09375 14.765 6 14.7181 5.90625L13.8275 4.07812Z"
      fill="#4C9DAD"
    />
  </svg>
);

export const StatusCheckIcon = ({ className }) => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="5" cy="5" r="4" fill="currentColor" />
  </svg>
);

export const ActionIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0859 6.83594L6.83594 12.0859C6.50781 12.4414 5.93359 12.4414 5.60547 12.0859C5.25 11.7578 5.25 11.1836 5.60547 10.8555L10.2266 6.20703L5.60547 1.58594C5.25 1.25781 5.25 0.683594 5.60547 0.355469C5.93359 0 6.50781 0 6.83594 0.355469L12.0859 5.60547C12.4414 5.93359 12.4414 6.50781 12.0859 6.83594ZM1.58594 12.0859C1.25781 12.4414 0.683594 12.4414 0.355469 12.0859C0 11.7578 0 11.1836 0.355469 10.8555L4.97656 6.20703L0.355469 1.58594C0 1.25781 0 0.683594 0.355469 0.355469C0.683594 0 1.25781 0 1.58594 0.355469L6.83594 5.60547C7.19141 5.93359 7.19141 6.50781 6.83594 6.83594L1.58594 12.0859Z"
      fill="#8F9BB7"
    />
  </svg>
);

export const BackActionIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.355469 5.60547L5.60547 0.355469C5.93359 0 6.50781 0 6.83594 0.355469C7.19141 0.683594 7.19141 1.25781 6.83594 1.58594L2.21484 6.20703L6.83594 10.8555C7.19141 11.1836 7.19141 11.7578 6.83594 12.0859C6.50781 12.4414 5.93359 12.4414 5.60547 12.0859L0.355469 6.83594C0 6.50781 0 5.93359 0.355469 5.60547ZM10.8555 0.355469C11.1836 0 11.7578 0 12.0859 0.355469C12.4414 0.683594 12.4414 1.25781 12.0859 1.58594L7.46484 6.20703L12.0859 10.8555C12.4414 11.1836 12.4414 11.7578 12.0859 12.0859C11.7578 12.4414 11.1836 12.4414 10.8555 12.0859L5.60547 6.83594C5.25 6.50781 5.25 5.93359 5.60547 5.60547L10.8555 0.355469Z"
      fill="#8F9BB7"
    />
  </svg>
);
